<template>
  <svg
    id="Ebene_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 466.5 427.5"
    style="enable-background: new 0 0 466.5 427.5"
  >
    <g>
      <g id="Background_00000016049047965983202920000007811914014083415186_" class="st0">
        <path
          class="st1"
          d="M482.06-45.83c0,256,0,256,0,512c-256,0-256,0-512,0c0-256,0-256,0-512
			C226.06-45.83,226.06-45.83,482.06-45.83z"
        />

        <path
          class="st1"
          d="M338.56,364.67c0.04,0.41,0.34,0.56,0.5,1c1.73,4.84-0.86,16.18-3,21c-4.4,9.89-9.82,2.85-22.75,9.5
			c-0.34,0.17-1.12,1.05-1.25,1.5c-0.33,0.03-0.67-0.01-1,0c2.23-2.82,1.92-1.77-2.5-2c1.38-2,1.38-2,2.75-4
			c-8.57,0.96-9.91,1.55-18.25-1.5c-3.31-0.99-3.49-0.69-6.5-1c-0.89-0.09-4.12,0.29-4.5-0.25c-0.27-0.38,0.19-6.17,0-7.75
			c1.43-5.62,2.42-11.48,3-17.25c1.83-1.44,3.69-3.36,5.5-4.75c0.17-0.13,1.31-0.23,3.5-2.5c19.77,2.43,28.45-1.65,30.25-1
			C327.13,361.15,333.55,362.08,338.56,364.67z"
        />
      </g>

      <g>
        <g>
          <path
            class="st2"
            d="M122.06,399.67c-0.01,0.33,0,0.67,0,1c0.04,4.45-2.8,8.57,3,10c6.78,1.67,3.79-2.92,5-8.5
				c0.78,0.02,5.88-1.01,6.75-1c30.27,0.22,60.49-0.78,90.75-0.5c-0.4,0.64-2.24,5.49-2.5,6.5c-0.27,1.03-0.16,2.39-1,3.25
				c0.38,0.38,0.38,0.38,0.75,0.75c3.5-2.44,7.79-6.01,11.75-7.5c4.42-1.66,9.75-3.39,14-0.5c-0.85,3.08-0.5,12.5,4,9.5
				c0.76-0.51,0.98-0.77,1.5-1.5c2.42,0.67,2.27-1.45,3.75-2.5c16.59-11.72,30.8-3.79,32.5-4c5.44-0.67-6.22-3.27-4.5-4
				c5.56,1.03,9.47,4.33,10.75,2.5c0.88,3.07,1.45,8.28,1,11.5c-1.24-1.06-2.02,1.74,0,1.5c2.1-0.25,2.58-2.12,4-3
				c8.93-5.54,18.98-9.12,29.5-10c0.75,6.14,1.63,7.01,6.5,10c1.74,1.07,3.65,1.69,5.25,3c0.83,0.23,0.71-0.71,1.25-1.5
				c0.85-1.25,1.07-3.08,1.5-4.5c0.08-0.25,0.62,0.1,1.5-5c2.64-1.42,5.59-1.49,8.5-1.5c-0.47,1.92-2.99,0.02-4.25,1
				c-3.4,2.64,6.27,0.17,14.5,3.5c3.88,1.57,7.99,5.26,10,9c0.83,0.02,1.71-5.64,1.75-6.5c0.23-5.03-1.5-10.34-5.5-13.5
				c9.83,1.15,70.27,0.02,73,8.25c2,6.02-22.43,10.07-26.75,10.75c-40.92,6.43-113.26,6.44-156.5,6.5
				c-64.24,0.09-147.66-0.11-210.5-6.5c-11.85-1.21-29.93-2.88-40.75-6c-3.9-4.81-8.14-3.02-2-9.5c7.42-2.43,15.33-2.91,23-4
				c0.58,3.08,5.31,0.57,7.5,1.5c-4.97,8.87,9.71,13.89,8-1.5C71.06,394.73,99.36,399.7,122.06,399.67z"
          />

          <path
            class="st3"
            d="M10.56,400.67c-6.14,6.48-1.9,4.69,2,9.5C3.47,407.55-2.41,404.91,10.56,400.67z"
          />

          <path
            class="st4"
            d="M49.06,396.67c1.71,15.39-12.97,10.37-8,1.5C42.4,395.77,46.65,396.88,49.06,396.67z"
          />

          <path
            class="st5"
            d="M127.06,401.67c-0.2,2.64,0.3,8-2,9c-5.8-1.43-2.96-5.55-3-10C123.54,401.18,125.52,401.5,127.06,401.67z"
          />

          <path
            class="st4"
            d="M130.06,402.17c-1.21,5.58,1.78,10.17-5,8.5c2.3-1,1.8-6.36,2-9C128.26,401.8,129.9,402.16,130.06,402.17z"
          />

          <path
            class="st3"
            d="M299.56,414.67c-0.01,0.07,0.6-0.18,0,1.5C297.53,416.4,298.31,413.61,299.56,414.67z"
          />
        </g>

        <g>
          <path
            class="st6"
            d="M400.56,186.17c0-0.75,0-0.75,0-1.5c2.46-4.16,3.1-14.05,2.5-18.75c-0.66-5.19-3.65-7.56-4.5-12.25
				C403.45,162.79,410.02,169.56,400.56,186.17z"
          />

          <path
            class="st7"
            d="M398.06,152.67c-0.19-0.36-0.32-0.64-0.5-1c3.9-6.11,0.47-13.54,3-20
				C401.67,138.81,401.67,146.26,398.06,152.67z"
          />

          <path
            class="st8"
            d="M277.56,84.67c-0.1,0.03,0.26,0.75-2,0.5c0.03-0.01-0.2-0.34,0.5-0.5
				C276.45,84.58,277.07,84.66,277.56,84.67z"
          />

          <path
            class="st9"
            d="M216.06,284.67c1.09,7.21,2.11,11.73,5,18.5c-0.67,3.8-3.75-0.06-5.25,3c-1.3-6.59,3.21-11.72-5.25-6.5
				c-1.73-0.61-2.09-0.61-3.5-1c0.02-0.33-0.01-0.67,0-1c6.05-0.61,6.2-23.11,5.25-24c-0.44,0.81-1.1,0.66-1.75,1
				c-2.36,1.25-5.94,4.31-6.5,7c-0.5,0-0.5,0-1,0c0.77-1.79,1.31-3.69,2-5.5c4.5-3.12,4.5-3.12,9-6.25
				c-0.21-2.54,0.06-4.74,0.5-7.25C214.32,270.09,214.95,277.33,216.06,284.67z"
          />

          <path
            class="st10"
            d="M234.06,218.17c-0.68,0.78-2.88,3.99-4,5.5c0.29-1.6-0.43-1.42-1.5-2c-0.06-0.03,0.18-0.92-0.25-1
				c-0.31-0.06-0.69,1.01-0.75,1c-0.33-0.04-0.68,0.05-1,0c0.69-2.66-7.78-1.12-8.5-3c5.19,0.05,11.45-0.66,12.75,1
				c2.54-2.01,1.02-1.65,1.25-2c0.04-0.07,1.69,0.06,1.25-1c-1.38-0.25-2.41,0.48-3.75,0.5c0-0.75,0-0.75,0-1.5
				C231.99,215.84,235.1,214.92,234.06,218.17z"
          />

          <path
            class="st11"
            d="M247.06,125.17c-1.02,3.83-2.81,5.67-3,12c-3.87-1.64-1.48-11.09,2-12.5
				C246.56,124.92,246.56,124.92,247.06,125.17z"
          />

          <path
            class="st2"
            d="M308.56,395.67c4.42,0.23,4.73-0.82,2.5,2c-3.37,4.26-5.67,2.37-8,10c-1.99-3.27-1.65-9.67-2.5-12
				C303.21,395.77,305.9,395.53,308.56,395.67z"
          />

          <path
            class="st12"
            d="M308.56,395.67c-2.65-0.14-5.34,0.1-8,0c-0.7-1.91-0.97-2.05-2.25-3.5c-4.33-0.33-4.98-1.92-5.25-2
				c8.34,3.05,9.68,2.46,18.25,1.5C309.93,393.67,309.93,393.67,308.56,395.67z"
          />

          <g>
            <path
              class="st13"
              d="M350.56,381.17c-0.4,3.37-0.74,6.6-0.5,10c0.22,1.54,0.17,2.96,0,4.5c-3.63-0.4-2.87-2.14-6-3.5
					c0.07-0.02-0.29-0.78,1.5-0.25c0.29-0.71-1.06-1.16-1-1.75c0.65-6.63,4.09-15.83,3-23c2.1,0.2,2.66-1.03,4.5-0.25
					C352.7,367.82,349.01,379.04,350.56,381.17z"
            />

            <path
              class="st14"
              d="M355.56,364.67c-3.13,5.06-4.32,10.71-5,16.5c-1.55-2.13,2.15-13.34,1.5-14.25
					c-1.84-0.78-2.4,0.45-4.5,0.25c-0.49-0.05-1,0.03-1.5,0c-0.92-0.18-1.95-3.48-7-1.5c-0.16-0.44-0.46-0.59-0.5-1
					C344.18,363.56,349.97,363.29,355.56,364.67z"
            />

            <path
              class="st15"
              d="M372.06,396.17c-2.84-0.32-6.16-1.37-11.5-1.5c-5.99-0.15-7.63,1.31-10.5,1c0.17-1.54,0.22-2.96,0-4.5
					C352.43,395.19,363.05,391.57,372.06,396.17z"
            />

            <path
              class="st16"
              d="M374.06,397.17c-1.89-0.22-1.89-0.99-2-1C372.27,396.28,372.29,395.77,374.06,397.17z"
            />

            <path
              class="st17"
              d="M340.06,392.17c-3.42,1.84-4.15,10.71-1.5,13.5c-3.8,1.28,0.56,3.86,0.5,4.75
					c-0.03,0.49-3.5-0.42,0.5,2.75c-4.87-2.99-5.75-3.86-6.5-10c-0.02-0.19,0.84-1.13,0.5-3.75c-0.96-1.35-18.83,2.11-25.5,6.25
					c-2.66-3.2,11.17-10.07,17.75-10.5c-1.62-0.5-1.62-0.5-3.25-1c2.29-0.53,4.7-0.55,7-1c5.19,5.07,8.68-1.85,9.75-2
					C340.1,391.75,339.99,392.17,340.06,392.17z"
            />

            <path
              class="st6"
              d="M333.06,403.17c-10.52,0.88-20.57,4.46-29.5,10c-0.61,0.02-0.76-0.68-1-1c2.67-3.53,1.8-4.2,5.5-6.5
					c6.67-4.14,24.54-7.6,25.5-6.25C333.89,402.03,333.03,402.98,333.06,403.17z"
            />

            <path
              class="st6"
              d="M379.56,410.67c-0.04,0.86-0.92,6.52-1.75,6.5c-2.01-3.74-6.12-7.43-10-9c-8.23-3.33-17.9-0.86-14.5-3.5
					c1.26-0.98,3.78,0.92,4.25-1c2.24-0.01,12.16,0.94,13.75,0.5c0.38-0.1,0.25-0.66,0.25-1c1.85,1.26,3.55,2.52,5,4.25
					c0.21,10.34,0.47,3.35,1.25,2.75C378.18,409.88,378.97,410.99,379.56,410.67z"
            />

            <path
              class="st13"
              d="M368.06,401.17c1.87,0.71,1.99,0.97,3.5,2c0,0.34,0.13,0.9-0.25,1c-1.59,0.44-11.51-0.51-13.75-0.5
					c-2.91,0.01-5.86,0.08-8.5,1.5c0.06-0.32-0.53-1.59,0-6.5C355.18,398.79,362.31,398.97,368.06,401.17z"
            />

            <path
              class="st18"
              d="M372.06,396.17c0.11,0.01,0.11,0.78,2,1c4,3.16,5.73,8.47,5.5,13.5c-0.59,0.33-1.37-0.79-1.75-0.5
					c-0.78,0.6-1.04,7.59-1.25-2.75c-1.45-1.73-3.15-2.99-5-4.25c-1.51-1.03-1.63-1.29-3.5-2c2.38-0.5,2.38-0.5,4.75-1
					c0-0.5,0-0.5,0-1c-6.12-2.25-6.12-2.25-12.25-4.5C365.9,394.8,369.22,395.85,372.06,396.17z"
            />

            <path
              class="st12"
              d="M346.06,367.17c-0.66,2.68-6.83,20.19-6.5,21.25c0.37,1.19,3.9,1.21,5,1.75c-0.06,0.59,1.29,1.04,1,1.75
					c-1.79-0.53-1.43,0.23-1.5,0.25c-0.78,0.16-2.02-0.08-3,0c-0.33,0.03-0.67-0.02-1,0c-0.06,0,0.05-0.41-0.75-1
					c-1.07,0.15-4.56,7.07-9.75,2c4.36-0.85,6.24,0.94,6.5-6.5c2.14-4.82,4.73-16.16,3-21C344.1,363.69,345.14,366.99,346.06,367.17
					z"
            />

            <path
              class="st19"
              d="M347.56,367.17c1.09,7.17-2.35,16.37-3,23c-1.1-0.54-4.63-0.56-5-1.75c-0.33-1.06,5.84-18.57,6.5-21.25
					C346.55,367.19,347.06,367.12,347.56,367.17z"
            />

            <path
              class="st20"
              d="M360.56,394.67c6.12,2.25,6.12,2.25,12.25,4.5c0,0.5,0,0.5,0,1c-2.38,0.5-2.38,0.5-4.75,1
					c-5.75-2.19-12.87-2.38-19-2.5c-1.48-0.38,0.86-1.72,1-3C352.93,395.98,354.57,394.52,360.56,394.67z"
            />

            <path
              class="st18"
              d="M308.06,405.67c-3.7,2.3-2.83,2.97-5.5,6.5c-0.43-0.58-1.37,1.6,0.5-4.5c2.33-7.63,4.63-5.74,8-10
					c0.33-0.01,0.67,0.03,1,0c2.43-0.2,7.7-2.85,10.5-3.5c1.62,0.5,1.62,0.5,3.25,1C319.23,395.6,305.39,402.47,308.06,405.67z"
            />

            <g>
              <path
                class="st20"
                d="M344.06,392.17c3.13,1.36,2.37,3.1,6,3.5c-0.14,1.28-2.48,2.62-1,3c-0.53,4.91,0.06,6.18,0,6.5
						c-0.88,5.1-1.42,4.75-1.5,5c-2.52,3.49-0.99-6.88-2-12c-1.02-5.19-1.49,1.52-4-1.75c-1.25-1.63,2.79-1.46-0.5-4.25
						C342.03,392.08,343.28,392.33,344.06,392.17z"
              />

              <path
                class="st20"
                d="M345.56,409.67c0.01,2.61-0.29,5.04,0.5,5c-0.54,0.79-0.42,1.73-1.25,1.5c-1.6-1.31-3.51-1.93-5.25-3
						c-4-3.17-0.53-2.26-0.5-2.75c0.06-0.89-4.3-3.47-0.5-4.75C338.83,405.96,344.54,408.78,345.56,409.67z"
              />

              <path
                class="st13"
                d="M347.56,410.17c-0.43,1.42-0.65,3.25-1.5,4.5c-0.79,0.04-0.49-2.39-0.5-5c-0.01-3.83,0.01-7.67,0-11.5
						C346.56,403.29,345.03,413.66,347.56,410.17z"
              />

              <path
                class="st21"
                d="M341.06,392.17c3.29,2.79-0.75,2.62,0.5,4.25c2.51,3.27,2.98-3.44,4,1.75c0.01,3.83-0.01,7.67,0,11.5
						c-1.02-0.89-6.72-3.71-7-4c-2.65-2.79-1.92-11.66,1.5-13.5C340.39,392.15,340.73,392.19,341.06,392.17z"
              />
            </g>

            <path
              class="st22"
              d="M329.56,393.17c-2.3,0.45-4.71,0.47-7,1c-2.8,0.65-8.07,3.3-10.5,3.5c0.13-0.45,0.91-1.33,1.25-1.5
					c12.93-6.65,18.35,0.39,22.75-9.5C335.8,394.1,333.92,392.32,329.56,393.17z"
            />
          </g>

          <g>
            <path
              class="st23"
              d="M397.06,77.17c-10.71,8.44-18.84-3.58-24.75-5c-7.78-1.87-12.57,0.47-13.25,0.5
					c-5.03,0.24-10.26-1.18-15,2c-14.64-1.38-26.07,5.51-35.5,16c-2.96,3.29-3,3.37-5.5,7c-8.86,12.87-5.05,15.32-11,0
					c0.5-0.5,0.5-0.5,1-1c0.37,1.34,0.9,3.98,2.5,3.5c0.11,0.66-1.1,6.93,1.25,4.5c0.23-0.24,1.66-5.83,1.75-6.5
					c1.93-0.08,1.87-1.7,2-2c1.5-3.47,0.86-4.61,1-5c2.4-6.88,7.2-13.23,9.5-20.25c1.58-2.47,3.39-4.81,5-7.25
					c0.93-1.4,2.05-3.19,3-4.5c0.87-1.2,3.04-3.04,4-4.5c0.25,0.5,0.25,0.5,0.5,1c-0.1,0.13-0.88,2.33-1,2.5
					c-0.5,0.7-2.9,2.09-3,2.25c-0.91,1.44-5.61,9.58-2.25,10.25c1.38,0.27,10.24-7.82,12.25-9c4.7-2.75,2.22-1.22,1,1
					c-0.1,0.18-2.23,1.51-1,3.25c1.7,2.39,13.32-7.63,17.75-10.25c19.77-11.7,13.93-3.09,15-2.5c1.91,1.05,34.79-9.41,32.75,15.25
					C393.27,72.28,388.38,81.66,397.06,77.17z"
            />

            <path
              class="st11"
              d="M397.06,77.17c-8.68,4.49-3.79-4.88-2-8.75c2.04-24.66-30.84-14.2-32.75-15.25c-1.07-0.59,4.77-9.2-15,2.5
					c-4.43,2.62-16.05,12.64-17.75,10.25c-1.23-1.74,0.9-3.07,1-3.25c7.99-2.74,12.9-9.39,19-14.75c-0.85-1.68-18.62,11.34-20,13.75
					c-2.01,1.18-10.87,9.27-12.25,9c-3.36-0.67,1.34-8.81,2.25-10.25c0.1-0.16,2.5-1.55,3-2.25c1.63,1.05,6.84-7.03,11.25-10.5
					c4.88-3.84,12.76-5.32,14.75-12c11.89-5.75,19.69-4.15,20.25-16c0.93,9.45,5.68-4.24-3.75-10c14.07,2.33,19.33,17.97,13,27.75
					c-3.61,5.58-8.31,2.88-12.5,11.5c0.93,1.18,19.56-2.84,29.25,4.25C401.85,58.32,404.59,71.24,397.06,77.17z"
            />

            <path
              class="st24"
              d="M325.06,3.67c2.17,5.87-1.47,3.37-1.75,3.5c-0.46,0.21-0.18,0.97-0.25,1c-3.33,1.4-6.39,1.58-10.75,4.5
					c-11.67,7.82-18.73,26.07-20.25,39.5c-4.79-1.03-0.46,22.84-5.5,21c-1.08-20.67,5.76-50.8,23.25-64
					C314.21,5.84,319.38,3,325.06,3.67z"
            />

            <path
              class="st11"
              d="M292.06,52.17c-0.35,3.14-0.15,6.34,0,9.5c0.2,4.26,0.78,19.16,6.5,16.5c-0.51,5.76,0.62,15.13,0,20
					c-0.09,0.67-1.52,6.26-1.75,6.5c-2.35,2.43-1.14-3.84-1.25-4.5c-0.8-4.71-4.98-15.92-5.5-27.25c0.07,7.82,0.9,16.19,3,23.75
					c-0.5,0.5-0.5,0.5-1,1c-2.26-5.81-3.44-8.77-4.5-15c-0.56-3.31-0.82-6.15-1-9.5C291.6,75,287.27,51.13,292.06,52.17z"
            />

            <path
              class="st25"
              d="M359.06,72.67c-0.66,2.68,6.64,1.46,12.25,4c9.53,4.31,10.29,16.35,1.75,14
					c-4.84-4.04-10.39-7.71-16.5-9.5c5.15-0.79-6.36-5.92-12.5-6.5C348.79,71.49,354.03,72.91,359.06,72.67z"
            />

            <path
              class="st26"
              d="M332.06,23.17c-9.24,7.49-0.34-4.22-2.5-11.25c-0.39-1.28-2.93-2.2-4-2.75c-0.12-0.06-0.11-1.36-2.5-1
					c0.07-0.03-0.21-0.79,0.25-1c0.28-0.13,3.92,2.37,1.75-3.5C335.46,4.88,336.99,15.54,332.06,23.17z"
            />

            <path
              class="st11"
              d="M329.56,27.67c-1.07,1.61-2.29,3.52-3.5,5c-0.51,0.62-0.99,1.38-1.5,2c-0.92,1.11-2.17,2.14-4,4.5
					c-3.96,5.11-11.39,12.56-7.75,15.5c2.2-5.74,5.01-7.59,5.25-8c0.25,0,0.25,0,0.5,0c-1.21,2.06-1.87,4.39-3,6.5
					c-1.7,3.16-3.35,6.31-5,9.5c-3.5,2.39-3.55,2.12-3.25,6.5c0.83-2.13,2.21-4,3.25-6c2.75,0.25,2.75,0.25,5.5,0.5
					c-1.61,2.44-3.42,4.78-5,7.25c-2.3,7.02-7.1,13.37-9.5,20.25c-2.89-1.89-2.04,4.09-1,5c-0.13,0.3-0.07,1.92-2,2
					c0.62-4.87-0.51-14.24,0-20c0.11-1.26,3.16-16.64,3.5-17.75c4.97-16.08,17.28-20.12,26.25-32.75
					C329.53,27,329.51,27.71,329.56,27.67z"
            />

            <path
              class="st27"
              d="M323.06,8.17c2.39-0.36,2.38,0.94,2.5,1c-24.26,9.32-29.01,29.67-32.5,53.25c-0.5-0.38-0.5-0.38-1-0.75
					c-0.15-3.16-0.35-6.36,0-9.5c1.52-13.43,8.58-31.68,20.25-39.5C316.66,9.75,319.72,9.57,323.06,8.17z"
            />

            <path
              class="st28"
              d="M348.56,35.67c-1.99,6.68-9.87,8.16-14.75,12c-4.41,3.47-9.62,11.55-11.25,10.5c0.12-0.17,0.9-2.37,1-2.5
					c1.45-1.87,3-3.67,4.5-5.5c2.92-2.2,5.09-5.3,8-7.5C339.02,40.42,345.06,37.36,348.56,35.67z"
            />

            <path
              class="st11"
              d="M317.56,55.67c0.42,0.8,1.21,2.6,1.5,3.5c-0.95,1.31-2.07,3.1-3,4.5c-2.75-0.25-2.75-0.25-5.5-0.5
					c0.07-0.13-0.07-0.37,0-0.5c1.65-3.19,3.3-6.34,5-9.5C317.32,53.68,316.89,54.38,317.56,55.67z"
            />

            <path
              class="st24"
              d="M343.06,20.67c-3.28,1.81-12.28,9.27-17,12c1.21-1.48,2.43-3.39,3.5-5
					C332.69,25.15,344.32,17.09,343.06,20.67z"
            />

            <path
              class="st11"
              d="M323.06,54.67c-0.96,1.46-3.13,3.3-4,4.5c-0.29-0.9-1.08-2.7-1.5-3.5c3.62-2.5,3.62-2.5,7.25-5
					C325.84,51.17,323.38,54.17,323.06,54.67z"
            />

            <g>
              <path
                class="st24"
                d="M332.06,23.17c9.58-7.76,19.67-15.71,33-13.5c9.43,5.76,4.68,19.45,3.75,10
						c-0.56,11.85-8.36,10.25-20.25,16c-3.5,1.69-9.54,4.75-12.5,7c-2.05-2.21-10.72,6.74-8,7.5c-1.5,1.83-3.05,3.63-4.5,5.5
						c-0.25-0.5-0.25-0.5-0.5-1c0.32-0.49,2.79-3.49,1.75-4c-3.62,2.5-3.62,2.5-7.25,5c-0.67-1.29-0.23-1.99-2-2.5
						c1.13-2.11,1.79-4.44,3-6.5c1.8-3.07,3.8-6.74,6-9.5c7.02-8.8,20.3-16.78,31.25-19.5c0.74-0.18,13.55-1.04,7.5-3
						c-3.77-1.22-16.4,3.87-20.25,6c1.26-3.57-10.37,4.48-13.5,7c-0.05,0.04-0.03-0.67-1.25,0c-8.97,12.63-21.28,16.67-26.25,32.75
						c-0.34,1.11-3.39,16.49-3.5,17.75c-5.72,2.66-6.3-12.24-6.5-16.5c0.5,0.38,0.5,0.38,1,0.75c3.49-23.58,8.24-43.93,32.5-53.25
						c1.07,0.55,3.61,1.47,4,2.75C331.71,18.94,322.81,30.65,332.06,23.17z"
              />

              <path
                class="st27"
                d="M324.56,37.17c0-1.25,0-1.25,0-2.5c0.51-0.62,0.99-1.38,1.5-2c4.72-2.73,13.72-10.19,17-12
						c3.85-2.13,16.48-7.22,20.25-6c6.05,1.96-6.76,2.82-7.5,3C344.86,20.39,331.57,28.36,324.56,37.17z"
              />

              <path
                class="st29"
                d="M329.31,41.67c8.2-1.55-5.23,4.5-8,10.5C321.85,49.19,326.62,42.17,329.31,41.67z"
              />

              <path
                class="st26"
                d="M336.06,42.67c-2.91,2.2-5.08,5.3-8,7.5C325.33,49.41,334.01,40.45,336.06,42.67z"
              />
            </g>

            <path
              class="st30"
              d="M324.56,37.17c-2.2,2.76-4.2,6.43-6,9.5c-0.25,0-0.25,0-0.5,0c0.99-1.68,3.27-6.03,2.5-7.5
					c1.83-2.36,3.08-3.39,4-4.5C324.56,35.92,324.56,35.92,324.56,37.17z"
            />

            <path
              class="st24"
              d="M330.56,62.67c1.22-2.22,3.7-3.75-1-1c1.38-2.41,19.15-15.43,20-13.75
					C343.46,53.28,338.54,59.93,330.56,62.67z"
            />

            <path
              class="st25"
              d="M295.56,100.17c-1.6,0.48-2.13-2.16-2.5-3.5c-2.1-7.56-2.93-15.93-3-23.75
					C290.58,84.25,294.76,95.46,295.56,100.17z"
            />

            <path
              class="st23"
              d="M301.56,91.17c-0.14,0.39,0.5,1.53-1,5C299.51,95.25,298.67,89.28,301.56,91.17z"
            />

            <path
              class="st29"
              d="M318.06,46.67c-0.24,0.41-3.05,2.26-5.25,8c-3.64-2.94,3.79-10.39,7.75-15.5
					C321.33,40.64,319.05,44.99,318.06,46.67z"
            />

            <path
              class="st29"
              d="M310.56,62.67c-0.07,0.13,0.07,0.37,0,0.5c-1.04,2-2.42,3.87-3.25,6C307,64.78,307.05,65.06,310.56,62.67z
					"
            />
          </g>

          <g>
            <path
              class="st26"
              d="M361.06,219.67c3.72,0.29,9.79,2.86,13,5c-1.89-0.01-7.24,1.29-9,2c-0.03-0.61-0.58-0.76-1-1
					c-9.68-5.63-22.24,4.01-27,15.25c-9.1,21.48,1.32,40.03,1.5,45.75c-3-4.16-7.87-14.54-9.5-19.25c-1.19-3.44,0.08-7.65-3-6.75
					c0.35-5.11,1.82-10.05,3-15c2.19-3.13,5.95-18.5,20.5-24c0.57-0.22,3.03-0.79,4-1C356.5,220.01,357.56,219.39,361.06,219.67z"
            />

            <path
              class="st27"
              d="M326.06,263.17c-0.76,25.58,13.84,44.43,37.75,52.5c2.42,0.81,6.64,1.07,9.25,2
					c0.36,0.13,1.3-0.43,2.5,1.25c-0.16,0.22-0.55,1.67-0.5,1.75c0.91,1.42-9.92-1.84-11.75-2.5c-9.98-3.61-19.71-9.28-27.25-16.75
					c-2.34-2.32-1.51-4.61-5.5-5c-0.49-1.49-1.33-2.84-2-4.25c-2.52-5.27-3.58-11.73-4-17.5c-0.39-5.34-0.57-11.83,1-17
					C325.51,260.32,325.3,263.14,326.06,263.17z"
            />

            <path
              class="st24"
              d="M365.06,226.67c-1.76,0.71-3.75,2.49-5.5,3.5c-15.84,9.13-17.39,18.74-13,41.5
					c-5.9,7.07-4.19-10.1-9.5-7.5c-2.21-19.75,4.91-38.04,27-38.5C364.47,225.91,365.03,226.06,365.06,226.67z"
            />

            <path
              class="st31"
              d="M364.06,225.67c-22.09,0.46-29.21,18.75-27,38.5c0.85,7.59,2.84,13.19,6,20c0.92,1.97,1.33,3.48,2.5,5.5
					c-1.5,1.25-1.5,1.25-3,2.5c-0.49-0.33-1.01-0.66-1.5-1c-1.25-2-1.25-2-2.5-4c0-0.17,0.01-0.33,0-0.5
					c-0.18-5.72-10.6-24.27-1.5-45.75C341.81,229.68,354.38,220.04,364.06,225.67z"
            />

            <path
              class="st11"
              d="M346.56,271.67c2.05,10.61,8.66,18.18,2.5,17.25c-0.4-3.77-4.13-8.05-6.25-12.75
					c-1.74,2.01,2.59,5.9,0.25,8c-3.16-6.81-5.15-12.41-6-20C342.36,261.57,340.65,278.74,346.56,271.67z"
            />

            <g>
              <path
                class="st11"
                d="M359.56,230.17c-10.82,9.26-11.74,16.95-10.5,30.5c0.19,2.05,0.7,3.99,1,6c0.13,0.88,0.35,1.64,0.5,2.5
						c0.37,2.08,1,3.97,1.5,6c0.26,1.07,0.65,5.55,1.5,8.25c1.33,4.23,5.62,10.39,6,15.5c2.03,3.41,14.12,6.65,13.5,18.75
						c-2.61-0.93-6.83-1.19-9.25-2c-23.91-8.07-38.51-26.92-37.75-52.5c0.02-0.83-0.06-1.67,0-2.5c3.08-0.9,1.81,3.31,3,6.75
						c1.63,4.71,6.5,15.09,9.5,19.25c0.01,0.17,0,0.33,0,0.5c0,0.18-1.43-0.91-1,2.75c0.18,0.49,3.04,0.94,3.5,1.25
						c0.49,0.34,1.01,0.67,1.5,1c12.79,8.64,7.39,5.06,3-2.5c-1.17-2.02-1.58-3.53-2.5-5.5c2.34-2.1-1.99-5.99-0.25-8
						c2.12,4.7,5.85,8.98,6.25,12.75c6.16,0.93-0.45-6.64-2.5-17.25C342.16,248.91,343.71,239.3,359.56,230.17z"
              />

              <path
                class="st32"
                d="M342.56,292.17c1.5-1.25,1.5-1.25,3-2.5C349.94,297.22,355.35,300.81,342.56,292.17z"
              />

              <path
                class="st11"
                d="M338.56,287.17c1.25,2,1.25,2,2.5,4c-0.46-0.31-3.32-0.76-3.5-1.25
						C337.13,286.25,338.55,287.34,338.56,287.17z"
              />

              <path
                class="st23"
                d="M370.81,313.67c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
						c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
						S370.68,313.79,370.81,313.67z"
              />
            </g>
          </g>

          <g>
            <path
              class="st33"
              d="M421.56,298.17c2.25,7.43,4.47,19.64-3.5,24.5c-0.12-0.75-0.12-0.75-0.25-1.5c-1.32,2.65-6,2.97-9.25,0.75
					c9.03,0,5.67-4.5,6-6c0.09-0.43,0.99-0.2,1-0.25c3.97-1.5-2.09,7.04,3.75,3.5c3.13-1.9,2.99-12.16,2.25-15.5
					c-0.75-3.36-5.58-11.04-7.5-14.5c0.75-0.75,0.75-0.75,1.5-1.5C417.85,290.85,419.07,289.94,421.56,298.17z"
            />

            <path
              class="st34"
              d="M385.56,208.67c-0.07,0.31-3.53,4.7,2.5,2.75c0.55,5.13-1.06,11.65,0.5,16c-0.42,0.87-4.21-1.1-5-1.25
					c-0.41-1-0.34-2-0.5-3c-1.66-10.48,1.67-13.17,1-19c0.41,0.22,1.08,0.3,1.5,0.75c-0.17-1.97,0.88-3.32,2-4.75
					c0.18-0.22,1.4-0.83,2-1.5C391.4,200.8,387.01,201.73,385.56,208.67z"
            />

            <g>
              <path
                class="st33"
                d="M455.06,224.17c5.26,5.85,8.49,12.67,4,20c-9.04,3.35-5.93,0.26-10.5-5.25
						c-6.1-7.34-16.35-17.46-26.75-16.25c-1.48,0.17-4.14,2.07-5.25,2.5c-0.46,0.18-1.58,0.32-2,0.5c-3.25-2.12-3.25-2.12-6.5-4.25
						c3.75-2.62,3.75-2.62,7.5-5.25c10.32,0.55,20.25,0.7,29.25,6.5c7.05,4.54,11.28,12.78,10.5,8.5c2.18-0.01,3.26,19.99,4.75,8.25
						c0.51-4.02-1.73-7-2.5-9c-0.02-0.05,0.74-0.46,0.5-1C457.39,227.91,455.38,229.14,455.06,224.17z"
              />

              <path
                class="st35"
                d="M416.56,225.17c5.49,2.03,11.92,3.44,14.25,9.5c2.51-0.44,7.46,1.95,9.5,3.5
						c10.07,7.66-0.14,7.77,4.75,12c0.1,0.08,0.41-0.08,0.5,0c-0.31,3.12,4.94,5.78,6,7.75c4.63,8.61-5.09-3.1-8-5.25
						c-1.96-1.45-4.3-3.02-6.5-4c-2.84-2.11,1.71-2.21,0-5.25c-0.39-0.7-10.85-8.36-13.25-8.75c-8.77-1.42-14.74,5.34-15.5,5
						c-0.66-2.1-3.2-7.74-3.25-9c3.33-0.89,6.41-3.63,9.5-5C414.97,225.48,416.09,225.34,416.56,225.17z"
              />

              <path
                class="st35"
                d="M459.06,244.17c-4.72,7.7-11.89,2.26-14,6c-4.89-4.23,5.32-4.34-4.75-12c-2.04-1.55-6.99-3.94-9.5-3.5
						c-2.33-6.06-8.76-7.47-14.25-9.5c1.11-0.43,3.77-2.33,5.25-2.5c10.4-1.21,20.65,8.91,26.75,16.25
						C453.13,244.42,450.01,247.51,459.06,244.17z"
              />

              <path
                class="st36"
                d="M454.56,223.67c0.17,0.17,0.31,0.29,0.5,0.5c0.33,4.97,2.33,3.75,3,5.25c0.24,0.54-0.52,0.95-0.5,1
						c0.77,2,3.01,4.98,2.5,9c-1.49,11.74-2.57-8.26-4.75-8.25c0.78,4.28-3.45-3.96-10.5-8.5c-9-5.8-18.93-5.95-29.25-6.5
						c13.63-3.18,30.09-0.92,38.75,10.5C454.43,225.17,454.43,225.17,454.56,223.67z"
              />

              <path
                class="st37"
                d="M405.06,230.67c0.05,1.26,2.59,6.9,3.25,9c0.76,0.34,6.73-6.42,15.5-5c2.4,0.39,12.86,8.05,13.25,8.75
						c1.71,3.04-2.84,3.14,0,5.25c-9.68-4.31-19.9-5.39-29.5-0.5c-0.54-0.83-0.9-0.4-1-0.5c-0.64-0.67-1-1.27-2-1.5
						c-0.15-1.72-4.77-7.64-5.5-10c-0.3-0.97-0.91-5.57-1-7c1.27-0.14,1.84,0.35,3-1.25c0.5-3.38,0.5-3.38,1-6.75
						c0.12-0.1,0.96-0.46,1-0.5C411.14,223.11,404.73,222.59,405.06,230.67z"
              />
            </g>

            <path
              class="st38"
              d="M395.06,269.67c0.05,0.4,0.34,0.6,0.5,1c-3.73,2.03,0.86,5.38,1,5.75c0.55,1.46,0.42,6.9,3,5.25
					c5.16,9.02,2.52-0.91,8-1c1.31,4.72,2.95,8.91,4.5,13.5c0.59,1.73,1.39,3.28,2,5c-1.72-1-3.56,1.64-4.25,2
					c-0.25,0.13-0.06-0.97-4.75,2c-6.7-1.21-7.53-15.07-8.5-16.75c-0.27-0.47-1.05-0.19-1.5-0.25c0.25-4.67-1.4-5.7-1.5-6
					c-1.27-3.74-4.31-9.72-7-12.5c0.25-0.25,0.25-0.25,0.5-0.5C389.4,269.23,392.08,269.52,395.06,269.67z"
            />

            <path
              class="st33"
              d="M387.06,267.17c-0.25,0.25-0.25,0.25-0.5,0.5c-9.22-9.52,4.24,11.93,5,12.75c1.1,1.18,0.64,0.47,2-0.25
					c0.1,0.3,1.75,1.33,1.5,6c-0.08,1.51,0.12,2.9-1.25,4c-1.26-2.75-7.04,2.01-12.25-1c-1.48-0.85-8.61-11.63-9.5-14.5
					c8.53,1.76,11.13-7.56,10.25-14C384.07,262.09,386.75,266.9,387.06,267.17z"
            />

            <path
              class="st39"
              d="M363.56,273.17c0.18-0.03-0.67-1.94,2.75-0.5c0.16,3,6.01,6.98,6.75,9.25c1.92,5.89-1.67,12.58-11.5,5.25
					c-3.38-2.52-6.63-8.77-9.5-12c-0.5-2.03-1.13-3.92-1.5-6c5.57,2.17,3.15-1.59-0.5-2.5c-0.3-2.01-0.81-3.95-1-6
					C353.56,265.68,357.19,274.24,363.56,273.17z"
            />

            <path
              class="st40"
              d="M406.56,247.67c-1.14,6.12,1.42,12.52,1.5,18.75c0.32,0.72,2.37,1.5,3.5,3.25
					c2.82,4.36,7.8,11.6,5.75,16.5c-3.5-3.25-3.5-3.25-7-6.5c-1.85-0.4,2.05,3.57,5.25,8c-0.75,0.75-0.75,0.75-1.5,1.5
					c-1.98-3.57-4.52-6.94-6.5-10.5c-2.21-3.98-2.24-6.85-4-13c-0.56-1.95-2.79-10-3-10.5c-0.02-1.1,0.95-1.67,1.5-2.5
					c0.99-1.49,2.63-4.94,2.5-6.5C405.55,246.4,405.92,247,406.56,247.67z"
            />

            <path
              class="st38"
              d="M372.06,274.67c0.89,2.87,8.02,13.65,9.5,14.5c-5.28,7.77-11.32,6.74-18.25,1.5
					c-1.52-1.14-3.63-3.27-1.75-3.5c9.83,7.33,13.42,0.64,11.5-5.25c-0.74-2.27-6.59-6.25-6.75-9.25c-3.42-1.44-2.57,0.47-2.75,0.5
					c-1.75-1.12-1.75-1.12-3.5-2.25c2.46-0.92,5.59,1.02,5.75-1.75C367.46,270.49,370.18,274.28,372.06,274.67z"
            />

            <g>
              <path
                class="st41"
                d="M389.56,208.67c-0.95,2.78-0.39,18.84,0,19.75c0.3,0.68,8.03,5.96,9.5,7.75c0.73,2.36,5.35,8.28,5.5,10
						c0.13,1.56-1.51,5.01-2.5,6.5c-0.9-6.38-6.75-10.7-13-11.25c0.84,3.04,3.13,1.88,4.25,2.75c3.04,2.35,5.77,7.42,7.25,11
						c0.21,0.5,2.44,8.55,3,10.5c-3.47-0.08-2.8-6.88-6.25-10c-3.35-0.11-6.38-0.95-9-3c4.1,5.48,14.61,9.07,13,17
						c-2.08-0.07-4.18,0.1-6.25,0c-2.98-0.14-5.66-0.44-8-2.5c-0.3-0.27-2.99-5.07-4.75-6.5c0.88,6.44-1.72,15.76-10.25,14
						c-1.88-0.39-4.6-4.17-6.25-5.5c-0.16,2.77-3.29,0.83-5.75,1.75c1.75,1.12,1.75,1.12,3.5,2.25c-6.37,1.07-9.99-7.48-14.5-12.5
						c-1.24-13.55-0.32-21.24,10.5-30.5c1.75-1.01,3.74-2.79,5.5-3.5c1.76-0.71,7.11-2.01,9-2c0.48,0,8.05,1.23,9.5,1.5
						c0.79,0.15,4.58,2.12,5,1.25c-1.56-4.35,0.05-10.87-0.5-16c-6.03,1.95-2.57-2.44-2.5-2.75
						C387.89,209.41,387.3,209.73,389.56,208.67z"
              />

              <g>
                <path
                  class="st39"
                  d="M360.06,248.67c-0.63-1.12-0.3-1.18-0.5-2c5.66-0.03,13.36,7.99,17.75,7c9.3-2.09,9.32-11.83,2.75-17
							c5.14,1.76,4.64,6.31,8.5,5.25c-3.07,8.66,0.42,7.5-10,13.5c5.86,8.19-1.23-0.73-1.75-0.75c-1.46-0.06,0.47,2.73-1,2.5
							C374.91,257.03,363.38,248.05,360.06,248.67z"
                />

                <path
                  class="st39"
                  d="M402.06,252.67c-0.55,0.83-1.52,1.4-1.5,2.5c-1.48-3.58-4.21-8.65-7.25-11
							c-1.12-0.87-3.41,0.29-4.25-2.75C395.31,241.97,401.16,246.29,402.06,252.67z"
                />

                <path
                  class="st33"
                  d="M359.56,246.67c0.2,0.82-0.13,0.88,0.5,2c1.76,3.1,6.71,5.25,4.25,5.5c-2.23-2.44-10.74-10.76-11.5-5.5
							c-5.26-9.65,1.55-1.29,3.5-2c3.1-11.47,7.62-14.69,2.25-0.25C358.59,246.83,359.54,246.62,359.56,246.67z"
                />

                <path
                  class="st39"
                  d="M380.06,236.67c-4.71-1.62-2.53,0.68-4.25,0.5c-1.73-0.18-6.16-1.97-6.5-2c-0.33-0.03-9.05,2.16-2-1.5
							C369.93,232.3,377.72,234.83,380.06,236.67z"
                />

                <path
                  class="st42"
                  d="M384.31,236.17c3.14-1.38,20.48,1.55-0.25,0.25C384.13,236.31,384.2,236.21,384.31,236.17z"
                />

                <path
                  class="st33"
                  d="M353.81,249.67c0.1-0.03,1.69,1.16,1.75,1.25C358.19,254.52,349.66,250.78,353.81,249.67z"
                />

                <path
                  class="st42"
                  d="M371.81,229.67c1.88-0.27-0.16,2.08-0.75,0.75C371.03,230.37,371.75,229.67,371.81,229.67z"
                />
              </g>
            </g>

            <g>
              <path
                class="st43"
                d="M413.56,261.67c0.18,0.85-0.4,1.99,0.5,2c1.03,1.93,8.37,4.4,13,8c1.14,0.88,2.52,1.97,3.5,3
						c4.6,4.87,9.54,15.2,9.25,22c-1.14-5.35-5.35-14.03-8.75-18.25c-2.65-3.29-11.62-10.63-11.75-8.75
						c-2.54-1.17-6.51-6.21-4.25-1.25c0.81,1.79,17.8,4.44,24,29c1.98-1.15,2.04,3.56,2,5.25c-0.04,1.78,0.22,5.65-2.75,5
						c-1.05-0.23,0.19-3.69-0.25-6.5c-0.42-2.67-1.16-5.43-2-8c-3.6-11.01-10.93-17.84-20.75-23.5c-1.71,1.33,3.77,9.87,4.25,11.75
						c1,3.9-0.99,5.35,3,16.25c-0.5,0.25-0.5,0.25-1,0.5c-2.49-8.22-3.71-7.32-6-10.5c-3.2-4.43-7.1-8.4-5.25-8
						c3.5,3.25,3.5,3.25,7,6.5c2.05-4.9-2.93-12.14-5.75-16.5c2.06,0.36-0.22-8.12-1-11.5
						C412.06,259.92,412.06,259.92,413.56,261.67z"
              />

              <path
                class="st33"
                d="M430.56,274.67c1.42-2.21,1.15,0.8,5-0.5c3.34,4.95,7.86,13.62,8.5,19.5c-2.05,1.23-1.29,8.37-3,9
						c0.04-1.69-0.02-6.4-2-5.25c-6.2-24.56-23.19-27.21-24-29c-2.26-4.96,1.71,0.08,4.25,1.25c0.13-1.88,9.1,5.46,11.75,8.75
						c3.4,4.22,7.61,12.9,8.75,18.25C440.1,289.87,435.15,279.53,430.56,274.67z"
              />

              <path
                class="st40"
                d="M423.06,262.17c2.66,1.52,5.83,3.88,8,6c1.04,1.02,2.09,2.35,3,3.5c-5.56,2.78-5.12-3.46-7,0
						c-4.63-3.6-11.97-6.07-13-8C418.47,260.36,422.26,265.2,423.06,262.17z"
              />

              <path
                class="st44"
                d="M431.06,265.17c1.85,1.63,1.88,2.87,2,3c-1,0-1,0-2,0c-2.17-2.12-5.34-4.48-8-6
						c-2.2-1.26-11.64-5.42-2.25-2.5c1.23,0.38,3.61,2.34,4,2.5c0.21,0.09,0.18-1.4,1-1C426.1,261.31,430.45,264.63,431.06,265.17z"
              />

              <path
                class="st38"
                d="M434.06,271.67c1.7,2.14,1.42,2.38,1.5,2.5c-3.85,1.3-3.58-1.71-5,0.5c-0.98-1.03-2.36-2.12-3.5-3
						C428.94,268.21,428.5,274.44,434.06,271.67z"
              />

              <g>
                <path
                  class="st38"
                  d="M436.06,293.17c-2.11,2.91-2.54,8.28,2,8c0.44,2.81-0.8,6.27,0.25,6.5c2.97,0.65,2.71-3.22,2.75-5
							c1.71-0.63,0.95-7.77,3-9c2.24,20.48-12.14,20.92-16,16.25c-0.43-0.52-5.01-10.92-5.5-12.25c-3.99-10.9-2-12.35-3-16.25
							c-0.48-1.88-5.96-10.42-4.25-11.75C425.12,275.33,432.46,282.15,436.06,293.17z"
                />

                <path
                  class="st38"
                  d="M438.06,301.17c-4.54,0.28-4.11-5.09-2-8C436.9,295.74,437.64,298.49,438.06,301.17z"
                />

                <path
                  class="st43"
                  d="M426.81,282.67c1.49,0.61,6.72,11.26,5.5,11.5C429.56,288.42,429.56,288.42,426.81,282.67z"
                />
              </g>
            </g>

            <path
              class="st36"
              d="M421.56,303.67c0.74,3.34,0.88,13.6-2.25,15.5c-5.84,3.54,0.22-5-3.75-3.5c1.35-7.52,0.83-9.88-1.5-16.5
					c-0.61-1.72-1.41-3.27-2-5c2.88-2.8,5.15,10.14,5.5,10.75C418.05,305.78,420.76,303.61,421.56,303.67z"
            />

            <g>
              <path
                class="st40"
                d="M399.56,326.67c-1.31,1.5-3.07,3.69-5.5,4c-0.2,0.03-3.35-0.41-4-0.5c-0.27-2.04,1.17-1.05,5-5
						c1.57-1.62,0.22-3.08,3.25-2C403.26,324.93,396.44,325.3,399.56,326.67z"
              />

              <path
                class="st43"
                d="M398.56,305.67c-0.5,0.12-0.5,0.12-1,0.25c-0.21,6.04-6.79,19.28-8.5,13.75
						c5.23-5.93,5.75-6.96,7.5-15.75C397.47,303,397.65,304.73,398.56,305.67z"
              />
            </g>

            <g>
              <path
                class="st38"
                d="M414.06,299.17c2.33,6.62,2.85,8.98,1.5,16.5c-0.01,0.05-0.91-0.18-1,0.25c-0.33,1.5,3.03,6-6,6
						c3.25,2.22,7.93,1.9,9.25-0.75c0.12,0.75,0.12,0.75,0.25,1.5c-10.16,6.2-13.4-4.11-14.25-4c-1.55,3.72-1.43,4.78-4.25,8
						c-3.12-1.37,3.7-1.74-1.25-3.5c-3.03-1.08-1.68,0.38-3.25,2c-2.41-2.87-0.99,0.01-2.75,1c-2.83,1.58-5.97-4.04-4.75-6.25
						c0.28-0.52,1.38-0.12,1.5-0.25c1.71,5.53,8.29-7.71,8.5-13.75c0.5-0.12,0.5-0.12,1-0.25c0.9,5.59,1.15,11-0.75,16.5
						c4.29-2.87,0.15-13.88,4.25-9.25c-0.77-1.67-1.83-5.97-2-6.25c3.01-1.23,4.74-3.34,5-3.5c4.69-2.97,4.5-1.87,4.75-2
						C410.49,300.8,412.33,298.17,414.06,299.17z"
              />

              <path
                class="st45"
                d="M400.06,306.67c0.17,0.28,1.23,4.58,2,6.25c-4.1-4.63,0.04,6.38-4.25,9.25c1.9-5.5,1.65-10.91,0.75-16.5
						C398.73,305.85,400.01,306.59,400.06,306.67z"
              />

              <path
                class="st43"
                d="M408.81,302.67c0.26-0.13,2.41,2.48,1,5C409.63,306.89,407.69,303.21,408.81,302.67z"
              />
            </g>

            <g>
              <path
                class="st33"
                d="M442.56,258.17c15.65,12.71,7.74,20.74,14,19c-2.12,4.55-6.82,6.24-11.75,4.5
						c-2.27-0.8-5.54-6.95-11.75-13.5c-0.12-0.13-0.15-1.37-2-3c1.5-2.75,1.5-2.75,3-5.5c1.83,1.42,12.83,11.81,11.5,3.75
						C445.15,260.95,438.57,258.81,442.56,258.17z"
              />

              <path
                class="st41"
                d="M443.56,252.67c2.91,2.15,12.63,13.86,8,5.25c-1.06-1.97-6.31-4.63-6-7.75c5.36,4.78,8.35,8.07,11,15
						c-0.25,2.26,0.47,1.9,0.5,2c1.32,3.88,1.24,6.28-0.5,10c-6.26,1.74,1.65-6.29-14-19c-3.19-2.59-6.33-4.66-10-6.5
						c-1.46-0.73-2.93-1.3-4.5-1.75c5.78-1.27,11.98,4.76,12.75,4.75C442.01,254.66,439.79,253.95,443.56,252.67z"
              />

              <path
                class="st46"
                d="M457.06,267.17c-0.03-0.1-0.75,0.26-0.5-2C456.59,265.26,457.3,264.91,457.06,267.17z"
              />

              <path
                class="st35"
                d="M437.06,248.67c2.2,0.98,4.54,2.55,6.5,4c-3.77,1.28-1.55,1.99-2.75,2c-0.77,0.01-6.97-6.02-12.75-4.75
						c1.57,0.45,3.04,1.02,4.5,1.75c-3.92,0.22-13.33-5.93-14-1.5c-3.25-0.76-5.08-1.31-8.5-0.5c-0.63,0.15-1.51-0.34-1.5,0.5
						c-0.07-0.16-0.94-1.91-1-2C417.15,243.27,427.37,244.36,437.06,248.67z"
              />

              <path
                class="st35"
                d="M418.56,250.17c9.87,2.29,13.02,7.59,15.5,9.5c-1.5,2.75-1.5,2.75-3,5.5c-0.61-0.54-4.95-3.86-5.25-4
						c-0.82-0.4-0.79,1.09-1,1c-0.39-0.16-2.77-2.12-4-2.5c-9.39-2.92,0.05,1.24,2.25,2.5c-0.79,3.03-4.59-1.8-9,1.5
						c-0.9-0.01-0.32-1.15-0.5-2c-0.91-4.19,1.14-9.68-3.5-12C413.48,248.86,415.31,249.41,418.56,250.17z"
              />

              <path
                class="st33"
                d="M432.56,251.67c3.67,1.84,6.81,3.91,10,6.5c-3.98,0.64,2.59,2.78,3,5.25c1.33,8.06-9.67-2.33-11.5-3.75
						c-2.48-1.91-5.63-7.21-15.5-9.5C419.22,245.73,428.64,251.88,432.56,251.67z"
              />
            </g>

            <path
              class="st35"
              d="M407.56,248.17c0.06,0.09,0.93,1.84,1,2c0.32,0.78,1.56,6.12,2,8c0.78,3.38,3.06,11.86,1,11.5
					c-1.13-1.75-3.18-2.53-3.5-3.25c-0.08-6.23-2.64-12.63-1.5-18.75C406.65,247.77,407.01,247.34,407.56,248.17z"
            />

            <path
              class="st33"
              d="M410.06,249.67c4.64,2.32,2.59,7.81,3.5,12c-1.5-1.75-1.5-1.75-3-3.5c-0.44-1.88-1.68-7.22-2-8
					C408.55,249.33,409.43,249.81,410.06,249.67z"
            />

            <path
              class="st41"
              d="M414.06,289.17c1.92,3.46,6.75,11.14,7.5,14.5c-0.79-0.06-3.51,2.11-4,1.25
					c-0.35-0.61-2.62-13.55-5.5-10.75c-1.55-4.59-3.19-8.78-4.5-13.5c-0.32-1.16-0.86-2.01,0-2
					C409.53,282.23,412.08,285.59,414.06,289.17z"
            />

            <g>
              <path
                class="st33"
                d="M443.56,193.67c-6.75-2.42-14.65-3.39-21.75-2c-1.66,0.32-17.81,7-15.5,8.5c1.67,1.09,8.9-8.06,26.5-5.5
						c6.53,0.95,13.44,8.54,17.25,5.5c2.12,5.34,0.74,8.82-4.5,11c-4.76-4.88-15.5-7.11-22.5-6.5c-2.72,0.24-4.59,0.8-7,2
						c-1.99-0.63-0.14-3.84-1.75-4.5c-1.27-0.52-15.01,7.43-16.25,20.5c-0.16,1.7-0.12,4.73,0,6.5c-5.1,0.56-4.45-6.64-4-10
						c0.57-4.25,1.07-4.12,2.5-7.5c2.86,1.04,7.56-7.7,6.5-10c1.77-2.07,1.4-2.4,1.5-2.5c1.07-1.04,2.12-2.03,3.25-3
						c3.34-1.71,13.32-3.95,12.75-5.5C428.65,189.38,436.41,189.42,443.56,193.67z"
              />

              <path
                class="st35"
                d="M445.56,211.17c-3.33,1.39-13.09,2.02-13,2.75c8.47,1.78,15.75,3.39,22,9.75c-0.12,1.5-0.12,1.5-0.25,3
						c-8.66-11.42-25.12-13.68-38.75-10.5c-3.75,2.62-3.75,2.62-7.5,5.25c3.25,2.12,3.25,2.12,6.5,4.25c-3.09,1.37-6.17,4.11-9.5,5
						c-0.32-8.08,6.08-7.55-2-10c2.52-3.04-1.88-2.54,9-10.5c2.3,4.8,2.48,0.82,4.75-0.5c4.53-2.63,7.72-2.4,6.25-5
						C430.06,204.06,440.8,206.29,445.56,211.17z"
              />

              <path
                class="st41"
                d="M443.56,193.67c2.78,1.65,5.24,3.33,6.5,6.5c-3.81,3.04-10.72-4.55-17.25-5.5
						c-17.6-2.56-24.83,6.59-26.5,5.5c-2.31-1.5,13.84-8.18,15.5-8.5C428.9,190.28,436.8,191.24,443.56,193.67z"
              />

              <path
                class="st9"
                d="M391.56,206.67c-1.2,3.29-1.03,6.59-1,10c0.02,2.09-0.55,7.98,0.5,2.5c1.5,0,1.5,0,3,0
						c-0.45,3.36-1.1,10.56,4,10c0.09,1.43,0.7,6.03,1,7c-1.47-1.79-9.2-7.07-9.5-7.75c-0.39-0.91-0.95-16.97,0-19.75
						C389.66,206.65,391.44,206.75,391.56,206.67z"
              />

              <path
                class="st40"
                d="M404.56,199.17c-0.1,0.1,0.27,0.43-1.5,2.5c-3.86,4.51-3.82,3.67-6.5,10c-1.43,3.38-1.93,3.25-2.5,7.5
						c-1.5,0-1.5,0-3,0c0.16-0.85,0.35-1.62,0.5-2.5c0.62-3.73,1-7.48,2.5-11c3.06-2.4,5.76-5.31,9-7.5
						C403.81,198.67,403.81,198.67,404.56,199.17z"
              />

              <path
                class="st41"
                d="M420.56,190.67c0.57,1.55-9.41,3.79-12.75,5.5c-1.13,0.97-2.18,1.96-3.25,3c-0.75-0.5-0.75-0.5-1.5-1
						C409.66,193.69,412.29,191.98,420.56,190.67z"
              />

              <path
                class="st47"
                d="M394.06,205.67c-1.5,3.52-1.88,7.27-2.5,11c-0.5,0-0.5,0-1,0c-0.03-3.41-0.2-6.71,1-10
						C393.29,205.39,393.95,205.75,394.06,205.67z"
              />

              <path
                class="st40"
                d="M416.06,206.67c-0.66,0.33-3.36,3.03-4,3.5c-10.88,7.96-6.48,7.46-9,10.5c-0.04,0.04-0.88,0.4-1,0.5
						c-0.76,0.61-2.92,1.56-4,1.5c1.24-13.07,14.98-21.02,16.25-20.5C415.91,202.83,414.06,206.04,416.06,206.67z"
              />

              <path
                class="st35"
                d="M423.06,204.67c1.47,2.6-1.72,2.37-6.25,5c-2.27,1.32-2.45,5.3-4.75,0.5c0.64-0.47,3.34-3.17,4-3.5
						C418.47,205.46,420.34,204.9,423.06,204.67z"
              />

              <path
                class="st39"
                d="M396.56,211.67c2.68-6.33,2.64-5.49,6.5-10C404.12,203.97,399.42,212.7,396.56,211.67z"
              />

              <path
                class="st35"
                d="M398.06,229.17c-0.12-1.77-0.16-4.8,0-6.5c1.08,0.06,3.24-0.89,4-1.5c-0.5,3.38-0.5,3.38-1,6.75
						C399.89,229.51,399.33,229.03,398.06,229.17z"
              />

              <path
                class="st39"
                d="M391.56,216.67c-0.15,0.88-0.34,1.65-0.5,2.5c-1.05,5.48-0.48-0.41-0.5-2.5
						C391.06,216.67,391.06,216.67,391.56,216.67z"
              />
            </g>

            <g>
              <path
                class="st35"
                d="M361.56,287.17c-1.88,0.23,0.23,2.36,1.75,3.5c6.93,5.24,12.97,6.27,18.25-1.5
						c5.21,3.01,10.99-1.75,12.25,1c1.37-1.1,1.17-2.49,1.25-4c0.45,0.06,1.23-0.22,1.5,0.25c0.97,1.68,1.8,15.54,8.5,16.75
						c-0.26,0.16-1.99,2.27-5,3.5c-0.05-0.08-1.33-0.82-1.5-1c-0.91-0.94-1.09-2.67-2-1.75c-1.75,8.79-2.27,9.82-7.5,15.75
						c-0.12,0.13-1.22-0.27-1.5,0.25c-1.22,2.21,1.92,7.83,4.75,6.25c1.76-0.99,0.34-3.87,2.75-1c-3.83,3.95-5.27,2.96-5,5
						c-6.32-0.88-11.7-4.06-15-9.5c-0.05-0.08,0.34-1.53,0.5-1.75c-1.2-1.68-2.14-1.12-2.5-1.25c0.62-12.1-11.47-15.34-13.5-18.75
						c-0.38-5.11-4.67-11.27-6-15.5c-0.85-2.7-1.24-7.18-1.5-8.25C354.92,278.39,358.17,284.64,361.56,287.17z"
              />

              <path
                class="st27"
                d="M381.31,319.67c0.74-0.02,2.26-0.2,2.75,0.25c0.82,0.75,2.65,15.48-5.5,0.5
						C380.59,320.28,381.16,319.67,381.31,319.67z"
              />
            </g>

            <path
              class="st41"
              d="M350.56,269.17c-0.15-0.86-0.37-1.62-0.5-2.5C353.71,267.57,356.13,271.34,350.56,269.17z"
            />

            <path
              class="st41"
              d="M386.56,267.67c2.69,2.78,5.73,8.76,7,12.5c-1.36,0.72-0.9,1.43-2,0.25
					C390.79,279.6,377.33,258.15,386.56,267.67z"
            />

            <g>
              <path
                class="st33"
                d="M403.56,265.67c1.76,6.15,1.79,9.02,4,13c-0.86-0.01-0.32,0.84,0,2c-5.48,0.09-2.84,10.02-8,1
						c-1.1-1.92-2.75-7.95-4-11c-0.16-0.4-0.45-0.6-0.5-1c2.07,0.1,4.17-0.07,6.25,0c1.61-7.93-8.9-11.52-13-17
						c2.62,2.05,5.65,2.89,9,3C400.76,258.79,400.08,265.58,403.56,265.67z"
              />

              <path
                class="st33"
                d="M395.56,270.67c1.25,3.05,2.9,9.08,4,11c-2.58,1.65-2.45-3.79-3-5.25
						C396.42,276.05,391.82,272.7,395.56,270.67z"
              />

              <path
                class="st35"
                d="M404.31,277.67c0.38,0,0.38,2,0,2S403.92,277.67,404.31,277.67z"
              />
            </g>
          </g>

          <path
            class="st37"
            d="M260.56,348.17c-0.07-0.06-0.18,0.07-1.5-1C259.81,347.67,259.81,347.67,260.56,348.17z"
          />

          <path
            class="st48"
            d="M226.06,217.17c1.57,1.99,3.93,0.45,6,0.5c-0.23,0.35,1.29-0.01-1.25,2c-1.3-1.66-7.56-0.95-12.75-1
				c-3.27-0.03-2.34,1-2.5,1c-0.5,0-1,0-1.5,0c-2.55-0.24-5.91-2.81-6.5-3C209.62,218.23,222.97,217.31,226.06,217.17z"
          />

          <path
            class="st49"
            d="M218.06,218.67c0.72,1.88,9.19,0.34,8.5,3c-2.95-0.42-6-1.23-9-1c-0.32-0.37-1.4-1.12-2-1
				C215.72,219.67,214.78,218.64,218.06,218.67z"
          />

          <path
            class="st50"
            d="M228.56,221.67c-0.5,0-0.5,0-1,0c0.06,0.01,0.44-1.06,0.75-1C228.73,220.74,228.5,221.64,228.56,221.67z"
          />

          <g>
            <path
              class="st51"
              d="M356.56,81.17c6.11,1.79,11.66,5.46,16.5,9.5c0.78,0.65,7.49,7.35,8.5,8.5c2.85,3.24,5.77,6.53,8,10.25
					c3.08,5.14,6.94,13.15,6,19c-0.05,0.29-1.4,1.15-1.5,1.5c-0.43,1.48,1.82,0.84-1.5,4.25c-4.08-6.95-4.92-14.62-9-21.75
					c-5.32-9.3-14.4-15.88-23.75-20.75c-13.35-6.96-18.23-8.31-33.25-4.5c-1.87,0.47-3.7,0.72-5.5,1.5c-0.5-0.5-0.5-0.5-1-1
					c1.23-0.6,9.25-7.85,18-7c5.18,0.5,9.99,7.89,11-1C351.34,79.95,354.38,80.53,356.56,81.17z"
            />

            <path
              class="st18"
              d="M397.56,151.67c0.18,0.36,0.31,0.64,0.5,1c0.18,0.35,0.34,0.69,0.5,1c0.85,4.69,3.84,7.06,4.5,12.25
					c0.6,4.7-0.04,14.59-2.5,18.75c-0.45,0.75-3.23,2.71-4,3.5c1.31-8.24-3.03-1.41-6.75,0c-2.88,1.09-6.26,0.9-9.25,1.5
					c-0.06,0.01,0.05-0.41-0.75-1c-0.6,2.47-6.05,1.25-7.25,4c-1.08-1.18-4.34-2.75-2.5-4.5c2.39-0.91,7-3.38,8-5.5
					c4.05,5.89,13.17-5.03,14.75-10.5c0.04,2.41,0.86,3.38,3.25,3c-1.98,9.66,2.74-2.26,2-8.25c2.61,2.17,0.96-11.2-5-14.25
					c-3.58-1.83-4.28,0.16,0.25-2c0.5-0.24,1.42-1.29,1.25-2c0.33-0.17,0.82,0.89,1,0.25c-0.71-9.87,0.71,1.83,1,2.5
					C396.75,151.87,397.52,151.6,397.56,151.67z"
            />

            <path
              class="st18"
              d="M400.56,131.67c-2.53,6.46,0.9,13.89-3,20c0.34-4.13-1.58-8.1-3-12c-0.63-1.73-2.12-3.34-2-5.5
					c3.32-3.41,1.07-2.77,1.5-4.25c0.1-0.35,1.45-1.21,1.5-1.5c0.94-5.85-2.92-13.86-6-19c-2.23-3.72-5.15-7.01-8-10.25
					C390.39,105.24,398.96,121.41,400.56,131.67z"
            />

            <path
              class="st19"
              d="M390.56,193.67c0.75,0.75,0.75,0.75,1.5,1.5c-2.68,2.88-2.36,3.34-2.5,3.5c-0.6,0.67-1.82,1.28-2,1.5
					c-3.12,0.29-3.33,0.02-5-2.5C384.56,196.6,387.64,193.76,390.56,193.67z"
            />

            <path
              class="st13"
              d="M400.56,186.17c-4.72,8.29-7.51,7.94-8.5,9c-0.75-0.75-0.75-0.75-1.5-1.5c2.18-1.72,4.05-3.52,6-5.5
					c0.77-0.79,3.55-2.75,4-3.5C400.56,185.42,400.56,185.42,400.56,186.17z"
            />

            <path
              class="st19"
              d="M370.06,188.17c-1.84,1.75,1.42,3.32,2.5,4.5c0.84,0.92,1.63,1.64,2.5,2.5c1,1,1.69,2.2,2.5,3
					c0,0.75,0,0.75,0,1.5c-0.94,0.52-2.09,1.41-3,2c-5.02,3.23,0.92,0.15,4.5,2.5c0.61,1.07,2.3,4.78,2.5,5.75
					c1.07,5.28-0.48,13.31,1.5,13.25c0.16,1,0.09,2,0.5,3c-1.45-0.27-9.02-1.5-9.5-1.5c-3.21-2.14-9.28-4.71-13-5
					c-2.71-3.6-8.64-5.41-13-6.5c-3.69-0.92-4.89-1.43-9-1.5c-0.62-6.55-10.89-5.84-14.25-1c-3.22-0.81-5.27,0.97-6,0.5
					c-2.91-1.88,5.53-0.78,10-4.5c10.44,0.58,27.67-0.96,34.75-9.5c1.33-1.61,2.06-3.18,3-5c0.18-0.35,0.32-2.69,0.5-3
					C368.97,185.79,369.86,188.24,370.06,188.17z"
            />

            <path
              class="st51"
              d="M324.56,274.67c0.42,5.77,1.48,12.23,4,17.5c-0.79,1.77-1.35,3.68-2,5.5c-2.02,0.74-3.28,3.15-4.75,1
					c-0.44,8.31-4.61,6.79-3.25,11c-4.42,1.93-6.65,6.21-10.5,9.5c-1.97,1.69-4.78,0.98-6.5,5.5c-16.02,2.48-15.38-3.6-16.75-4.5
					c-0.32-0.21-1.87,0.21-2.25,0c-5.45-2.97,4.42-6,3-8.5c5.5,3.81,9.65-0.7,11.75,1.5c1.09-1.09,2.86-2.96,4.25-3.5
					c4.76-1.83,10.66-2.27,14-6.75c0.39-0.52-0.76-2.48,7-10.5c-0.42-0.84-5.54,1.81-7,2.25c-6.62,1.97-13.45,4.7-19.5,0
					c-3.71-2.89-7.12-7.93-0.5-9.5c0.23,2.15,2.15,4.39,3.5,6c4.05,4.83,3.52,4.13,10.75,4c-12.95-2.29,6.32-4.64,9.25-9.75
					c0.08-4.25,2.38-3.79,4-10.75C323.81,274.67,323.81,274.67,324.56,274.67z"
            />

            <path
              class="st52"
              d="M392.56,134.17c-0.12,2.16,1.37,3.77,2,5.5c-0.53,0.21-0.86,1.02-1,1.5c-3-1.12-3-1.12-6-2.25
					c-0.16-17.15-9.29-34.01-24.25-42.75c-1.45-0.85-17.98-8.28-19-8.5c-3.33-0.73-9.96-0.72-13.5-0.5c-0.57,0.04-4.55,1.84-4.25,0
					c15.02-3.81,19.9-2.46,33.25,4.5c9.35,4.87,18.43,11.45,23.75,20.75C387.64,119.55,388.47,127.22,392.56,134.17z"
            />

            <path
              class="st27"
              d="M254.56,192.17c1.62,7.03-0.05,10.6-5,15.5c-0.25,0.25-0.25,0.25-0.5,0.5c-1.71,1.56-4.46,2.82-6.25,4.5
					c-13.71,12.84-20.7,24.12-24.25,43c-0.3,1.61-0.53,3.35-0.5,5c-0.01,0.03-0.37-0.19-0.5,0.5c-1.37,7.09-0.56,15.49,0.5,22.5
					c-1,0.5-1,0.5-2,1c-1.11-7.33-1.74-14.58-1.5-22c0.2-1.13,0.29-2.39,0.5-3.5c0.82-4.29,1.16-8.81,2.5-13
					c0.02-0.05,0.06,0.27,0.5-1c0.93-2.7,2.71-5.89,4-8.5c1.09-2.19,2.28-5,3.5-7c0.49-0.81,3.27-4.34,4.5-6
					c1.12-1.51,3.32-4.72,4-5.5c6.52-7.46,19.87-13.94,18-25C253.31,192.67,253.31,192.67,254.56,192.17z"
            />

            <path
              class="st53"
              d="M268.06,319.17c-0.83,0.53-0.36,0.82-0.5,1c-1.35,1.77,0,2.51,2.5,6c1.37,1.91,0.21,1.96,0.75,2.5
					c1.4,1.39,12.84,4.01,4,6c-9.92,2.23-17.8-4.2-18.75-4.5c0.94-1.14,0.22-1.92-1-2.5c0.13-6.33,3.4-8.8,4.25-15
					C263.68,315.92,263.68,315.92,268.06,319.17z"
            />

            <path
              class="st28"
              d="M252.56,161.67c1.14,6.16-2.8,13.35-9,15c-5.38-11.7-0.53-23.25,3-25
					C248.63,155.06,251.81,157.63,252.56,161.67z"
            />

            <path
              class="st51"
              d="M301.56,309.67c-0.17-1.07-1.23-0.23-2.5,0c-4.28-0.65-2.8-1.85-3-2c2.02-1.36,1.37-1.91,0.5-3.5
					c4.01-1.02,4.62-3.87,6.25-4.5c3-1.17,8.36,1.22,12.75-5c1.46-0.44,6.58-3.09,7-2.25c-7.76,8.02-6.61,9.98-7,10.5
					C312.22,307.4,306.31,307.84,301.56,309.67z"
            />

            <path
              class="st52"
              d="M280.06,86.17c-12.39,4.25-18.47,12.84-24.5,23.5c-2,3.53-3.68,8.8-7,10c0.51-1.49,0.44-2.83,0.5-3
					c0.4-1.07,4.04-9.16,4.5-10c2.32-4.26,2.79-4.25,5.5-7.5c0.24-0.29,0.97-0.91,1.5-1.5c1.35-1.5,4.54-5.18,5.5-6
					c1.27-1.09,8.39-6.12,9.5-6.5c2.26,0.25,1.9-0.47,2-0.5C279.46,84.68,280.36,84.18,280.06,86.17z"
            />

            <path
              class="st53"
              d="M325.56,257.67c-1.57,5.17-1.39,11.66-1,17c-0.75,0-0.75,0-1.5,0c0.04-0.16-0.03-0.34,0-0.5
					c0.03-0.17,2.09-0.28,1-2.75c-0.31-0.7-6.83-0.95-7-12.25c-0.16-10.54,5.46,3.09,8.5-7
					C325.84,253.85,325.59,255.91,325.56,257.67z"
            />

            <path
              class="st52"
              d="M218.06,283.67c0.68,4.48,1.88,10,4,14c-0.04,2.33,1.42,3.8,1.5,4c1.68,4.2,3.32,7.58,6.5,11
					c-1,1.39,1.56,1.13-0.5,4c0,0.25,0,0.25,0,0.5c-1.11-1.7-3.86-4.92-4.5-6c-0.88-1.48-1.92-2.84-2-3c-0.12-0.24-1.37-3.53-2-5
					c-2.89-6.77-3.91-11.29-5-18.5C217.06,284.17,217.06,284.17,218.06,283.67z"
            />

            <path
              class="st18"
              d="M275.56,90.67c-0.69,0.46-4.08,1.39-7,5.5c-1.27,1.79-1.59,0.83-1.5,4.25c-0.08,0.1-2.02,0.02-2.5,0.25
					c0.11-0.2,0.07-1.44-0.25-1.5c-0.71-0.14-0.62,3.02,0.25,1.5c-0.07,0.04,0.22,0.75-0.25,1c-0.12,0.07-1.21-1.49-2.75,0.25
					c-4.65,7.06-7.19,14.67-6,7.75c6.03-10.66,12.11-19.25,24.5-23.5c1.53-0.52,2.12-1.48,2.25-1.5
					C289.22,83.87,283.59,85.36,275.56,90.67z"
            />

            <path
              class="st52"
              d="M315.56,294.67c-4.39,6.22-9.75,3.83-12.75,5c-1.63,0.63-2.24,3.48-6.25,4.5c-1.19,0.3-3.03-0.68-3.5,1
					c-1.19-3.94,3.7-3.01,4-4.75c0.05-0.3-2.46-3.61-1-5.75C302.11,299.37,308.93,296.64,315.56,294.67z"
            />

            <g>
              <path
                class="st51"
                d="M371.56,177.17c1.18,0.24,4.53,0.3,5,0.5c2.09,0.86,2.42,3.06,1.5,5c-1,2.12-5.61,4.59-8,5.5
						c-0.2,0.08-1.09-2.37-3,1c-0.89-0.65-3.69-6.51-4-6.75c-1.22-0.94-0.95,0.78-1,0.75c-4.51-2.63-3.3-1.42-3.5-1.5
						c-2.01-0.77-3.53-1.76-3.75-1c0.13-4.09-4.83-8.88-3.25-14.5C354.45,175.76,366.46,176.11,371.56,177.17z"
              />

              <g>
                <path
                  class="st28"
                  d="M370.06,152.67c5.82,0.45,10.65,3.28,13,8.5c-3.48,12.78-10.67,11.53-11.5,16
							c-5.1-1.06-17.11-1.41-20-11c-0.14-0.46-0.43-0.57-0.5-1c-0.01-0.07-0.01-1.43,0-1.5c0.04-0.43,0.83-2.65,1-4
							c5.2-3.36,6.02-6.26,13-7C366.36,152.53,368.7,152.56,370.06,152.67z"
                />

                <path
                  class="st28"
                  d="M376.56,177.67c-0.47-0.2-3.82-0.26-5-0.5c0.83-4.47,8.02-3.22,11.5-16
							C386.77,169.41,382.92,172.48,376.56,177.67z"
                />
              </g>
            </g>

            <path
              class="st50"
              d="M320.06,87.67c0.5,0.5,0.5,0.5,1,1c-2.49,1.08-7.85,4.66-8.75,7c-4.09-0.52-5.76,0.57-9.25,2
					c2.5-3.63,2.54-3.71,5.5-7C312.68,91.6,316.51,89.4,320.06,87.67z"
            />

            <path
              class="st53"
              d="M397.56,151.67c-0.03-0.07-0.8,0.21-1-0.25c-0.29-0.67-1.71-12.37-1-2.5c-0.18,0.64-0.67-0.42-1-0.25
					c-0.73,0.37-4.73,1.96-5,2c-0.75-0.25-0.75-0.25-1.5-0.5c0.43-0.96,0.83-3.83,1.5-4.75c1.63-2.25,3.19-1.57,4-4.25
					c0.14-0.48,0.47-1.29,1-1.5C395.98,143.56,397.89,147.54,397.56,151.67z"
            />

            <path
              class="st54"
              d="M256.06,161.17c-1.75,0.25-1.75,0.25-3.5,0.5c-0.75-4.03-3.93-6.6-6-10c3.02-1.49,7.24,3.22,10.25,4
					c0.38,0.38,0.38,0.38,0.75,0.75C256.53,157.78,256.04,159.47,256.06,161.17z"
            />

            <path
              class="st27"
              d="M317.06,259.17c0.17,11.3,6.69,11.55,7,12.25c1.09,2.47-0.97,2.58-1,2.75
					C315.48,272.49,312.52,265.27,317.06,259.17z"
            />

            <path
              class="st27"
              d="M282.56,320.17c0.38,0.21,1.93-0.21,2.25,0c1.37,0.9,0.73,6.98,16.75,4.5c-1.05,1.11-4.58,1.91-6,2
					c-2.6,0.17-11.13-0.86-13-2.5C281.4,323.15,279.97,320.17,282.56,320.17z"
            />

            <path
              class="st52"
              d="M301.56,309.67c-1.39,0.54-3.16,2.41-4.25,3.5c-2.1-2.2-6.25,2.31-11.75-1.5c-5.26-3.64,1.44-1.02,1.75-1
					c3.1,0.17,8.59-0.43,11.75-1C300.32,309.44,301.39,308.59,301.56,309.67z"
            />

            <path
              class="st55"
              d="M239.56,321.67c1.5,2.25,1.5,2.25,3,4.5c-2.48-1.01-2.81-3.01-5-0.5c-0.23-0.29-2.4-2.24-5-5.5
					C234.64,319.42,236.83,320.85,239.56,321.67z"
            />

            <path
              class="st18"
              d="M296.56,304.17c0.87,1.59,1.52,2.14-0.5,3.5c-0.7-0.51-2.15,0.31-3-2.5
					C293.52,303.48,295.37,304.47,296.56,304.17z"
            />

            <g>
              <path
                class="st53"
                d="M287.56,82.67c1.06,6.23,2.24,9.19,4.5,15c5.95,15.32,2.14,12.87,11,0c3.49-1.43,5.16-2.52,9.25-2
						c0.9-2.34,6.26-5.92,8.75-7c1.8-0.78,3.63-1.03,5.5-1.5c-0.3,1.84,3.68,0.04,4.25,0c3.54-0.22,10.17-0.23,13.5,0.5
						c1.02,0.22,17.55,7.65,19,8.5c14.96,8.74,24.09,25.6,24.25,42.75c3,1.12,3,1.12,6,2.25c-0.81,2.68-2.37,2-4,4.25
						c-0.67,0.92-1.07,3.79-1.5,4.75c-0.08,0.19-3.91,1.32,1.5,0.5c0.27-0.04,4.27-1.63,5-2c0.17,0.71-0.75,1.76-1.25,2
						c-4.53,2.16-3.83,0.17-0.25,2c4.55,10.95,5.4,10.77,3,22.5c-2.39,0.38-3.21-0.59-3.25-3c-1.58,5.47-10.7,16.39-14.75,10.5
						c0.92-1.94,0.59-4.14-1.5-5c6.37-5.19,10.21-8.26,6.5-16.5c-2.35-5.22-7.18-8.05-13-8.5c1.91-5.07-1.25-7.93-3-12
						c-1.15-2.67-2.58-5.24-3.5-8c2.25,3.12,2.25,3.12,4.5,6.25c-3.05-19.56-26.26-36.38-44.25-24.25
						c-8.08,5.45-13.37,17.38-12.75,27c-1.82-0.08-1.48-3.69-1.5-5.25c-1.65,1.05-1.19-7.29-3-4.5c-0.27,0.42-0.23,2.42,1,2.5
						c-0.11,0.46-1.49,0.17-1.5,0.25c-0.12-0.5-0.12-0.5-0.25-1c-1.39,3.33-1.21,10.49,1.25,13.5c4.7,5.94,3.43,5.91,10,11.5
						c9.86,8.39,21.5,11.05,34,6.5c0.07,0.43,0.36,0.54,0.5,1c-1.58,5.62,3.38,10.41,3.25,14.5c0.22-0.76,1.74,0.23,3.75,1
						c1.62,2.25,1.62,2.25,3.25,4.5c0.12-1.5,0.12-1.5,0.25-3c0.05,0.03-0.22-1.69,1-0.75c0.31,0.24,3.11,6.1,4,6.75
						c-0.18,0.31-0.32,2.65-0.5,3c-3.45,1.14-8.63,0.26-3,5c-7.08,8.54-24.31,10.08-34.75,9.5c-4.47,3.72-12.91,2.62-10,4.5
						c0.73,0.47,2.78-1.31,6-0.5c3.36-4.84,13.63-5.55,14.25,1c-1.87-0.03-5.62-0.22-6.75,0c-10.21,1.98,20.96-0.05,17.25,10
						c-14.55,5.5-18.31,20.87-20.5,24c-0.51,0.73-1.09,2.01-1.75,2c-1.02-1.35-2.64-2.29-3.75-3.5c1.26-3.06-1.38-5.22-1.5-5.5
						c-0.81-1.97-0.13-4.65-3-5.5c0.49-2.32,8.33-9.17,10.5-12.75c-2.03-2.55-5.59,8.57-5.25,0.75c-1.01,3.64-6.58,10.21-7.25,13
						c-0.98,4.09-0.3,4.8,1.5,8c0.52,0.92,0.96,0.94,1,1c5.19,7.04,7.56,3.83,6,9c-3.04,10.09-8.66-3.54-8.5,7
						c-4.54,6.11-1.57,13.33,6,15c-0.03,0.16,0.04,0.34,0,0.5c-1.62,6.96-3.92,6.5-4,10.75c-2.93,5.11-22.2,7.46-9.25,9.75
						c-7.23,0.13-6.7,0.83-10.75-4c4.39-2.1-4.51-15.33-3.5-6c-6.62,1.57-3.21,6.61,0.5,9.5c-1.46,2.14,1.05,5.45,1,5.75
						c-0.3,1.74-5.19,0.81-4,4.75c0.85,2.81,2.3,1.99,3,2.5c0.2,0.15-1.28,1.35,3,2c-3.16,0.57-8.65,1.17-11.75,1
						c-0.31-0.02-7.01-2.64-1.75,1c1.42,2.5-8.45,5.53-3,8.5c-2.58,0-1.16,2.98,0,4c-4.38,3.75-10.88-3.46-12.5,2
						c-2.5-3.49-3.85-4.23-2.5-6c0.16,2.76,9.01,2.5,9.5,1.25c0.78-2.01-6.74-3.71-9-2.25c-4.38-3.25-4.38-3.25-8.75-6.5
						c-0.85,6.2-4.12,8.67-4.25,15c-1.91-0.9-8.69,0.13-14.25-7c-1.04-0.1-1.17,1.02-1.25,1c-2.72-0.82-4.91-2.25-7-1.5
						c-0.95-1.2-1.91-1.89-2-2c-0.06-0.07,0.25-1.16-1-1.5c2.06-2.87-0.5-2.61,0.5-4c9.85,9.08-4.56-5.63-6.5-11
						c-0.08-0.2-1.54-1.67-1.5-4c-4.11-13.08-4.98-22.86-4.5-36.5c0.13-0.69,0.49-0.47,0.5-0.5c0.36-1.46,1.94-3.48,0.5-5
						c3.55-18.88,10.54-30.16,24.25-43c1.79-1.68,4.54-2.94,6.25-4.5c0.19-0.17,0.53,0.28,0.75,0.5c0.87-0.81-0.29-0.96-0.25-1
						c4.95-4.9,6.62-8.47,5-15.5c-1.42-6.18-8.36-9.17-11-14c-0.14-0.26,0.14-1.19,0-1.5c6.2-1.65,10.14-8.84,9-15
						c1.75-0.25,1.75-0.25,3.5-0.5c0.01,0.75-0.1,1.72,0,2c0.25,0.7,1.49,1.98,2.25,1.5c0.8-0.5-1.67-0.27,1.25-2
						c0.15,0.88,1.01,0.93,1,1c-0.06,0.73-1.64,0.37-0.75,1.5c3.85-0.57,5.43,0.53,7.25,1c4.28,12.61,5.24,18.74,13,30
						c1.06,1.54,1.88,3.34,2.75,5c0.24-0.05,0.18-0.91,0.75-2c4.38-8.38,7.82-12.42,14.5-19c-0.06,0.63,0.95,0.65,1.25,0.5
						c0.84-0.42,10.49-9.53,14.75-11.5c4.59-2.13,2.52,0.02,7-0.25c0.4-0.61-6.9-4.82-7.5-5.25c-8.03-5.76-9.29-6.48-13-16
						c-2.21-5.67-3.51-15.77-8-19.5c-4.81-4-6.19-1.15-10.5,1.5c-2.02,1.24-3.87,2.22-5.5,4c2.81-5.57,0.73-23.67-7.25-24.5
						c-3.12-0.32-12.55,4.42-13.25,8c-0.94-1.39-1.22-2.18-2.25-1.5c-2.62,2.75-2.62,2.75-5.25,5.5c0.13-0.39-0.13-1.12,0-1.5
						c3.32-1.2,5-6.47,7-10c-1.2,6.92,1.35-0.69,6-7.75c1.54-1.74,2.63-0.18,2.75-0.25c0.47-0.25,0.18-0.96,0.25-1
						c0.48-0.23,2.42-0.15,2.5-0.25c-0.09-3.42,0.23-2.46,1.5-4.25c1.66,1.85,3.15-0.47,3.75-0.5c5.27-0.28,11.37,3.66,3.25-5
						c8.04-5.3,13.66-6.8,6.75-6c-0.13,0.02-0.72,0.98-2.25,1.5c0.31-1.98-0.59-1.48-2.5-1.5
						C280.71,83.59,284.35,81.82,287.56,82.67z"
              />

              <g>
                <path
                  class="st52"
                  d="M277.81,214.67c4.34,0.27-5.31,3.71-10.75,10.75c-1.03,1.33-5.33,10.8-6.75,10.25
							C255.02,225.82,268.59,214.1,277.81,214.67z"
                />

                <path
                  class="st55"
                  d="M235.06,264.17c0.12,0.28,1.48,0.51,1.5,5.5c0.19,1.23-0.9,1.41-1,1.5c-6.14-8.92-6.35-14.06-4-24.5
							c0.33-0.7,3.28-5.97,3.5-6.25c6.75-8.87-1.83,5.78-2.5,12.5C231.57,262.81,234.1,262.01,235.06,264.17z"
                />

                <path
                  class="st27"
                  d="M276.31,242.17c8.53-1.24-7.77,8.25-11,20C260.45,258.63,272.31,242.75,276.31,242.17z"
                />

                <path
                  class="st52"
                  d="M245.56,245.67c0.15,4.83-6.5,15.35-7.5,19.75c-0.47,2.06,1.28,7.52-1.5,4.25
							c-0.02-4.99-1.38-5.22-1.5-5.5c1.83-7.14,6.4-13.03,10.5-19C245.56,245.42,245.56,245.42,245.56,245.67z"
                />

                <path
                  class="st55"
                  d="M322.06,238.67c-2.45,4.42,0.47,4.39,1.5,5.5c1.11,1.21,2.73,2.15,3.75,3.5c0.66,0.01,1.24-1.27,1.75-2
							c-1.18,4.95-2.65,9.89-3,15c-0.06,0.83,0.02,1.67,0,2.5c-0.76-0.02-0.55-2.85-0.5-5.5c0.03-1.76,0.28-3.81,0-5.5
							c1.56-5.17-0.81-1.96-6-9c0.37-3.68-1.29-6.23-0.5-10C321.93,234.02,321.25,236.7,322.06,238.67z"
                />

                <path
                  class="st52"
                  d="M308.31,266.17c3.3,8.52,8.67,11.97,8.75,12.75c0.14,1.43-1.6-0.5-2,0.5c-0.04,0.1,1.23,1.56,0.25,2.25
							C314.51,282.22,302.63,273.77,308.31,266.17z"
                />

                <path
                  class="st55"
                  d="M254.56,192.17c-1.25,0.5-1.25,0.5-2.5,1c-1.2-7.11-4.85-3.25-10.5-13c1-1,1-1,2-2
							C246.2,182.99,253.13,185.99,254.56,192.17z"
                />

                <path
                  class="st52"
                  d="M339.06,211.67c4.11,0.07,5.31,0.58,9,1.5c0.37,3.4,2.63,5.9,5.5,7.5c-0.97,0.21-3.43,0.78-4,1
							c3.71-10.05-27.46-8.02-17.25-10C333.43,211.45,337.18,211.64,339.06,211.67z"
                />

                <path
                  class="st52"
                  d="M255.06,327.67c1.22,0.58,1.94,1.36,1,2.5c-1.91-0.61-5.57-0.85-6-1c-2.61-0.94-4.96-1.96-7.5-3
							c-1.5-2.25-1.5-2.25-3-4.5c0.08,0.02,0.21-1.1,1.25-1C246.37,327.8,253.14,326.76,255.06,327.67z"
                />

                <path
                  class="st18"
                  d="M319.06,233.17c-0.79,3.77,0.87,6.32,0.5,10c-0.04-0.06-0.48-0.08-1-1c-0.75-4-0.75-4-1.5-8
							c0.67-2.79,6.24-9.36,7.25-13c-0.34,7.82,3.22-3.3,5.25-0.75C327.39,224,319.54,230.85,319.06,233.17z"
                />

                <path
                  class="st19"
                  d="M232.81,273.67c-3.61,20.8,8.98,24.8,8.75,26.25c-0.6,3.84-9.27-7.9-10-11
							C230.08,282.71,231.75,273.45,232.81,273.67z"
                />

                <path
                  class="st56"
                  d="M396.06,175.17c2.4-11.73,1.55-11.55-3-22.5c5.96,3.05,7.61,16.42,5,14.25
							C398.8,172.91,394.08,184.83,396.06,175.17z"
                />

                <path
                  class="st19"
                  d="M235.56,271.17c-0.08,0.07,0.17,1.01-0.25,1c-1.4-0.03-11.04-10.08-3.75-25.5
							C229.21,257.11,229.41,262.25,235.56,271.17z"
                />

                <path
                  class="st50"
                  d="M265.06,280.17c-10.48-7.4-7.63-9.68-11-7.25c0.75-4.26-2.62-9.49-0.25-16.25
							c-0.83,16.53,8.26,17.89,11.75,22.75C265.58,279.45,264.88,279.91,265.06,280.17z"
                />

                <path
                  class="st53"
                  d="M275.56,90.67c8.12,8.66,2.02,4.72-3.25,5c-0.6,0.03-2.09,2.35-3.75,0.5
							C271.47,92.05,274.86,91.12,275.56,90.67z"
                />

                <g>
                  <path
                    class="st27"
                    d="M252.56,287.67c-4.56,10.94,6.03,15.29,7.5,17c5.17,5.98-8.2-0.26-10.5-3.75
								c-8.56-12.99,6.06-24,8.75-23.75C262.58,277.56,253.62,285.11,252.56,287.67z"
                  />

                  <path
                    class="st18"
                    d="M260.06,304.67c-1.47-1.71-12.06-6.06-7.5-17C251.35,299.36,263.28,301.81,260.06,304.67z"
                  />
                </g>

                <path
                  class="st18"
                  d="M267.56,320.17c0.14-0.18-0.33-0.47,0.5-1c2.26-1.46,9.78,0.24,9,2.25
							C276.57,322.67,267.72,322.92,267.56,320.17z"
                />

                <path
                  class="st27"
                  d="M299.06,291.17c-1.35-1.61-3.27-3.85-3.5-6C294.55,275.84,303.45,289.06,299.06,291.17z"
                />

                <g>
                  <path
                    class="st13"
                    d="M292.56,128.17c4.49,3.73,5.79,13.83,8,19.5c-0.75,0-0.75,0-1.5,0c-2.95-6.35-5.21-12.9-7.5-19.5
								C291.8,128.24,292.23,128.13,292.56,128.17z"
                  />

                  <path
                    class="st22"
                    d="M300.56,147.67c3.71,9.52,4.97,10.24,13,16c0,0.25,0,0.25,0,0.5c-2.19-0.37-4.03-1.59-6-2.5
								c-4.14-4.34-6.06-8.75-8.5-14C299.81,147.67,299.81,147.67,300.56,147.67z"
                  />

                  <path
                    class="st14"
                    d="M292.56,128.17c-0.33-0.04-0.75,0.07-1,0c-0.53-0.16-0.63-0.52-1-0.5c-2.54,0.16-7.52,3.37-9.5,5
								c0.06-0.61,1.29-1.65,1-3C286.36,127.02,287.74,124.17,292.56,128.17z"
                  />
                </g>

                <path
                  class="st6"
                  d="M222.06,297.67c-2.12-4-3.32-9.52-4-14c-1.06-7.01-1.87-15.41-0.5-22.5
							C217.08,274.81,217.95,284.59,222.06,297.67z"
                />

                <path
                  class="st57"
                  d="M245.56,245.67c0-0.25,0-0.25,0-0.5C257.38,227.94,257.84,231.59,245.56,245.67z"
                />

                <path
                  class="st55"
                  d="M366.56,192.17c-0.94,1.82-1.67,3.39-3,5C357.92,192.43,363.1,193.31,366.56,192.17z"
                />

                <path
                  class="st8"
                  d="M230.06,312.67c-3.18-3.42-4.82-6.8-6.5-11C225.49,307.04,239.9,321.74,230.06,312.67z"
                />

                <path
                  class="st58"
                  d="M324.06,214.67c0.25,0,0.25,0,0.5,0c4.51-1.79,8.9,2.06,9.25,6.5
							C329.92,212.66,325.9,217.16,324.06,214.67z"
                />

                <path
                  class="st59"
                  d="M234.56,308.17c0.93,0.84,7.67,5.03,7.5,5.75C241.6,315.89,234.52,310.16,234.56,308.17z"
                />

                <path
                  class="st50"
                  d="M280.31,301.17c3.76,3.48,14.25,7.16,2,3.5C281.31,302.92,281.31,302.92,280.31,301.17z"
                />

                <path
                  class="st53"
                  d="M323.56,244.17c-1.03-1.11-3.95-1.08-1.5-5.5C322.17,238.95,324.81,241.11,323.56,244.17z"
                />

                <path
                  class="st58"
                  d="M347.81,172.17c-0.65,3.74-5.72,6.45-2.25,10.75C341.39,183.67,344.22,175.51,347.81,172.17z"
                />

                <path
                  class="st16"
                  d="M245.81,228.67c-3.25,3.75-3.25,3.75-6.5,7.5C237.61,235.65,244.92,229.05,245.81,228.67z"
                />

                <path
                  class="st50"
                  d="M273.31,277.67c3.62,0.88,3.62,0.88,7.25,1.75C277.39,281.68,275.47,281.07,273.31,277.67z"
                />

                <path
                  class="st51"
                  d="M265.06,280.17c6.48,4.57,3.79,5.69,1.5,3.25C266.43,283.29,265.78,281.22,265.06,280.17z"
                />

                <path
                  class="st19"
                  d="M362.06,183.17c-0.12,1.5-0.12,1.5-0.25,3c-1.62-2.25-1.62-2.25-3.25-4.5
							C358.76,181.74,357.55,180.54,362.06,183.17z"
                />

                <path
                  class="st50"
                  d="M249.81,215.67c-2.25,3.5-2.25,3.5-4.5,7c-0.38-0.38-0.38-0.38-0.75-0.75
							C247.18,218.79,247.18,218.79,249.81,215.67z"
                />

                <path
                  class="st13"
                  d="M318.56,242.17c-1.8-3.2-2.48-3.91-1.5-8C317.81,238.17,317.81,238.17,318.56,242.17z"
                />

                <path
                  class="st55"
                  d="M337.81,178.17c2.74-0.54,3.2,2.96,2,3C339.63,181.17,336.99,178.76,337.81,178.17z"
                />

                <path
                  class="st7"
                  d="M350.81,186.67c1.36,2.3,4.19,1.18,4.25,1.75C350.6,191.24,350.26,186.71,350.81,186.67z"
                />

                <path
                  class="st10"
                  d="M346.31,183.67c6.53,6.02,2.16,5.13,0.25,1.75C346.35,185.05,345.81,183.82,346.31,183.67z"
                />

                <path
                  class="st53"
                  d="M324.56,214.67c-0.25,0-0.25,0-0.5,0C321.72,211.51,328.38,210.69,324.56,214.67z"
                />

                <path
                  class="st7"
                  d="M218.06,260.67c-0.03-1.65,0.2-3.39,0.5-5C220,257.19,218.41,259.2,218.06,260.67z"
                />

                <path
                  class="st18"
                  d="M388.06,150.17c0.75,0.25,0.75,0.25,1.5,0.5C384.15,151.48,387.97,150.35,388.06,150.17z"
                />

                <path
                  class="st59"
                  d="M234.56,308.17c-0.38-1-0.38-1-0.75-2C234.45,306.96,234.48,308.09,234.56,308.17z"
                />

                <path
                  class="st51"
                  d="M276.81,315.67c0.32-0.15,1.75-0.03,1.75,0.25C278.56,316.48,275.82,316.13,276.81,315.67z"
                />

                <path
                  class="st59"
                  d="M249.06,208.17c0.25-0.25,0.25-0.25,0.5-0.5c-0.04,0.04,1.12,0.19,0.25,1
							C249.58,208.44,249.25,207.99,249.06,208.17z"
                />
              </g>
            </g>

            <path
              class="st18"
              d="M309.06,324.17c-0.11,0.12-1.12-0.14-1.25,0c-1.23,1.3-0.63,2.13-0.75,2.25c-0.31,0.32-7.04,4.73-7,5.5
					c0.03,0.57,7.1,1.14-3.75,4.75c-1.28,3.03-1.89,2.07-3.75,3.5c-6.34-0.12-9.21,4.39-9.75,4.5c-0.65,0.13-1.97-1.04-2.75-1
					c-0.78,0.04-1.29,0.14-1.5,1c-0.44,0.16-0.61,0.05-1.5,0.5c-2.98-0.41-4.27,0.98-4.5,1c-1.73,0.15-4.54-0.01-6-1
					c-0.63-0.43-1.92-0.93-2-1.75c-0.52-5.53,20.36-4.95,22-9.75c3.01,0.24,8.5,1.13,10.5-1.5c2.14-2.82-1.43-1.52-1.5-5.5
					c1.42-0.09,4.95-0.89,6-2c1.72-4.52,4.53-3.81,6.5-5.5c0.32,3.76,3.31-1.7,4.5-0.75C313.19,318.92,309.78,323.38,309.06,324.17z
					"
            />

            <path
              class="st18"
              d="M292.56,340.17c-4.26,3.27-7.79,7.11-12.5,9.75c2.1,5.15,9.04,2.74,10,6.25c-3.68-0.6-9.78-2.31-13.5-3.5
					c-2.44-0.78-2.84-1.44-3-1.5c-0.5-3.01-1.4-3.21-1.5-3.5c2.05-0.31,3.28-1.63,5-2.5c0.89-0.45,1.06-0.34,1.5-0.5
					c0.25-0.09,1.14,0.23,1.5-1c0.78-0.04,2.1,1.13,2.75,1C283.35,344.56,286.22,340.05,292.56,340.17z"
            />

            <path
              class="st20"
              d="M321.06,312.67c-0.37,0.36-1.96,4.38-7,7.25c2.47,3.46,8.86-7.06,8-3c-0.64,3-9.94,8.78-13,7.25
					c0.72-0.78,4.13-5.25,3.5-5.75c-1.19-0.95-4.18,4.51-4.5,0.75c3.85-3.29,6.08-7.57,10.5-9.5
					C319.12,311.42,319.77,311.59,321.06,312.67z"
            />

            <path
              class="st50"
              d="M323.56,306.17c-6.1,2.57,0.61,1.96,5-0.5c-0.78,2.96-5.9,5.44-7.5,7c-1.28-1.07-1.93-1.24-2.5-3
					c-1.36-4.21,2.81-2.69,3.25-11c1.47,2.15,2.73-0.26,4.75-1c-0.28,0.79,0.52,1.19,0.5,1.25
					C326.53,300.31,323.94,300.78,323.56,306.17z"
            />

            <path
              class="st60"
              d="M276.56,352.67c3.72,1.19,9.82,2.9,13.5,3.5c1.25,0.2,2.72,0.34,4,0.5c-2.19,2.27-3.33,2.37-3.5,2.5
					c2.11-2.76-4.02-0.73-9.25-2c-3.3-0.8-7.08-3.66-10.25-4.5c0.25-0.25,0.25-0.25,0.5-0.5
					C272.4,352.46,276.16,353.62,276.56,352.67z"
            />

            <g>
              <path
                class="st19"
                d="M375.06,320.67c3.3,5.44,8.68,8.62,15,9.5c0.65,0.09,3.8,0.53,4,0.5c-7.05,15.69-20.01,29.99-37.75,32.5
						c-1,0.68-0.69,1.41-0.75,1.5c-5.58-1.38-11.37-1.11-17,0c-5-2.59-11.43-3.51-14.25-9c-1.8-0.65-10.48,3.43-30.25,1
						c-1.28-0.16-2.75-0.3-4-0.5c-0.96-3.51-7.9-1.1-10-6.25c4.71-2.64,8.24-6.48,12.5-9.75c1.86-1.43,2.47-0.47,3.75-3.5
						c10.85-3.61,3.78-4.18,3.75-4.75c-0.04-0.77,6.69-5.18,7-5.5c0.12-0.12-0.48-0.95,0.75-2.25c0.13-0.14,1.14,0.12,1.25,0
						c3.06,1.53,12.36-4.25,13-7.25c0.86-4.06-5.53,6.46-8,3c5.04-2.87,6.63-6.89,7-7.25c1.6-1.56,6.72-4.04,7.5-7
						c0.81-0.46,1.68-0.8,2.5-1.25c-2.62-1.32-4.15,1.33-6.25,2.25c-0.59,0.26-0.89-0.65-1.25-0.5c0.38-5.39,2.97-5.85,3.5-7.25
						c0.02-0.06-0.78-0.46-0.5-1.25c0.65-1.82,1.21-3.73,2-5.5c0.67,1.41,1.51,2.76,2,4.25c3.99,0.39,3.16,2.68,5.5,5
						c7.54,7.47,17.27,13.14,27.25,16.75C365.14,318.83,375.97,322.08,375.06,320.67z"
              />

              <g>
                <path
                  class="st27"
                  d="M364.56,344.67c-1.73,0.45-6.67,1.47-8,1.5c-4.19,0.09-13.56-1.79-16.75-4.5c-6.72-5.72,7.92,1.74,9,2
							c8.89,2.11,19.66,0.13,27-5.5C374.75,341.45,367.71,343.84,364.56,344.67z"
                />

                <path
                  class="st50"
                  d="M364.06,326.17c-3.75,0.31-7.41,1.7-11,2.5c-1.73,0.38-6.13,2.58-11.25,1.5c-3.82-0.8-12.04-7.47-7.75-6
							c6.88,8.27,20.89,5.83,15.5,2c0.49-0.07,6.94-2.3,9.5-3C358.99,328.29,362.62,323.79,364.06,326.17z"
                />

                <path
                  class="st61"
                  d="M359.06,323.17c-2.56,0.7-9.01,2.93-9.5,3c-6.05,0.9-7.05,0.52-12.5-1c4.83,1.08,7.2,0.45,11.5-0.5
							c1.3-0.29-0.45-1.19,6.5-1.75c-4.62-0.62-4.62-0.62-9.25-1.25c1.38-0.5,1.38-0.5,2.75-1
							C363.56,323.67,373.68,319.15,359.06,323.17z"
                />

                <path
                  class="st20"
                  d="M337.06,325.17c5.45,1.52,6.45,1.9,12.5,1c5.39,3.83-8.62,6.27-15.5-2
							C335.41,323.21,336.12,324.91,337.06,325.17z"
                />

                <path
                  class="st50"
                  d="M364.56,344.67c1.99,3.28-12.45,7.15-13,6.25c1.68-1.58,5.29-2.78,5-4.75
							C357.89,346.14,362.83,345.12,364.56,344.67z"
                />

                <path
                  class="st27"
                  d="M348.56,320.67c-1.38,0.5-1.38,0.5-2.75,1c4.62,0.62,4.62,0.62,9.25,1.25c-6.95,0.56-5.2,1.46-6.5,1.75
							c-4.75-2.88-4.75-2.88-9.5-5.75C342.14,316.77,344.25,319.8,348.56,320.67z"
                />

                <path
                  class="st59"
                  d="M359.06,335.17c-0.96,0.19-7.83,1.31-8,0.75c2.92-2.33,5.3-1.98,8.5-2.75c2.46-0.59,5.1-0.65,7.5-1.75
							C363.06,333.29,363.06,333.29,359.06,335.17z"
                />

                <path
                  class="st61"
                  d="M359.06,335.17c4-1.88,4-1.88,8-3.75c-2.4,1.1-5.04,1.16-7.5,1.75
							C372.34,326.72,370.5,332.88,359.06,335.17z"
                />

                <path
                  class="st62"
                  d="M336.81,348.17c6.88,1.88,6.88,1.88,13.75,3.75C345.95,352.93,340.39,351.41,336.81,348.17z"
                />

                <path
                  class="st63"
                  d="M328.56,305.67c-4.39,2.46-11.1,3.07-5,0.5c0.36-0.15,0.66,0.76,1.25,0.5c2.1-0.92,3.63-3.57,6.25-2.25
							C330.24,304.86,329.37,305.21,328.56,305.67z"
                />

                <path
                  class="st61"
                  d="M364.06,326.17c-0.01,1.4-9.39,2.44-11,2.5C356.65,327.87,360.3,326.48,364.06,326.17z"
                />

                <path
                  class="st18"
                  d="M363.81,327.67c5-0.53-0.19,2.31-6.75,1.25C360.5,328.98,363.46,327.7,363.81,327.67z"
                />
              </g>
            </g>

            <path
              class="st19"
              d="M344.06,74.67c6.14,0.58,17.65,5.71,12.5,6.5c-2.17-0.64-5.22-1.22-7.5-1.5c-5.24-0.64-12.11-1.36-11,1
					c-8.75-0.85-16.77,6.4-18,7c-3.54,1.73-7.38,3.93-11.5,3C317.99,80.17,329.41,73.29,344.06,74.67z"
            />

            <path
              class="st18"
              d="M349.06,79.67c-1.01,8.89-5.82,1.5-11,1C336.95,78.31,343.81,79.02,349.06,79.67z"
            />

            <path
              class="st21"
              d="M396.56,188.17c-1.95,1.98-3.82,3.78-6,5.5c-2.92,0.1-6,2.94-8,4c-1.38,0.73-3.82,0.9-4,1
					c-0.26-0.07-0.96-0.46-1-0.5c-0.81-0.8-1.5-2-2.5-3c3.71,0.34,5.72-2.04,5.5-5.5c2.99-0.6,6.37-0.41,9.25-1.5
					C393.53,186.76,397.87,179.92,396.56,188.17z"
            />

            <path
              class="st18"
              d="M380.56,189.67c0.22,3.46-1.79,5.84-5.5,5.5c-0.87-0.86-1.66-1.58-2.5-2.5c1.2-2.75,6.65-1.53,7.25-4
					C380.61,189.26,380.49,189.68,380.56,189.67z"
            />

            <path
              class="st13"
              d="M382.56,197.67c1.67,2.52,1.88,2.79,5,2.5c-1.12,1.43-2.17,2.78-2,4.75c-0.42-0.45-1.09-0.53-1.5-0.75
					c-1.32-0.72-1.05-2.84-5-0.5c-1.04-1.64-0.52-3.36-4.5-2c0.91-0.59,2.06-1.48,3-2c0.06-0.03,0.94-0.97,1-1
					C378.74,198.57,381.17,198.4,382.56,197.67z"
            />

            <path
              class="st19"
              d="M384.06,204.17c0.67,5.83-2.66,8.52-1,19c-1.98,0.06-0.43-7.97-1.5-13.25c-0.2-0.97-1.89-4.68-2.5-5.75
					c-0.07-0.13,0.07-0.38,0-0.5C383.01,201.33,382.74,203.45,384.06,204.17z"
            />

            <path
              class="st51"
              d="M242.56,326.17c2.54,1.04,4.89,2.06,7.5,3c0.55,5.41-5.43,2.32-9,2c-4.13-2.88-3.29-5.23-3.5-5.5
					C239.74,323.16,240.07,325.15,242.56,326.17z"
            />

            <path
              class="st63"
              d="M266.56,345.17c1.46,0.99,4.27,1.15,6,1c-1.91,1.37-0.52,1.42-0.5,1.5c0.1,0.29,1,0.49,1.5,3.5
					c-6.67-2.45-12.75-5.16-19-8.5c-0.3-0.25-0.6-0.67-1-1C256.2,335.37,256.83,346.98,266.56,345.17z"
            />

            <path
              class="st58"
              d="M273.56,351.17c0.16,0.06,0.56,0.72,3,1.5c-0.4,0.96-4.16-0.21-5-0.5c-2.37-0.81-6.07-3.56-8-2.5
					c-0.15-0.12-0.81-0.37-1-0.5c-1.29-0.9-1.91-0.93-2-1c-0.75-0.5-0.75-0.5-1.5-1c-0.42-0.35-1.07-0.66-1.5-1
					c-0.93-0.75-2.11-2.78-3-3.5C260.81,346.01,266.89,348.72,273.56,351.17z"
            />

            <path
              class="st51"
              d="M361.06,219.67c-3.49-0.28-4.56,0.34-7.5,1c-2.87-1.6-5.13-4.1-5.5-7.5
					C352.42,214.26,358.35,216.06,361.06,219.67z"
            />

            <path
              class="st52"
              d="M379.06,203.67c0.07,0.12-0.07,0.37,0,0.5c-3.58-2.35-9.52,0.73-4.5-2.5
					C378.53,200.3,378.02,202.03,379.06,203.67z"
            />

            <path
              class="st6"
              d="M378.56,198.67c-0.06,0.03-0.94,0.97-1,1c0-0.75,0-0.75,0-1.5C377.6,198.21,378.3,198.59,378.56,198.67z"
            />

            <g>
              <path
                class="st64"
                d="M367.06,140.67c1.75,4.07,4.91,6.93,3,12c-1.35-0.1-3.7-0.14-5,0c1.62-2.66-2.58-2.32-5-3
						c2.08-3.36,2.39-7.48,2.5-11.25C362.69,141.29,368.52,146.14,367.06,140.67z"
              />

              <g>
                <path
                  class="st26"
                  d="M347.06,151.17c-2.81,9.47-23.4,12.71-32.5-0.25c-0.7-1-1.02-2.18-1.5-3.25c1.23-0.86-0.55-2.95,2-2.5
							c0.19,0.3,4.86,4.05,5.5,4.5c9.88,6.9,19.34,5.62,23.5-6.25C349.41,139.33,348.47,146.39,347.06,151.17z"
                />

                <g>
                  <path
                    class="st2"
                    d="M363.56,132.67c-2.88-6.74-13.57-14.73-20.25-17c-11.8-4-1.23,0.81,2.25,5.25
								c6.59,8.41,6.21,21.01,1.5,30.25c1.42-4.77,2.35-11.84-3-7.75c-4.16,11.87-13.62,13.15-23.5,6.25
								c-0.42-2.07,0.04-3.09,0-3.25c-3.55-15.9-9.58-7.89-5.5-1.25c-2.55-0.45-0.77,1.64-2,2.5c-0.99-2.19-1.8-2.94-2-6
								c-0.62-9.62,4.67-21.55,12.75-27c17.99-12.13,41.2,4.69,44.25,24.25C365.81,135.79,365.81,135.79,363.56,132.67z"
                  />

                  <path
                    class="st27"
                    d="M320.56,149.67c-0.64-0.45-5.31-4.2-5.5-4.5c-4.08-6.64,1.95-14.65,5.5,1.25
								C320.59,146.58,320.14,147.6,320.56,149.67z"
                  />

                  <path
                    class="st27"
                    d="M335.31,131.67c4.71-1.28,4.51,7.46-0.5,6C331.91,136.82,333.43,132.17,335.31,131.67z"
                  />
                </g>
              </g>

              <path
                class="st65"
                d="M365.06,152.67c-6.98,0.74-7.8,3.64-13,7c-3.81,2.46-2.95,3.11-7.5,0.75c4.02-0.73,13.69-7.82,15.5-10.75
						C362.47,150.35,366.67,150.01,365.06,152.67z"
              />

              <g>
                <path
                  class="st27"
                  d="M363.56,132.67c0.92,2.76,2.35,5.33,3.5,8c1.47,5.48-4.37,0.62-4.5-2.25c-0.11,3.77-0.42,7.89-2.5,11.25
							c-1.81,2.93-11.48,10.02-15.5,10.75c4.55,2.36,3.69,1.71,7.5-0.75c-0.17,1.35-0.96,3.57-1,4c-10.41,3.9-24.39,0.61-34-5
							c-6.57-5.59-5.3-5.56-10-11.5c-0.98-3.79-1.49-8.66-1-12.5c0.01-0.08,1.39,0.21,1.5-0.25c-1.23-0.08-1.27-2.08-1-2.5
							c1.81-2.79,1.35,5.55,3,4.5c0.02,1.56-0.32,5.17,1.5,5.25c0.2,3.06,1.01,3.81,2,6c0.48,1.07,0.8,2.25,1.5,3.25
							c9.1,12.96,29.69,9.72,32.5,0.25c4.71-9.24,5.09-21.84-1.5-30.25c-3.48-4.44-14.05-9.25-2.25-5.25
							C349.99,117.93,360.68,125.92,363.56,132.67z"
                />

                <path
                  class="st20"
                  d="M351.06,163.67c-0.01,0.07-0.01,1.43,0,1.5c-12.5,4.55-24.14,1.89-34-6.5
							C326.67,164.27,340.65,167.57,351.06,163.67z"
                />

                <path
                  class="st6"
                  d="M306.06,134.67c-0.49,3.84,0.02,8.71,1,12.5c-2.46-3.01-2.64-10.17-1.25-13.5
							C305.93,134.17,305.93,134.17,306.06,134.67z"
                />

                <path
                  class="st64"
                  d="M357.31,134.17c0.73,5.33,0.26,11.34-3.5,15.5c2.33-5.18,3.47-7.86,3.25-13.75
							C357.04,135.54,355,136.05,357.31,134.17z"
                />
              </g>
            </g>

            <g>
              <g>
                <path
                  class="st26"
                  d="M263.56,152.67c-0.34,0.28-0.76,0.6-1,1c-12,2.83-16.07-13.1-14-22.5
							C249.47,141.09,254.03,148.93,263.56,152.67z"
                />

                <g>
                  <path
                    class="st2"
                    d="M276.56,133.67c-2.97,3.24-8.49,13.64-10.5,18c-0.89,0.1-1.79,0.42-2.5,1
								c-9.53-3.74-14.09-11.57-15-21.5c0.81-3.68,2.8-5.59,5-8.5c0.25,0,0.25,0,0.5,0c-1.17,3.15-2.44,9.67,2.25,10.5
								c7.43,1.32,0.13-8.84,15.25-13.75c1.05-2.56-7.83-9.51-15.25-0.75c-1.31-0.86-0.06-1.22-0.25-1.5
								c0.7-3.58,10.13-8.32,13.25-8C277.28,110,279.37,128.1,276.56,133.67z"
                  />

                  <path
                    class="st27"
                    d="M266.81,136.67c9.17-2.1,2.66,9.97-2.5,8.5C259.81,143.88,263.83,137.35,266.81,136.67z"
                  />
                </g>
              </g>

              <g>
                <path
                  class="st27"
                  d="M254.06,122.67c0.23-0.62,3.15-4.83-0.5,0c-2.2,2.91-4.19,4.82-5,8.5c-2.07,9.4,2,25.33,14,22.5
							c-0.68,1.15,1.02,2.37-6.5,9.5c-0.1-0.28,0.01-1.25,0-2c-0.01-1.7,0.47-3.38,1.5-4.75c-0.38-0.38-0.38-0.38-0.75-0.75
							c-3.01-0.78-7.23-5.49-10.25-4c-3.53,1.75-8.38,13.3-3,25c0.14,0.31-0.14,1.24,0,1.5c-1,1-1,1-2,2
							c-6.27-10.81-4.09-22.2,4-31.25c-0.46-3.91-1.62-7.79-1.5-11.75c0.19-6.33,1.98-8.17,3-12c0.21-0.77-0.01-0.48,0-0.5
							c0.31-1.11,1.13-2.37,1.5-3.5c2.62-2.75,2.62-2.75,5.25-5.5c1.03-0.68,1.31,0.11,2.25,1.5c0.19,0.28-1.06,0.64,0.25,1.5
							c7.42-8.76,16.3-1.81,15.25,0.75c-15.12,4.91-7.82,15.07-15.25,13.75C251.62,132.33,252.89,125.82,254.06,122.67z"
                />

                <path
                  class="st66"
                  d="M247.06,124.67c-0.01,0.02,0.21-0.27,0,0.5c-0.5-0.25-0.5-0.25-1-0.5
							C246.23,124.59,246.7,124.71,247.06,124.67z"
                />

                <path
                  class="st67"
                  d="M254.06,122.67c-0.25,0-0.25,0-0.5,0C257.2,117.84,254.29,122.04,254.06,122.67z"
                />

                <path
                  class="st68"
                  d="M260.31,155.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
							s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
							C260.18,155.79,260.18,155.79,260.31,155.67z"
                />
              </g>
            </g>

            <g>
              <path
                class="st51"
                d="M282.56,324.17c1.87,1.64,10.4,2.67,13,2.5c0.07,3.98,3.64,2.68,1.5,5.5c-6.27,1.22-12.59-0.22-18.75-1.5
						c-0.39,2.51,4.99,2.74,8.25,3c-1.64,4.8-22.52,4.22-22,9.75c0.08,0.82,1.37,1.32,2,1.75c-9.73,1.82-10.36-9.8-13-3.5
						c-2.24-1.86-8.81-4.32-12.5-10.5c3.57,0.32,9.55,3.41,9-2c0.43,0.15,4.09,0.39,6,1c0.95,0.3,8.83,6.73,18.75,4.5
						c8.84-1.99-2.6-4.61-4-6c-0.54-0.54,0.62-0.59-0.75-2.5C271.67,320.7,278.17,327.91,282.56,324.17z"
              />

              <path
                class="st52"
                d="M297.06,332.17c-2,2.63-7.49,1.74-10.5,1.5c-3.26-0.26-8.64-0.49-8.25-3
						C284.47,331.94,290.79,333.39,297.06,332.17z"
              />

              <path
                class="st19"
                d="M273.81,325.17c2.88,2.12,2.88,2.12,5.75,4.25C276.95,329.68,272.08,326.28,273.81,325.17z"
              />
            </g>

            <path
              class="st19"
              d="M264.56,100.67c-0.87,1.52-0.96-1.64-0.25-1.5C264.62,99.23,264.67,100.47,264.56,100.67z"
            />

            <path
              class="st7"
              d="M277.06,345.17c-1.72,0.87-2.95,2.19-5,2.5c-0.02-0.08-1.41-0.13,0.5-1.5
					C272.79,346.15,274.08,344.76,277.06,345.17z"
            />

            <path
              class="st7"
              d="M280.06,343.67c-0.36,1.23-1.25,0.91-1.5,1C278.77,343.8,279.27,343.71,280.06,343.67z"
            />

            <g>
              <path
                class="st2"
                d="M300.56,162.17c8.33,0.94,16.53,4.69,13,2c0-0.25,0-0.25,0-0.5c0.6,0.43,7.9,4.64,7.5,5.25
						c-4.48,0.27-2.41-1.88-7,0.25c-0.94,0.12-2.16-0.17-3,0c-1.08-2.03-1.35-1.28-3-0.5c-5.75-2.91-10.42,1.38-15.5,3.5
						c-1.63-5.44,2.89-6.13,3.5-10C297.53,162.28,299.1,162,300.56,162.17z"
              />

              <path
                class="st20"
                d="M293.06,155.67c0.23,0.81,1.38,0.37,0.75,1c-7.29-1.05-16.74-2.43-22.75,2.5c-2.01,0.68-5.58,2.13-1.5,3
						c-0.78-0.03-0.38,0.7-0.5,1c-0.28,0.71-0.5,0.46-0.5,0.5c-1.23-1.48-5.7-0.64-8,0c0.01-0.07-0.85-0.12-1-1
						c0.43-0.25,2.61-1.37,3-1.5c0.23-0.07,0.86,0.63,4.75-0.5c0.52-0.17-0.34-0.97-0.5-1c-0.6-0.1-8.64,2.63,5-2.5
						c0.51-4.31,8.18-6.25,10.75-8C287.81,152.42,287.81,152.42,293.06,155.67z"
              />

              <path
                class="st21"
                d="M268.56,166.17c0.33,1.01,3.46,2.58,9,19c1.25,3.72,3.77,9.52,2.5,11c-7.76-11.26-8.72-17.39-13-30
						C267.47,166.27,268.08,166.1,268.56,166.17z"
              />

              <path
                class="st21"
                d="M282.06,129.67c0.29,1.35-0.94,2.39-1,3c-3.28,2.7-6.7,6.96-7,11.5c-1.67,2.99-1.4,3.81-1.5,4
						c-3.01,5.36-1.33-0.39-5.5,5.75c-0.57,0.84-1.17,1.47-2,0.75c0.39-0.97,0.54-2.01,1-3c2.01-4.36,7.53-14.76,10.5-18
						C278.19,131.89,280.03,130.91,282.06,129.67z"
              />

              <path
                class="st6"
                d="M311.06,169.17c-1.61,0.33-11.15,9.17-13,11c-6.68,6.58-10.12,10.62-14.5,19c-0.79,0.04-0.38-0.77-0.5-1
						c4.03-9.28,10.46-16.46,17-24c1.58-1.17,7.08-5.07,8-5.5C309.7,167.89,309.98,167.14,311.06,169.17z"
              />

              <path
                class="st69"
                d="M266.06,151.67c-0.46,0.99-0.61,2.03-1,3c-0.87,2.15-2.15,4.14-2.5,6.5c-0.39,0.13-2.57,1.25-3,1.5
						c-2.92,1.73-0.45,1.5-1.25,2c-0.76,0.48-2-0.8-2.25-1.5c7.52-7.13,5.82-8.35,6.5-9.5c0.24-0.4,0.66-0.72,1-1
						C264.26,152.09,265.17,151.77,266.06,151.67z"
              />

              <path
                class="st20"
                d="M280.56,184.67c0.65,2.87,0.97,5.9,2.5,8.5c-1.12,2.84-1.51,2.19,0,5c0.12,0.23-0.29,1.04,0.5,1
						c-0.57,1.09-0.51,1.95-0.75,2c-0.87-1.66-1.69-3.46-2.75-5c1.27-1.48-1.25-7.28-2.5-11
						C279.06,184.92,279.06,184.92,280.56,184.67z"
              />

              <path
                class="st21"
                d="M311.06,169.17c0.84-0.17,2.06,0.12,3,0c-4.26,1.97-13.91,11.08-14.75,11.5c-0.3,0.15-1.31,0.13-1.25-0.5
						C299.91,178.34,309.44,169.5,311.06,169.17z"
              />

              <path
                class="st14"
                d="M268.56,163.67c-0.02,0.12-0.04,2.38,0,2.5c-0.48-0.06-1.08,0.11-1.5,0c-1.82-0.47-3.4-1.57-7.25-1
						c-0.89-1.13,0.69-0.77,0.75-1.5C262.85,163.03,267.32,162.19,268.56,163.67z"
              />

              <path
                class="st70"
                d="M296.06,162.17c-0.61,3.87-5.13,4.56-3.5,10c-4.55,1.9-9.01,3.97-13.5,6c-1.39-4.44-5.66-17.47-10-15
						c0.12-0.3-0.28-1.03,0.5-1C270.85,162.44,283.31,161.19,296.06,162.17z"
              />

              <path
                class="st23"
                d="M308.06,168.67c-0.92,0.43-6.42,4.33-8,5.5c-3.14,2.34-5.32,4.12-8,7c-6,0.5-6,0.5-12,1
						c-0.34-1.37-0.57-2.63-1-4c4.49-2.03,8.95-4.1,13.5-6C297.63,170.04,302.31,165.76,308.06,168.67z"
              />

              <path
                class="st20"
                d="M296.56,153.67c1.25,1.39,2.07,3.06,3.25,4.5c2,0.48,3.94,1.58,5.75,2.5c0.71,0.36,1.26,0.66,2,1
						c1.97,0.91,3.81,2.13,6,2.5c3.53,2.69-4.67-1.06-13-2c-3.97-5.14-24.26-4.78-29.5-3c6.01-4.93,15.46-3.55,22.75-2.5
						c0.63-0.63-0.52-0.19-0.75-1c-0.3-1.07-8.4-9.85-9.5-8.5C291.13,141.58,288.19,144.38,296.56,153.67z"
              />

              <path
                class="st71"
                d="M300.56,162.17c-1.45-0.16-3.03,0.11-4.5,0c-12.75-0.97-25.2,0.28-26.5,0c-4.08-0.87-0.51-2.32,1.5-3
						C276.29,157.38,296.59,157.03,300.56,162.17z"
              />

              <path
                class="st72"
                d="M289.56,132.17c0.38,0.66,1.26,5.99,4.5,14.5c0.85,2.24,1.33,4.81,2.5,7c-8.37-9.28-5.43-12.08-13-6.5
						c-0.78,0.57-0.47,1.64-1,2c-2.57,1.75-10.24,3.69-10.75,8c-13.64,5.13-5.6,2.4-5,2.5c0.16,0.03,1.02,0.83,0.5,1
						c-3.89,1.13-4.52,0.43-4.75,0.5c0.35-2.36,1.63-4.35,2.5-6.5c0.83,0.72,1.43,0.09,2-0.75c4.17-6.14,2.49-0.39,5.5-5.75
						c4.09-6.16,13.46-11.75,15.5-14.25C288.8,133,286.06,132.27,289.56,132.17z"
              />

              <path
                class="st13"
                d="M279.06,178.17c0.43,1.37,0.66,2.63,1,4c0.19,0.78,0.32,1.7,0.5,2.5c-1.5,0.25-1.5,0.25-3,0.5
						c-5.54-16.42-8.67-17.99-9-19c-0.04-0.12-0.02-2.38,0-2.5c0-0.04,0.22,0.21,0.5-0.5C273.4,160.7,277.67,173.73,279.06,178.17z"
              />

              <path
                class="st73"
                d="M293.06,155.67c-5.25-3.25-5.25-3.25-10.5-6.5c0.53-0.36,0.22-1.43,1-2
						C284.65,145.81,292.76,154.6,293.06,155.67z"
              />

              <g>
                <path
                  class="st56"
                  d="M289.56,132.17c-3.5,0.11-0.75,0.83-1.5,1.75c-2.04,2.5-11.41,8.09-15.5,14.25c0.1-0.19-0.17-1.01,1.5-4
							c2.46-4.39,1.57-5.81,8.5-10C285.01,132.68,288.36,130.09,289.56,132.17z"
                />

                <path
                  class="st17"
                  d="M281.06,132.67c-0.18,1.94,1.55-0.65,1.5,1.5c-6.93,4.19-6.04,5.61-8.5,10
							C274.36,139.63,277.78,135.37,281.06,132.67z"
                />
              </g>

              <path
                class="st74"
                d="M300.06,174.17c-6.54,7.54-12.97,14.72-17,24c-1.51-2.81-1.12-2.16,0-5c0.61-1.55,7.49-10.37,9-12
						C294.73,178.29,296.91,176.5,300.06,174.17z"
              />

              <path
                class="st51"
                d="M291.56,128.17c2.29,6.6,4.55,13.15,7.5,19.5c2.44,5.25,4.36,9.66,8.5,14c-0.74-0.34-1.29-0.64-2-1
						c-4.67-4.28-7.85-8.08-10-14c-1.55-4.26-3.49-13.89-5-19C290.93,127.64,291.03,128.01,291.56,128.17z"
              />

              <path
                class="st23"
                d="M292.06,181.17c-1.51,1.63-8.39,10.45-9,12c-1.53-2.6-1.85-5.63-2.5-8.5c-0.18-0.8-0.31-1.72-0.5-2.5
						C286.06,181.67,286.06,181.67,292.06,181.17z"
              />

              <path
                class="st13"
                d="M290.56,127.67c1.51,5.11,3.45,14.74,5,19c-0.75,0-0.75,0-1.5,0c-3.24-8.51-4.12-13.84-4.5-14.5
						c-1.2-2.08-4.54,0.51-7,2c0.05-2.15-1.68,0.44-1.5-1.5C283.04,131.03,288.02,127.83,290.56,127.67z"
              />

              <path
                class="st15"
                d="M295.56,146.67c2.15,5.92,5.33,9.72,10,14c-1.81-0.92-3.75-2.02-5.75-2.5c-1.18-1.44-2-3.11-3.25-4.5
						c-1.17-2.19-1.65-4.76-2.5-7C294.81,146.67,294.81,146.67,295.56,146.67z"
              />
            </g>
          </g>

          <path
            class="st75"
            d="M135.56,229.17c0.83-8.17,0.03-5.3-2-5.5c0.88-2.4,9.6-0.8,9,2.25
				C142.48,226.3,136.61,228.51,135.56,229.17z"
          />

          <g>
            <path
              class="st13"
              d="M270.56,395.17c9.15,1.04,24.64-3.81,28,8c-1.28,1.83-5.19-1.47-10.75-2.5c-1.72,0.73,9.94,3.33,4.5,4
					c-1.7,0.21-15.91-7.72-32.5,4c-1.48,1.05-1.33,3.17-3.75,2.5c0.19-0.26,0.35-2.98,3.25-5.5c5.88-3.12,5.88-3.12,11.75-6.25
					c-0.75-2.38-0.75-2.38-1.5-4.75C270,394.64,270.06,395.11,270.56,395.17z"
            />

            <path
              class="st20"
              d="M293.06,390.17c0.27,0.08,0.92,1.67,5.25,2c1.28,1.45,1.55,1.59,2.25,3.5c0.85,2.33,0.51,8.73,2.5,12
					c-1.87,6.1-0.93,3.92-0.5,4.5c0.24,0.32,0.39,1.02,1,1c-1.42,0.88-1.9,2.75-4,3c0.6-1.68-0.01-1.43,0-1.5
					c0.45-3.22-0.12-8.43-1-11.5c-3.36-11.81-18.85-6.96-28-8c1.83-3.45,5.54-4.48,9-5c1.89-0.28,8.16,1.47,7-1
					C289.57,389.47,289.74,389.18,293.06,390.17z"
            />

            <path
              class="st19"
              d="M269.06,394.67c0.25,0,0.25,0,0.5,0c0.75,2.38,0.75,2.38,1.5,4.75c-5.88,3.12-5.88,3.12-11.75,6.25
					c-2.9,2.52-3.06,5.24-3.25,5.5c-0.52,0.73-0.74,0.99-1.5,1.5c-5.65-3.08,0.86-12.84,4-16c0.96,4.36,5.14-2.99,6.75,0.5
					C266.48,396.19,267.77,395.47,269.06,394.67z"
            />

            <path
              class="st53"
              d="M262.56,390.67c-0.93,0.88-2.01,1.62-2,1.75c0.02,0.23,1.74,0.27,1.5,1.75c-1.03,0.96-2.46,1.46-3.5,2.5
					c-3.14,3.16-9.65,12.92-4,16c-4.5,3-4.85-6.42-4-9.5c0.12-0.44,3.28-5.57,4-6.5c1.12-1.45,2.34-2.46,4-3.25
					c-0.12-0.62-0.12-0.62-0.25-1.25c-6.56,1.59-13.94,0.01-20.25,2.5c-0.5-0.75-0.5-0.75-1-1.5c7.62-2.68,20.05-1.43,23.25-2.5
					C261.9,390.13,261.36,386.78,262.56,390.67z"
            />

            <path
              class="st7"
              d="M254.56,396.67c-0.72,0.93-3.88,6.06-4,6.5c-4.25-2.89-9.58-1.16-14,0.5c-1.75-0.75-1.75-0.75-3.5-1.5
					C240.14,399.03,246.5,396.58,254.56,396.67z"
            />

            <path
              class="st20"
              d="M233.06,402.17c1.75,0.75,1.75,0.75,3.5,1.5c-3.96,1.49-8.25,5.06-11.75,7.5
					c-0.38-0.38-0.38-0.38-0.75-0.75c0.84-0.86,0.73-2.22,1-3.25c1.36,1.31,2.55-2.59,4-4.5
					C230.86,403.47,231.41,402.9,233.06,402.17z"
            />

            <path
              class="st63"
              d="M238.06,394.67c-3.32,1.31-6.88,5.22-9,8c-1.45,1.91-2.64,5.81-4,4.5c0.26-1.01,2.1-5.86,2.5-6.5
					c1.63-2.65,6.51-6.45,9.5-7.5C237.56,393.92,237.56,393.92,238.06,394.67z"
            />

            <path
              class="st6"
              d="M271.06,352.67c3.17,0.84,6.95,3.7,10.25,4.5c5.23,1.27,11.36-0.76,9.25,2c-1.81,1.39-3.67,3.31-5.5,4.75
					c-0.58,5.77-1.57,11.63-3,17.25c-0.77,3.02-2.31,5.78-2.5,9c-3.46,0.52-7.17,1.55-9,5c-0.5-0.06-0.56-0.53-1-0.5
					c-0.25,0-0.25,0-0.5,0c0.41-0.26,5.32-4.84,5.5-5.25c0.83-1.79,0.92-5.94,1-6.25c0.06-0.23,1.19-2.15,1.75-4.5
					c1.3,10.2,4.11-5.32,4.25-15.25c-1.43-0.93-4.48-1.5-5.5-2.25c-0.11-0.08-1.02-1.19-2-2c-2.49-2.06-3.68-3.64-5.5-6.25
					C268.46,351.6,269.68,352.3,271.06,352.67z"
            />

            <path
              class="st53"
              d="M276.06,361.17c-1,0.12-0.26,2.61-0.5,5c-0.34,3.42-3.98,16.92-5.5,20c-3.19,6.47-5.35,5.52-8,8
					c0.24-1.48-1.48-1.52-1.5-1.75c-0.01-0.13,1.07-0.87,2-1.75c0.17-0.16,1.31-0.21,3.5-3c0.04-0.06,0.47-0.15,1-1
					c3.58-5.76,5.17-20.22,7-27.5C275.03,359.98,275.94,361.08,276.06,361.17z"
            />

            <path
              class="st76"
              d="M267.06,386.67c-0.53,0.85-0.96,0.94-1,1C264.6,385.96,265.05,385.66,267.06,386.67z"
            />

            <path
              class="st14"
              d="M286.56,389.17c1.16,2.47-5.11,0.72-7,1c0.19-3.22,1.73-5.98,2.5-9c0.19,1.58-0.27,7.37,0,7.75
					C282.44,389.45,285.66,389.08,286.56,389.17z"
            />

            <path
              class="st20"
              d="M275.56,383.17c-0.08,0.31-0.17,4.46-1,6.25c-0.18,0.41-5.09,4.99-5.5,5.25c-1.29,0.81-2.57,1.53-3.75,2.5
					c-1.61-3.49-5.79,3.86-6.75-0.5c1.04-1.04,2.47-1.54,3.5-2.5c2.65-2.48,4.81-1.53,8-8c0.25,1.25,0.25,1.25,0.5,2.5
					c-3.49,3.75,3.46,0.02,2-1.5c1.24-1.68,1.89-3.02,2.5-5C275.31,382.67,275.31,382.67,275.56,383.17z"
            />

            <path
              class="st21"
              d="M254.56,396.67c-8.06-0.09-14.41,2.37-21.5,5.5c-1.65,0.73-2.19,1.31-4,0.5c2.12-2.78,5.68-6.69,9-8
					c6.31-2.49,13.69-0.91,20.25-2.5c0.12,0.62,0.12,0.62,0.25,1.25C256.9,394.2,255.68,395.22,254.56,396.67z"
            />

            <path
              class="st13"
              d="M275.56,383.17c-0.25-0.5-0.25-0.5-0.5-1c1.94-6.27,0.44-8.11,0.5-9.25c0.08-1.48,2.53-6.52,0-6.75
					c0.24-2.39-0.5-4.88,0.5-5c1.02,0.75,4.07,1.32,5.5,2.25c-0.14,9.93-2.95,25.45-4.25,15.25
					C276.74,381.02,275.62,382.93,275.56,383.17z"
            />

            <path
              class="st20"
              d="M275.06,382.17c-0.61,1.98-1.26,3.32-2.5,5c-0.15,0.2-1.69,1.17-2,1.5c-0.25-1.25-0.25-1.25-0.5-2.5
					c1.52-3.08,5.16-16.58,5.5-20c2.53,0.23,0.08,5.27,0,6.75C275.49,374.06,277,375.9,275.06,382.17z"
            />

            <path
              class="st13"
              d="M270.56,388.67c0.31-0.33,1.85-1.3,2-1.5C274.01,388.68,267.07,392.42,270.56,388.67z"
            />
          </g>

          <g>
            <g>
              <path
                class="st39"
                d="M205.56,274.17c-0.19,0.54-0.3,1.48-0.5,2c-0.69,1.81-1.23,3.71-2,5.5c-1.36,3.16-3.51,6.36-5,9.5
						c-2.31-0.5-4.09,1.03-6-0.5c-0.22-1.39-0.48-0.95-0.5-1c-0.61-1.72-0.98-1.89-1-2c-0.53-2.49-0.94-6.09,0-8.5
						c-0.59-1.74-2.74-1.23-3.5-1.5c-3.42-6.06,4.66-0.13,5.75,2c4.01-5.65,4.55-1.77,6-2.5
						C199.43,276.85,201.49,269.3,205.56,274.17z"
              />

              <path
                class="st77"
                d="M207.56,216.67c0.59,0.19,3.95,2.76,6.5,3c4.07,5.23,8.13,4.96,5.5,10c-1.37,2.62-5.89,5.06-0.75,6.5
						c-9.82,1.37-15.59,2.16-23.25-5c0.72-0.14,2.76-2.9,4-3.5c5.34-2.57,13.28,1.86,9-1.5c-0.31-0.17-0.4-0.85-0.5-1
						c-0.02-0.04,0.94-0.16,0.5-0.75c-0.91-1.22-8.9-8.6-11-8.25c-0.13-0.07-1.04,0.49-2.5-1.5c1.45-0.14,2.75-0.74,4.25-0.5
						C202.15,214.77,204.81,215.76,207.56,216.67z"
              />

              <path
                class="st77"
                d="M195.06,214.67c1.46,1.99,2.37,1.43,2.5,1.5c3.93,2.22,7.27,5.9,10.5,9c0.1,0.15,0.19,0.83,0.5,1
						c-4.38,0.48-9.61-1.81-9,1.5c-1.24,0.6-3.28,3.36-4,3.5c-0.16,0.03-0.34-0.02-0.5,0c-8.75-2.75-8.75-2.75-17.5-5.5
						c0.34-3.47-5.74-5.23,8-9C187.27,216.2,193.87,214.78,195.06,214.67z"
              />

              <path
                class="st77"
                d="M222.06,236.67c-1.29,2.61-3.07,5.8-4,8.5c-3.42-0.2-19.47-2.53-20.5-2.5c-0.98-5.54-2.66,0.66-3.5-1.25
						c1.5-2.18,4.97-3.61,4.5-6.25c0.61,0.49,0.64,1.94,2.25,3C211.01,242.97,214.82,236.33,222.06,236.67z"
              />

              <path
                class="st33"
                d="M225.56,229.67c-1.22,2-2.41,4.81-3.5,7c-7.23-0.34-11.04,6.3-21.25,1.5c-1.61-1.06-1.64-2.51-2.25-3
						c-1.28-1.01-2.55-2.65-4-3.5c0.25-0.25,0.25-0.25,0.5-0.5c0.16-0.02,0.34,0.03,0.5,0c7.66,7.16,13.43,6.37,23.25,5
						c-5.14-1.44-0.62-3.88,0.75-6.5c1.25-1.25,1.25-1.25,2.5-2.5C222.2,227.33,225.04,229.11,225.56,229.67z"
              />

              <path
                class="st39"
                d="M226.56,221.67c0.32,0.05,0.67-0.04,1,0c0.5,0,0.5,0,1,0c1.07,0.58,1.79,0.4,1.5,2
						c-1.23,1.66-4.01,5.19-4.5,6c-0.52-0.56-3.35-2.34-3.5-2.5c-0.79-0.87-3.47-5.32-4.5-6.5
						C220.55,220.43,223.61,221.25,226.56,221.67z"
              />

              <path
                class="st34"
                d="M198.06,291.17c0.22,0.05,3.54,1.56,4,2c0.33,2.73,2.19,4.79,5,4.5c-0.01,0.33,0.02,0.67,0,1
						c-1.97-0.55-5.07-2.16-6.25-1c-0.14-1.24-3.42-4.1-4.25-4.5c-1.59-0.76-2.19-0.32-3-0.5c-0.38-0.09-0.49-0.35-1.5-0.5
						c-0.04-0.49,0.07-1.02,0-1.5C193.97,292.2,195.75,290.67,198.06,291.17z"
              />

              <path
                class="st33"
                d="M204.06,281.67c-0.42,2.02-0.98,2.82,2,1.5c2.01,1.44-2.19,9.22-4,10c-0.46-0.44-3.78-1.95-4-2
						c1.49-3.14,3.64-6.34,5-9.5C203.56,281.67,203.56,281.67,204.06,281.67z"
              />

              <path
                class="st38"
                d="M207.06,297.67c-2.81,0.29-4.67-1.77-5-4.5c1.81-0.78,6.01-8.56,4-10c2.49-1.11,3.43-6.05,4.5-8.5
						c0.65-0.34,1.31-0.19,1.75-1C213.26,274.56,213.11,297.05,207.06,297.67z"
              />

              <path
                class="st39"
                d="M206.06,283.17c-2.98,1.32-2.42,0.52-2-1.5c0.56-2.69,4.14-5.75,6.5-7
						C209.49,277.12,208.54,282.06,206.06,283.17z"
              />

              <path
                class="st33"
                d="M215.56,219.67c0.6-0.12,1.68,0.63,2,1c1.03,1.18,3.71,5.63,4.5,6.5c-1.25,1.25-1.25,1.25-2.5,2.5
						c2.63-5.04-1.43-4.77-5.5-10C214.56,219.67,215.06,219.67,215.56,219.67z"
              />

              <path
                class="st78"
                d="M208.06,225.17c-3.23-3.1-6.57-6.78-10.5-9c2.1-0.35,10.09,7.03,11,8.25
						C209,225,208.03,225.13,208.06,225.17z"
              />

              <path
                class="st40"
                d="M208.56,226.17c4.28,3.36-3.66-1.07-9,1.5C198.95,224.36,204.18,226.65,208.56,226.17z"
              />

              <g>
                <path
                  class="st77"
                  d="M194.56,231.67c1.45,0.85,2.72,2.49,4,3.5c0.47,2.64-3,4.07-4.5,6.25c0.84,1.91,2.52-4.29,3.5,1.25
							c-0.42,0.01-0.83-0.01-1.25,0c0,0.5,0,0.5,0,1c6.79,2.32,14.1,2.25,21.25,2.5c-1.34,4.19-1.68,8.71-2.5,13
							c-6.81-1.42-6.77,4.43-10.75,7c-0.77,0.5-12.31,3.47-3.5,3.5c-1.82,6.15,2.54-2.67,4.5-3.5c6.32-2.67,1.42,4.66,0.25,8
							c-4.07-4.87-6.12,2.68-6.75,3c-1.45,0.73-1.99-3.15-6,2.5c-1.09-2.13-9.17-8.06-5.75-2c-5.4-1.91-7.92-1.15-9.5-8
							c6.22-10.83-8.19-1.36-7.5-14.5c0.02-0.33,0.45-2.86,0.5-3c1.71-5.3,7.74-4.99,2.5-7c1.01-5,2.03,2.63,13,2.25
							c-6.5-2.18-10.44-1.55-13-8.75c0.49-0.76,1.29-0.38,1-1.75c-0.24-0.72-3.38-0.37-1.5-6.25c0.42-0.22,3.86-3.27,4-3.5
							C180.89,226.82,191.05,229.61,194.56,231.67z"
                />

                <g>
                  <path
                    class="st33"
                    d="M197.56,242.67c1.03-0.03,17.08,2.3,20.5,2.5c-0.44,1.27-0.48,0.95-0.5,1
								c-7.15-0.25-14.46-0.18-21.25-2.5c0-0.5,0-0.5,0-1C196.72,242.66,197.14,242.68,197.56,242.67z"
                  />

                  <path
                    class="st35"
                    d="M195.06,231.17c-0.25,0.25-0.25,0.25-0.5,0.5c-3.51-2.05-13.66-4.85-18-4.5c0.31-0.5,0.96-1.11,1-1.5
								C186.31,228.42,186.31,228.42,195.06,231.17z"
                  />

                  <path
                    class="st77"
                    d="M173.06,245.17c-0.42-0.16-0.59-0.41-1-0.5c-0.09-0.64-0.29-1.4-0.5-2c-0.25-0.75-0.25-0.75-0.5-1.5
								c0.18-1.4,1.74-2.1,2-2.5c2.56,7.2,6.5,6.57,13,8.75C175.08,247.8,174.07,240.17,173.06,245.17z"
                  />

                  <path
                    class="st33"
                    d="M191.31,253.17c0.52-0.31,9.25,0.29,9.25,0.75c-6.02,0.23-5.48,3.65-6.25,3.75
								c-1.49,0.19,0.35-2.62,0.25-2.75C194.41,254.72,188.87,254.62,191.31,253.17z"
                  />

                  <path
                    class="st38"
                    d="M181.81,233.67c4.12,0.88,4.12,0.88,8.25,1.75C180.3,234.35,171.94,236.73,181.81,233.67z"
                  />

                  <path
                    class="st33"
                    d="M186.56,262.17c0.23-2.18,0.18-3.85,1.25-6C188.36,258.25,186.95,260.24,186.56,262.17z"
                  />

                  <path
                    class="st33"
                    d="M186.56,262.17c-0.15,1.47,0.31,3.07-0.25,4.5C185.55,265.09,186.25,263.67,186.56,262.17z"
                  />

                  <path
                    class="st77"
                    d="M191.81,244.67c0.81,0.14-0.21,1.14-0.25,1.25C190.05,250.2,190.69,244.47,191.81,244.67z"
                  />
                </g>
              </g>

              <g>
                <path
                  class="st33"
                  d="M215.06,259.17c-0.21,1.11-0.3,2.37-0.5,3.5c-0.44,2.51-0.71,4.71-0.5,7.25c-4.5,3.12-4.5,3.12-9,6.25
							c0.2-0.52,0.31-1.46,0.5-2c1.17-3.34,6.07-10.67-0.25-8c-1.96,0.83-6.32,9.65-4.5,3.5c-8.81-0.03,2.73-3,3.5-3.5
							C208.28,263.6,208.24,257.75,215.06,259.17z"
                />

                <path
                  class="st44"
                  d="M211.31,259.67c0.31-0.04,0.66-0.06,0.75,0.25C212.48,261.36,209.04,259.98,211.31,259.67z"
                />
              </g>
            </g>

            <g>
              <path
                class="st21"
                d="M142.56,208.67c0.72,4.25,1.34,4.62,4,1c1.16,0.41,2.32,1.08,3.5,1.5c6.33,2.27,28.12,7.72,24.25,15
						c-4.05-0.23-8.21,0.31-12.25,0c-1.81-0.14-2.39-0.47-4-1c-0.03-0.02,0.19-0.15-0.5-0.5c-3.44-1.72-5.31-2.01-9-2.5
						c-2.06-1.78-5.38-3.26-6.5-6c-0.28-0.69-0.46-3.79-0.5-5c-0.01-0.43-0.97-1.07,0-3C142.73,207.98,142.5,208.65,142.56,208.67z"
              />

              <path
                class="st17"
                d="M167.06,213.67c0.44,1.47,2.81,2.05,4,2.5c3.86,1.45,8.42,2.6,8,0c2.01-0.15,4.54-0.18,6.5-0.5
						c0,0.5,0,0.5,0,1c-13.74,3.77-7.66,5.53-8,9c-0.04,0.39-0.69,1-1,1.5c-0.14,0.23-3.58,3.28-4,3.5c-4.26,2.23-3.31-0.08-3.5,0
						c1.06-2.44-6.02-5.56-5.25-2.5c-0.87,0.11-1.95-0.16-2.75,0c-2.58-1.55-4.84-0.03-7,1c-1.01,0.48-5.11,4.11-5.75,4
						c-2.85-0.48,1.3-6.17,2.25-7c3.06-2.69,2.53,0.51,4.75,0c0.56-0.13-0.81-1.46,2.25-1.5c0.69,0.35,0.47,0.48,0.5,0.5
						c0.2,0.11,1.84,2.7,4,1c4.04,0.31,8.2-0.23,12.25,0c3.87-7.28-17.92-12.73-24.25-15C151.56,208.9,162.21,213.06,167.06,213.67z
						"
              />

              <path
                class="st53"
                d="M185.56,215.67c-1.96,0.32-4.49,0.35-6.5,0.5c-2.75,0.2-5.24,0.71-8,0c-1.19-0.45-3.56-1.03-4-2.5
						c7.7,0.96,15.53,0.26,23.25,0.5C189.25,215.41,187.02,215.43,185.56,215.67z"
              />

              <path
                class="st15"
                d="M146.56,222.17c0,2.25,0,2.25,0,4.5c-3.97,0.83-8.04,2.37-11.5,4.5c-0.1,0.06-0.48-0.2-2,1
						c-0.25-0.25-0.25-0.25-0.5-0.5c0.97-0.58,2.55-2.22,3-2.5c1.05-0.66,6.93-2.87,7-3.25c0.6-3.05-8.12-4.65-9-2.25
						c-2.39-0.24-4.36,0.67-4-1C133.91,220.72,141.43,221.61,146.56,222.17z"
              />

              <path
                class="st74"
                d="M135.06,231.17c1.3,1.7,3.77-0.84,1.5,4.5c-1.08,0.02-5.12,1.25-7,1.5c1.39-2.56,0.79-2.86,3.5-5
						C134.57,230.97,134.96,231.23,135.06,231.17z"
              />

              <path
                class="st58"
                d="M138.56,236.17c-1.5,1-1.5,1-3,2c-0.7-0.19-0.95,0.32-1.5,0.5c0.22-1.96-1.37-0.03-1.5,0
						c-0.95,0.21-1.27,0.07-2.5,0.5c-3.76,1.31-2.88,2.38-0.5-2c1.88-0.25,5.92-1.48,7-1.5
						C136.66,235.67,136.21,235.98,138.56,236.17z"
              />

              <path
                class="st9"
                d="M132.56,238.67c-0.08,0.02,0.22,0.73-1.5,0.5c-0.5,0-0.5,0-1,0C131.29,238.74,131.61,238.88,132.56,238.67
						z"
              />

              <path
                class="st22"
                d="M141.56,211.17c0.04,1.21,0.22,4.31,0.5,5c-3.98,1.1-10.31,1.95-12.5,6c-1.02,1.88-1,2.97-1.25,5
						c-0.38-2-0.38-2-0.75-4c0.09-1.5,0.42-3.1,0.5-4.5c2.54-0.99,4.85-1.77,7.5-2.5c1.7-0.47,2.81-0.02,4.5-0.25
						c0.38-1.54,0.28-3.22,0.5-4.75C141.06,211.17,141.06,211.17,141.56,211.17z"
              />

              <path
                class="st79"
                d="M148.56,239.67c0.34,0.01,6.01,2.26,6.25,2.5c1.98,1.98-0.44,1.27-0.75,1.5c-0.53,0.4-0.7,0.21-0.5,1
						c-0.91,0.65-4.62-1.62-6.75,2.5c-2.77-0.35-5.6,1.1-7.25,1.5c-1.27,0.31-2.68,0.56-4,0.5c0.02-0.5-0.02-1,0-1.5
						c0.79,0.78,2.35-0.08,3-0.5c2.26,0.54,15-4.52,11.75-5c-0.66-0.1-5.73,2.68-8.75,1.5c1.53-1.55-1.43-1.24,2.5-2
						c0.1,1.89,0.43,0.52,1,0C145.93,240.88,146.57,239.6,148.56,239.67z"
              />

              <path
                class="st80"
                d="M148.56,222.17c3.69,0.49,5.56,0.78,9,2.5c-3.06,0.04-1.69,1.37-2.25,1.5c-2.22,0.51-1.69-2.69-4.75,0
						c-1.35-0.09-2.7,0.23-4,0.5c0-2.25,0-2.25,0-4.5C147.21,222.24,147.91,222.08,148.56,222.17z"
              />

              <path
                class="st80"
                d="M162.06,226.17c-2.16,1.7-3.8-0.89-4-1C159.67,225.69,160.24,226.03,162.06,226.17z"
              />

              <path
                class="st21"
                d="M150.56,226.17c-0.95,0.83-5.1,6.52-2.25,7c0.64,0.11,4.74-3.52,5.75-4c2.26-0.7,5.15-0.64,7-1
						c0.8-0.16,1.88,0.11,2.75,0c-0.77-3.06,6.31,0.06,5.25,2.5c-3.01,1.24-4.63,4.46-14.75,4.5c-0.88,0-6.92-2.06-4.25,0
						c-1.51,1.73-2.92,1.24-2.5,3c-1.64-0.55-4.7-1.2-6.5-1.5c-0.91-0.15-1.39-0.41-2.5-0.5c-2.35-0.19-1.9-0.5-2-0.5
						c2.27-5.34-0.2-2.8-1.5-4.5c3.46-2.13,7.53-3.67,11.5-4.5C147.86,226.39,149.21,226.07,150.56,226.17z"
              />

              <path
                class="st16"
                d="M179.06,216.17c0.42,2.6-4.14,1.45-8,0C173.82,216.87,176.31,216.37,179.06,216.17z"
              />

              <path
                class="st15"
                d="M161.06,228.17c-1.85,0.36-4.74,0.3-7,1C156.22,228.14,158.47,226.61,161.06,228.17z"
              />

              <path
                class="st34"
                d="M147.56,238.17c0.07,0.02,0.93,0.98,1,1c0,0.25,0,0.25,0,0.5c-1.99-0.06-2.63,1.21-3.5,2
						c-0.32,0.03-0.69-0.06-1,0c-3.93,0.76-0.97,0.45-2.5,2c-0.16,0.16-1.5,2.54-3,3.5c-0.65,0.42-2.21,1.28-3,0.5
						c0.01-0.17-0.01-0.33,0-0.5c3.98-1.97,6.07-6.24,5.5-10.5C142.85,236.96,145.91,237.62,147.56,238.17z"
              />

              <path
                class="st81"
                d="M134.06,238.67c-0.36,0.12-1.04-0.1-1.5,0C132.68,238.64,134.27,236.7,134.06,238.67z"
              />

              <path
                class="st20"
                d="M159.56,239.67c-0.58,2.14-0.95,1.37-2,3c-0.25,0-0.25,0-0.5,0c-2.7-1.58-5.6-2.42-8.5-3.5
						c-0.07-0.02-0.93-0.98-1-1c-0.42-1.76,0.99-1.27,2.5-3c4.62,0.25,4.62,0.25,9.25,0.5C160.2,236,159.69,239.18,159.56,239.67z"
              />

              <path
                class="st59"
                d="M154.06,243.67c0.18,1.14-0.42,0.94-0.5,1C153.36,243.88,153.52,244.07,154.06,243.67z"
              />

              <path
                class="st73"
                d="M138.56,247.17c1.5-0.96,2.84-3.34,3-3.5c3.02,1.18,8.09-1.6,8.75-1.5
						C153.56,242.65,140.81,247.71,138.56,247.17z"
              />

              <path
                class="st82"
                d="M145.06,241.67c-0.57,0.52-0.9,1.89-1,0C144.36,241.61,144.73,241.69,145.06,241.67z"
              />

              <g>
                <path
                  class="st74"
                  d="M148.56,222.17c-0.65-0.09-1.35,0.07-2,0c-5.13-0.56-12.64-1.44-17,0.5c0-0.25,0-0.25,0-0.5
							c2.19-4.05,8.52-4.9,12.5-6C143.18,218.9,146.5,220.39,148.56,222.17z"
                />

                <path
                  class="st7"
                  d="M138.81,219.67c8.46,1.34,8.82,1.73,0,1C138.81,220.17,138.81,220.17,138.81,219.67z"
                />
              </g>

              <g>
                <path
                  class="st6"
                  d="M172.56,230.67c-1.88,5.88,1.26,5.53,1.5,6.25c0.29,1.37-0.51,0.99-1,1.75c-0.26,0.4-1.82,1.1-2,2.5
							c-0.22,1.74,0.47,1.43,0.5,1.5c0.21,0.6,0.41,1.36,0.5,2c-1.77-0.4-3.21,0.49-4,0.5c-0.33,0-0.56-0.02-1,0
							c-2.39,0.12-15.1,0.64-7,2.25c-2.16,0.51-4.32,1.03-3,4c1.07,2.41,12.83-1.23,13.5,0.75c-0.05,0.14-0.48,2.67-0.5,3
							c-4.75,0.16-12.57-1.8-13,0.5c-0.25,0-0.25,0-0.5,0c0.36-12.61-1.56-10.19-1.5-10.75c0.05-0.4,2.54-0.34,2-2.25
							c0.25,0,0.25,0,0.5,0c0,0.25,0,0.25,0,0.5c1.5,0,1.5,0,3,0c-0.49-1.79,4.13-0.68,3.5-2.25c-0.37-0.93-3.61-0.48-4.5-1.25
							c0.13-0.48,0.64-3.67-0.25-4c-4.62-0.25-4.62-0.25-9.25-0.5c-2.67-2.06,3.37,0,4.25,0c10.12-0.04,11.74-3.26,14.75-4.5
							C169.24,230.59,168.29,232.89,172.56,230.67z"
                />

                <g>
                  <g>
                    <path
                      class="st13"
                      d="M160.56,243.17c-1.5,0-1.5,0-3,0c0-0.25,0-0.25,0-0.5c1.05-1.63,1.42-0.86,2-3
									c0.89,0.77,4.13,0.32,4.5,1.25C164.68,242.49,160.07,241.38,160.56,243.17z"
                    />

                    <path
                      class="st20"
                      d="M166.31,234.17c5.99-0.71-2.51,2.88-2.75,2.25C162.82,235.91,166.11,234.19,166.31,234.17z"
                    />

                    <path
                      class="st78"
                      d="M171.56,242.67c-0.03-0.07-0.72,0.24-0.5-1.5C171.31,241.92,171.31,241.92,171.56,242.67z"
                    />
                  </g>

                  <g>
                    <path
                      class="st83"
                      d="M157.81,252.67c12.61,0.51,3.39,2.6,0,1.5C156.97,253.9,157.01,253.1,157.81,252.67z"
                    />

                    <path
                      class="st53"
                      d="M168.06,245.17c-0.5,0-0.5,0-1,0C167.5,245.15,167.73,245.17,168.06,245.17z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>

        <g>
          <path
            class="st4"
            d="M239.56,33.17c1.81,1.76,5.45,4.47,6.5,6.75c1.71,3.71-3.07,7.15,3.25,3.25c0.48,2.97,4.92,1.33,3.25,3.5
				c-40.91-6.6-82.02-12.21-122.75-19.5c-1.53,0.47-1.2,15.13-1.25,17.5c-2.19-0.14,0.5,3.87-3,3.5
				c-0.15-14.03,2.31-26.64-5.5-21.75c-0.04,26.42,0.06,52.83,0,79.25c-0.25,43.38-0.25,43.38-0.5,86.75c-0.5,0-0.5,0-1,0
				c0.42-5.85-2-11.65-5.5-16.25c0-2.5,0-5,0-7.5c0.01-30.49,0.6-61.03,0.5-91.5c-0.05-16.06-1-32.17-0.5-48.25
				c-0.5-0.12-0.5-0.12-1-0.25c-38.25,7.75-38.25,7.75-76.5,15.5c0-0.17,0-0.33,0-0.5c0-0.74,1.19,0.16,1-2.25
				c-2.18-2.61-0.9-7.42-4.5-8.25c4.52-1.82,28.7-6.73,36.5-8.5c2.75,2.45,3.05,0.03,3.25,0c18.7-2.67,36.85-7.53,55.5-10
				C164.79,20.52,202.29,26.22,239.56,33.17z"
          />

          <path
            class="st2"
            d="M36.56,210.17c0.25,52.63-1.01,105.4,0,158c0.04,2.29-0.58,14.1,0.75,15c6.89,0.89,13.84,0.96,20.75,1.5
				c7.16,0.56,14.34,1.05,21.5,1.5c-0.01,1.61,3.56,1.79,3,0c11.75,0.66,28.94,0.78,37.25,1.5c0.13,0.01,1.18,1.35,2.25,1.5
				c-0.19,3.5,0.07,7,0,10.5c-22.69,0.04-50.99-4.94-73-3c-2.4,0.21-6.66-0.9-8,1.5c-2.19-0.93-6.92,1.58-7.5-1.5
				c2.8-13.78-3.7-9.44-4.5-11.25c-0.06-61.25-0.48-122.5-0.5-183.75C35.39,201.89,33.14,205.57,36.56,210.17z"
          />

          <path
            class="st4"
            d="M256.56,34.67c1.81,0.39,3.73,0.59,5.5,1c-0.12,2.73,7.12,4.69,8.5,2c1,0.34,4.16,0.93,4.5,1.75
				c0.51,15.06-1.12,30.35,1,45.25c-0.7,0.16-0.47,0.49-0.5,0.5c-1.11,0.38-8.23,5.41-9.5,6.5c0.32-8.32,2.48-27.3-3-31.75
				c8.63,1.26,3.91-12.15-0.25-10.75c-2.58,0.87-0.5,3.14-0.75,4.25c-0.87,3.91-5.88-1.01-3-5c-3.25-0.88-3.25-0.88-6.5-1.75
				c1.67-2.17-2.77-0.53-3.25-3.5c-6.32,3.9-1.54,0.46-3.25-3.25c-1.05-2.28-4.69-4.99-6.5-6.75
				C244.79,34.14,255.59,36.76,256.56,34.67z"
          />

          <path
            class="st3"
            d="M36.06,124.17c0.04,3.83-0.04,7.67,0,11.5c0.01,1.5-0.01,3,0,4.5c0,0.17,0,0.33,0,0.5
				c0.02,1.82,0.49,2.36,0.5,3c0.02,1.82-0.01,3.67,0,5.5c0.12,14.65-0.07,29.34,0,44c0.03,5.67-0.03,11.33,0,17
				c-3.42-4.59-1.17-8.28-8-8.5c-0.01-25-0.06-50,0-75C32.31,125.42,32.31,125.42,36.06,124.17z"
          />

          <path
            class="st5"
            d="M35.56,43.67c0,0.17,0,0.33,0,0.5c-0.1,19.56-0.24,38.93,0,58.5c-0.72,3.26-3.12,2.11-5,4.25
				c-0.36,0.41,0.14,3.36-2,2.75c0.07-21.98-0.59-44.04,0.5-66C32.31,43.67,32.31,43.67,35.56,43.67z"
          />

          <path
            class="st2"
            d="M256.56,34.67c-0.97,2.1-11.76-0.52-17-1.5c-37.27-6.95-74.77-12.64-112.25-18.5
				c-18.65,2.47-36.8,7.33-55.5,10c-0.2,0.03-0.5,2.45-3.25,0c17.55-3.98,35.25-7.31,52.75-11.5c4,0,4,0,8,0
				C171.56,21.01,214.5,25.71,256.56,34.67z"
          />

          <path
            class="st4"
            d="M36.06,117.67c0.02,2.17-0.02,4.33,0,6.5c-3.75,1.25-3.75,1.25-7.5,2.5c0.01-5.67-0.02-11.33,0-17
				c2.14,0.61,1.64-2.34,2-2.75c1.88-2.14,4.28-0.99,5-4.25C35.62,107.66,36,112.71,36.06,117.67z"
          />

          <path
            class="st5"
            d="M35.56,43.67c-3.25,0-3.25,0-6.5,0c0.11-2.29-0.76-6.43,0-9.25c0.95-0.54,1.99-0.84,3-1.25
				c3.6,0.83,2.32,5.64,4.5,8.25C36.74,43.83,35.55,42.93,35.56,43.67z"
          />

          <path
            class="st2"
            d="M270.56,37.67c-1.38,2.69-8.62,0.73-8.5-2C264.82,36.3,267.89,36.75,270.56,37.67z"
          />

          <path
            class="st2"
            d="M133.06,232.17c-2.71,2.14-2.11,2.44-3.5,5c-2.38,4.38-3.26,3.31,0.5,2c0.5,0,0.5,0,1,0
				c-2.44,2-1.3,7.82-1.5,13c-0.38,9.51-0.84,18.97-1,28.5c-0.27,15.97-0.51,32.03-0.5,48c0,6.09-0.25,45.48,0.5,47.75
				c0.06,0.2,0.91,0.37,1.5,0.75c-1.44,1.71-1.55,6.35-1.25,6.5c2.01-3.79,0.46-0.92,1.25,1c0.24,0.58,1.23,2.33,1.5,2.5
				c-3.43,3.49,2.67,3.76,5,4c16.77,1.76,48.73-2.29,67.25-1c-5.46-1.5-2.65-4.89,0.5-7.5c13.15-1.52,46.14-2.16,54.75-4
				c8.23-1.76,4.44-6.48,4.5-7c0.51-4.3,3.4-11.11,2.5-20.25c-0.12-0.3-1.26-0.76-2.5-1.75c1.93-1.06,5.63,1.69,8,2.5
				c-0.25,0.25-0.25,0.25-0.5,0.5c-1.38-0.36-2.59-1.07-2.5,0.25c1.82,2.61,3.01,4.19,5.5,6.25c-1.83,7.28-3.42,21.74-7,27.5
				c-2.01-1-2.45-0.71-1,1c-2.19,2.79-3.33,2.84-3.5,3c-1.2-3.89-0.66-0.53-2.25,0c-3.2,1.07-15.63-0.18-23.25,2.5
				c-2.99,1.05-7.87,4.85-9.5,7.5c-30.26-0.28-60.48,0.72-90.75,0.5c-0.87-0.01-5.97,1.02-6.75,1c-0.15,0-1.79-0.37-3-0.5
				c-1.53-0.17-3.51-0.48-5-1c0-0.33-0.01-0.67,0-1c0.07-3.5-0.19-7,0-10.5c0.68,0.1,2.53,0.14,3-0.25c0.5-1.4,0.35-2.83,0.5-4.25
				c0.3-2.75-0.07-6.87,0-10c0.2-8.82-0.04-17.68,0-26.5c0.19-37.66,0.04-75.34,0-113c0.9-1.22,0.86-0.8,1.5-1
				c2.35-0.74,3.41-1.25,5.5-2.5C132.81,231.92,132.81,231.92,133.06,232.17z"
          />

          <path
            class="st4"
            d="M120.06,211.67c0,44.83,0.44,89.67,0,134.5c-0.1,9.65,0.22,19.34,0,29c-0.06,2.77,0.29,6.99,0,9
				c-0.1,0.65,0.27,2.13-0.25,2.5c-0.28,0.2-6.54,0.05-6.75-0.25c-0.38-0.54,0.07-11.31,0-13.25c-1.05-28.8,0.07-65.04,0-95
				c-0.01-3.67,0.01-7.33,0-11c-0.05-30.34,0-60.66,0-91c3.5,4.6,5.92,10.4,5.5,16.25c0.5,0,0.5,0,1,0
				c0.25-43.38,0.25-43.38,0.5-86.75C119.98,141,120.06,176.33,120.06,211.67z"
          />

          <path
            class="st84"
            d="M125.56,48.17c0.59,54.81-1.78,109.68,0,164.5c-2.75-0.5-2.75-0.5-5.5-1c0-35.33-0.07-70.67,0-106
				c0.06-26.42-0.04-52.83,0-79.25C127.87,21.52,125.4,34.14,125.56,48.17z"
          />

          <path
            class="st85"
            d="M113.56,77.17c0.1,30.47-0.49,61.01-0.5,91.5c-0.34,0-0.91-0.12-1,0.25c-0.74,3.12,0.68,23.26,0,24.5
				c-0.38,0.7-3.28-0.75-4-0.25c0.06-11.38-0.61-26.87,0-37.25c0.02-0.4,2.17-2.44,1.5-7.75c-0.07-0.59-0.5-3.35-0.75-3.5
				c-19.54,1.68-39.08,4.36-58.75,5c0.05-0.32-0.03-0.67,0-1c8.89-2.13,17.98-2.1,27-3c5.47-0.54,25.43-2.3,28-3
				c0.58-0.16,1.92,0.08,3-1.25c0-33.38,0-33.38,0-66.75C110.81,75.92,110.81,75.92,113.56,77.17z"
          />

          <path
            class="st27"
            d="M112.06,28.67c0.74,3.06-0.66,5.79-4,6c-0.49,0.03,0.41-1.64-9.5,0c-11.39,1.88-34.36,6.75-46,9.5
				c-2.47,0.58-5.04,0.7-7.5,1.5c-1.79,0.58-3.74,0.47-5,2.25c-0.07,2.24,0.1,4.51,0,6.75c-0.48,10.43,0.08,21.05,0,31.5
				c-0.02,2.67,0.01,5.33,0,8c-0.01,2.5,0.02,5,0,7.5c-0.03,5.01-0.44,10.03-0.5,15c-0.95,1.48-1.83,0.95-3.5,1
				c-0.06-4.96-0.44-10-0.5-15c-0.24-19.57-0.1-38.94,0-58.5C73.81,36.42,73.81,36.42,112.06,28.67z"
          />

          <path
            class="st2"
            d="M128.56,44.67c-0.13,6.33,0.05,12.67,0,19c-0.1,12.67,0.1,25.34,0,38c-0.03,3.87-0.48,7.64-0.5,11.5
				c-0.17,30.67-0.42,61.33,0.5,92c0,4.49-0.25,9.02-0.5,13.5c-0.08,1.4-0.41,3-0.5,4.5c-0.22,3.66-0.43,7.33-0.5,11
				c-0.64,0.2-0.6-0.22-1.5,1c-0.01-7.5,0.01-15,0-22.5c-1.78-54.82,0.59-109.69,0-164.5C129.06,48.54,126.36,44.52,128.56,44.67z"
          />

          <path
            class="st86"
            d="M113.06,168.67c0,2.5,0,5,0,7.5c0,30.34-0.05,60.66,0,91c-3.61,0.61-2.59-3.51-5-3
				c0.06-23.67-0.13-47.34,0-71c0.72-0.5,3.62,0.95,4,0.25c0.68-1.24-0.74-21.38,0-24.5C112.14,168.55,112.72,168.66,113.06,168.67z
				"
          />

          <path
            class="st84"
            d="M113.56,77.17c-2.75-1.25-2.75-1.25-5.5-2.5c0-20,0-20,0-40c3.34-0.21,4.74-2.94,4-6
				c0.5,0.12,0.5,0.12,1,0.25C112.55,44.99,113.5,61.1,113.56,77.17z"
          />

          <path
            class="st5"
            d="M41.56,202.17c0.12,1.98-0.16,4.02,0,6c0.21,2.55-0.15,5.19,0,7.75c0.44,0.61,2.72,0.26,3.5,0.25
				c0.25,1,0.25,1,0.5,2c-1.36,0.05-2.66,0.03-4-0.25c-0.05,5.58,0.06,11.17,0,16.75c-0.03,2.5,0.01,5,0,7.5c-0.04,6,0.02,12,0,18
				c-0.01,3.17,0.01,6.33,0,9.5c-0.01,1.67,0.01,3.33,0,5c-0.02,4.5,0.01,9,0,13.5c0,1.5,0,3,0,4.5c0,0.17,0,0.33,0,0.5
				c0,1.17,0,2.33,0,3.5c0,1.33,0,2.67,0,4c-0.02,7.51-0.47,15.02-0.5,22.5c-0.02,5.33-0.07,10.67,0,16c0.04,2.68-0.04,5.35,0,8
				c0.12,7.63-1.33,9.25,3.5,8.5c-0.16,0.26,0.62,1.95,0,2.5c-0.28,0.01-2.85,0.36-3,0.75c0.12,2.57-0.17,5.19,0,7.75
				c-4.23-0.6-3.54,1.27-5,1.5c-1.01-52.6,0.25-105.37,0-158c-0.03-5.67,0.03-11.33,0-17C40.13,193.28,38.33,201.28,41.56,202.17z"
          />

          <path
            class="st5"
            d="M113.06,373.17c0.07,1.94-0.38,12.71,0,13.25c0.21,0.3,6.47,0.45,6.75,0.25c0.52-0.37,0.15-1.85,0.25-2.5
				c2.75,0.25,2.75,0.25,5.5,0.5c-0.15,1.42,0,2.85-0.5,4.25c-0.47,0.39-2.32,0.35-3,0.25c-1.07-0.15-2.12-1.49-2.25-1.5
				c-8.31-0.72-25.5-0.84-37.25-1.5c-0.99-0.06-2.01,0.06-3,0c-7.16-0.45-14.34-0.94-21.5-1.5c2.16-2.72-0.68-4.04-1.5-6.75
				c3.35-0.92,7.12,0.25,7.5,0.25c11.19,0.04,22.32,1.23,33.5,0.5c2.19-0.02,6.5,0.24,7.5,0c2.67-0.64,2.71-3.19,3-5.5
				C110.56,373.17,110.56,373.17,113.06,373.17z"
          />

          <path
            class="st4"
            d="M41.56,366.67c0.06,0.83,1.54,4.97,1.25,9c7.07,0.49,14.18,0.53,21.25,1c0,0.75,0,0.75,0,1.5
				c-0.38,0-4.15-1.17-7.5-0.25c0.82,2.71,3.66,4.03,1.5,6.75c-6.91-0.54-13.86-0.61-20.75-1.5c-1.33-0.9-0.71-12.71-0.75-15
				C38.02,367.93,37.33,366.07,41.56,366.67z"
          />

          <path
            class="st2"
            d="M82.56,386.17c0.56,1.79-3.01,1.61-3,0C80.55,386.23,81.56,386.11,82.56,386.17z"
          />

          <path
            class="st4"
            d="M43.56,144.67c1.99-0.03,4.01,0.1,6,0c-0.34,3.77,0.52,3.8,0.5,4c-0.03,0.33,0.05,0.68,0,1
				c-0.06,0.37-1.42,1.03-1.5,1.75c-0.88,7.62,2.93,3.67,20.5,1.75c-2,3-2,3-4,6c-2.42,0.36-15,0.83-9.5,3
				c-0.08,0.01,0.21,1.42-0.25,1.5c-2.13,0.2-4.67,0.19-6.75,0.5c-1.57,0.23-6.37,0.31-6.75,0.5c-1.67,1.33-0.21,2.72-0.25,3
				c-0.24,1.79-0.31,10.77,0.25,11c1.14-0.54,2.03-0.52,3.25-0.5c0.33,0.01,0.67,0.01,1,0c0,1.25,0,1.25,0,2.5
				c-1.49,0.14-3.03-0.01-4.5-0.25c0.7,4.73-1.15,14.14,0.5,18.25c0.3,0.75,1.9,0.53,1.5,2.5c-1.25,0.09-2.23-0.43-2,1
				c-3.22-0.88-1.43-8.88-5-9c-0.07-14.66,0.12-29.35,0-44c2.84-0.27,1.66-2.89,2-3.75c0.29-0.74,1.35-0.56,1.5-1.25
				C41.94,145.96,42.24,144.68,43.56,144.67z"
          />

          <path
            class="st84"
            d="M40.06,130.17c-3.85-0.2,2.11,4.44-4,5.5c-0.04-3.83,0.04-7.67,0-11.5c-0.02-2.17,0.02-4.33,0-6.5
				c1.67-0.05,2.55,0.48,3.5-1C39.5,121.13,40.15,125.61,40.06,130.17z"
          />

          <path
            class="st87"
            d="M40.06,144.17c-0.15,0.69-1.21,0.51-1.5,1.25c-0.34,0.86,0.84,3.48-2,3.75c-0.01-1.83,0.02-3.68,0-5.5
				c2.05-1.9,2.98-3.52-0.5-3c0-0.17,0-0.33,0-0.5c3.22,0.58,1.38-0.9,4-4C39.96,138.33,40.46,142.33,40.06,144.17z"
          />

          <path
            class="st86"
            d="M40.06,130.17c-0.04,1.99,0.09,4.01,0,6c-2.62,3.1-0.78,4.58-4,4c-0.01-1.5,0.01-3,0-4.5
				C42.16,134.6,36.2,129.96,40.06,130.17z"
          />

          <path
            class="st86"
            d="M36.56,143.67c-0.01-0.64-0.48-1.18-0.5-3C39.53,140.15,38.61,141.77,36.56,143.67z"
          />

          <path
            class="st5"
            d="M139.56,248.67c0.57,0.08,1.69-0.24,2,0.25c0.55,0.88-0.45,17.96-0.5,20.75c-0.05,2.88,0.03,5.67,0,8.5
				c-0.16,14.9-0.03,29.62,0,44.5c0.01,3.67-0.02,7.32,0,11c0.03,8.52-2.09,29.14-0.5,35.75c1.28,5.3,10.59,11.85,11.75,12.25
				c2.63,0.91,25.08,0.64,30,0.5c6.48-0.18,56.09-3.47,59-4c5.13-0.93,9.58-3.92,12.75-8c2.68-0.73,4.83,0.31,5.5-0.25
				c1.32-1.1,3.92-17.7,3-20.75c0.19,0.13,0.85,0.38,1,0.5c1.24,0.99,2.38,1.45,2.5,1.75c0.9,9.14-1.99,15.95-2.5,20.25
				c-7.22-0.28-2.77,2.34-4.5,7c-8.61,1.84-41.6,2.48-54.75,4c-3.15,2.61-5.96,6-0.5,7.5c-18.52-1.29-50.48,2.76-67.25,1
				c2.34-2.21,2.69-7.94,3-8.25c1.03-1.04,3.49,0.85,4,0c0.78-1.3-5.75-6.14-6.5-7.25c-5.2-7.65-3.33-20.62-3.5-29.5
				c-0.32-17.15,0.1-34.35,0-51.5c-0.04-6,0.04-12,0-18c0.44-0.05,1.29,0.2,1.5-0.25c0.57-1.24,0.38-23.42,0.5-27.25
				C136.88,249.23,138.28,248.98,139.56,248.67z"
          />

          <path
            class="st3"
            d="M141.06,333.67c-0.02-3.68,0.01-7.33,0-11c45.62,0,45.62,0,91.25,0c2.62,3.62,2.62,3.62,5.25,7.25
				c0.21,0.68-2.28,1.17-2.75,1.25C227.2,332.45,158.59,331.58,141.06,333.67z"
          />

          <path
            class="st4"
            d="M177.56,269.67c1.58,6.85,4.1,6.09,9.5,8c0.76,0.27,2.91-0.24,3.5,1.5c-24.75-0.5-24.75-0.5-49.5-1
				c0.03-2.83-0.05-5.62,0-8.5C159.31,269.67,159.31,269.67,177.56,269.67z"
          />

          <path
            class="st4"
            d="M259.06,347.17c1.32,1.07,1.43,0.94,1.5,1c0.09,0.07,0.71,0.1,2,1c0.92,3.05-1.68,19.65-3,20.75
				c-0.67,0.56-2.82-0.48-5.5,0.25c5.32-6.84,6.27-15.87,3.5-24C257.98,346.51,258.63,346.82,259.06,347.17z"
          />

          <path
            class="st4"
            d="M253.56,106.67c-0.46,0.84-4.1,8.93-4.5,10c-5.26,1.44-2.27-1.16-4.75-2.5c-1.5-0.81-9.46-0.81-12-2
				c-45.62-4.75-45.62-4.75-91.25-9.5c0.02-3.16-0.03-6.31,0-9.5C197.31,99.92,197.31,99.92,253.56,106.67z"
          />

          <path
            class="st4"
            d="M141.56,208.17c-0.97,1.93-0.01,2.57,0,3c-0.5,0-0.5,0-1,0c0.71-5.03,0.38-9.96,0.5-15
				c15.86,1.36,98.23,3.28,103.25,4.5c5.31,1.3-0.65,7.94-3,8.5c-4.74,1.14-90.21-5.31-97.5-3
				C142.73,206.51,142.09,207.1,141.56,208.17z"
          />

          <path
            class="st4"
            d="M141.56,155.67c0-0.5-0.51-3.51-0.5-10c32.97,3,65.94,6.19,99,7.75c-1.62,4.12-1.62,4.12-3.25,8.25
				C189.18,158.67,189.18,158.67,141.56,155.67z"
          />

          <path
            class="st87"
            d="M141.06,67.17c-0.16,8.66,0.08,17.34,0,26c-0.03,3.19,0.02,6.34,0,9.5c-0.1,14.33,0.03,28.67,0,43
				c-0.01,6.49,0.5,9.5,0.5,10c0,0.2-0.48-0.9-0.5,3.5c-3.27-0.08,0.97-4.34-6-1.5c-0.03-12.66-0.05-25.34,0-38
				c0.02-5.17-0.03-10.33,0-15.5c0.06-10.82-0.2-21.69,0-32.5C138.06,69.42,138.06,69.42,141.06,67.17z"
          />

          <path
            class="st88"
            d="M141.06,159.17c-0.05,12.32,0.28,24.69,0,37c-0.12,5.04,0.21,9.97-0.5,15c-0.22,1.53-0.12,3.21-0.5,4.75
				c-1.69,0.23-2.8-0.22-4.5,0.25c-0.62-19.5-0.45-39-0.5-58.5C142.02,154.82,137.79,159.09,141.06,159.17z"
          />

          <path
            class="st89"
            d="M229.56,215.67c0,0.75,0,0.75,0,1.5c-1.17,0.02-2.27-0.06-3.5,0c-3.09,0.14-16.43,1.06-18.5-0.5
				c-0.04-0.03-0.64-0.87-0.25-1C214.88,216.63,221.78,215.12,229.56,215.67z"
          />

          <path
            class="st90"
            d="M260.56,97.67c-0.53,0.59-1.26,1.21-1.5,1.5c-0.48-9.47,0.81-24.68-1.5-33.5c2.08,0.48,5.15-3.27,6,0.25
				c0.32,1.34,0.36,26.17,0,27.5C263.44,93.83,260.48,96.4,260.56,97.67z"
          />

          <path
            class="st85"
            d="M125.56,212.67c0.01,7.5-0.01,15,0,22.5c0.04,37.66,0.19,75.34,0,113c-1.03-6.86-0.77-2.73-5.5-2
				c0.44-44.83,0-89.67,0-134.5C122.81,212.17,122.81,212.17,125.56,212.67z"
          />

          <path
            class="st5"
            d="M133.56,294.67c0.1,17.15-0.32,34.35,0,51.5c-3.01-3.44-0.21-15.45-5.5-17.5c-0.01-15.97,0.23-32.03,0.5-48
				C134.38,283.53,130.12,293.93,133.56,294.67z"
          />

          <path
            class="st4"
            d="M133.56,346.17c0.17,8.88-1.7,21.85,3.5,29.5c-0.69-0.04-1.36,0.32-2,0.5c-0.97,0.27-1.58-0.37-3,1
				c-0.25-1.48-1.11-1.06-2,0c-0.59-0.38-1.44-0.55-1.5-0.75c-0.75-2.27-0.5-41.66-0.5-47.75
				C133.35,330.72,130.55,342.72,133.56,346.17z"
          />

          <path
            class="st90"
            d="M125.56,348.17c-0.04,8.82,0.2,17.68,0,26.5c-1.26,3.3-2.85,0.13-5.5,0.5c0.22-9.66-0.1-19.35,0-29
				C124.78,345.44,124.53,341.3,125.56,348.17z"
          />

          <path
            class="st88"
            d="M133.56,276.67c0.04,6-0.04,12,0,18c-3.44-0.73,0.82-11.14-5-14c0.16-9.53,0.62-18.99,1-28.5
				c3.44-0.32,2.53,5.33,4.5,6.75C133.57,264.88,133.52,270.69,133.56,276.67z"
          />

          <path
            class="st87"
            d="M135.56,238.17c-0.09,2.99,0.12,6.01,0,9c-0.01,0.17,0.01,0.33,0,0.5c-0.02,0.5,0.02,1,0,1.5
				c-0.12,3.83,0.07,26.01-0.5,27.25c-0.21,0.45-1.06,0.2-1.5,0.25c-0.04-5.98,0.01-11.79,0.5-17.75c-1.97-1.42-1.06-7.07-4.5-6.75
				c0.2-5.18-0.94-11,1.5-13c1.72,0.23,1.42-0.48,1.5-0.5c0.46-0.1,1.14,0.12,1.5,0C134.6,238.48,134.86,237.98,135.56,238.17z"
          />

          <path
            class="st4"
            d="M137.06,375.67c0.75,1.11,7.28,5.95,6.5,7.25c-0.51,0.85-2.97-1.04-4,0c-0.31,0.31-0.66,6.04-3,8.25
				c-2.33-0.24-8.43-0.51-5-4c3.79,2.32,0.76-3.09,4-4.25c-1.28-4.74-3.99-0.39-5.5,1.75c-0.79-1.92,0.76-4.79-1.25-1
				c-0.3-0.15-0.19-4.79,1.25-6.5c0.89-1.06,1.75-1.48,2,0c-2.03,1.96,0.12,3.52,3-1C135.7,375.99,136.37,375.63,137.06,375.67z"
          />

          <path
            class="st5"
            d="M129.56,222.67c-0.36,1.67,1.61,0.76,4,1c2.03,0.2,2.83-2.67,2,5.5c-0.45,0.28-2.03,1.92-3,2.5
				c-2.09,1.25-3.15,1.76-5.5,2.5c0.07-3.67,0.28-7.34,0.5-11c0.38,2,0.38,2,0.75,4c0.25-2.03,0.23-3.12,1.25-5
				C129.56,222.42,129.56,222.42,129.56,222.67z"
          />

          <path
            class="st87"
            d="M125.56,384.67c-2.75-0.25-2.75-0.25-5.5-0.5c0.29-2.01-0.06-6.23,0-9c2.65-0.37,4.24,2.8,5.5-0.5
				C125.48,377.8,125.85,381.91,125.56,384.67z"
          />

          <path
            class="st4"
            d="M263.56,371.67c-0.06,0.52,3.73,5.24-4.5,7C260.78,374,256.34,371.38,263.56,371.67z"
          />

          <path
            class="st2"
            d="M131.56,387.17c-0.27-0.17-1.26-1.92-1.5-2.5c1.51-2.14,4.22-6.49,5.5-1.75
				C132.32,384.08,135.35,389.49,131.56,387.17z"
          />

          <path
            class="st87"
            d="M113.06,278.17c0.07,29.96-1.05,66.2,0,95c-2.5,0-2.5,0-5,0c0.47-3.7,0.46-26.58,0.5-33
				c0.08-12.28-0.53-24.68-0.5-37c7.26,0.42,2.56-18.68,4-24.75C112.14,278.05,112.72,278.16,113.06,278.17z"
          />

          <path
            class="st90"
            d="M113.06,267.17c0.01,3.67-0.01,7.33,0,11c-0.34,0-0.91-0.12-1,0.25c-1.44,6.07,3.26,25.17-4,24.75
				c0.03-13-0.03-26,0-39C110.47,263.66,109.44,267.78,113.06,267.17z"
          />

          <path
            class="st90"
            d="M134.06,105.67c0.26,4.89-0.01,9.19,0,14c0.01,4.93-0.49,10.01-0.5,15c-1.25,0-1.25,0-2.5,0
				c-0.06-5.66,0.04-11.34,0-17c-0.03-4.31,2.13-17.95-2.5-16c0.1-12.66-0.1-25.33,0-38c2-0.26,0.55,6.58,1,11.75
				c0.41,4.69,3.11,14.44,3.5,18c0.75,6.81,0.97,5.2,1,5.5C134.09,99.25,133.89,102.61,134.06,105.67z"
          />

          <path
            class="st90"
            d="M142.06,51.17c-2.53,7.69-0.9,10.59-1,16c-3,2.25-3,2.25-6,4.5c0.13-7.16-0.47-14.37,0.5-21.5
				c1.13,1.51,2.93-2.58,4.5-5C141.97,45.71,141.24,49.3,142.06,51.17z"
          />

          <path
            class="st3"
            d="M144.56,38.67c-2.69,0.63,0.16-2.19-1.5-4.5c2.2-3.05,10.47-0.02,8.25,2.5
				C151.07,36.93,145.23,38.24,144.56,38.67z"
          />

          <path
            class="st84"
            d="M135.06,119.67c-0.5,0-0.5,0-1,0c-0.01-4.81,0.26-9.11,0-14c0.5-0.75,0.5-0.75,1-1.5
				C135.02,109.33,135.08,114.5,135.06,119.67z"
          />

          <path
            class="st2"
            d="M109.56,148.17c0.67,5.31-1.48,7.35-1.5,7.75c-0.61,10.38,0.06,25.87,0,37.25c-0.13,23.66,0.06,47.33,0,71
				c-0.03,13,0.03,26,0,39c-0.03,12.32,0.58,24.72,0.5,37c-1.85-0.6-1.09-9.38-1.5-11.75c-0.08-0.46-1.49-0.18-1.5-0.25
				c-0.43-2.28,0.92-5.95-1-7.5c0.03-0.05,0.48-0.95,0.5-1c0.08-0.27,0.83,0.85,1,0.25c0.21-0.75-1.14-7.09-1.25-9.25
				c-8.55,0.63-27.97-0.85-33.5,0c-0.4,0.06-0.09,0.92-0.5,1c-9.89,1.89-13,6.42-19.5,5.5c1.12,1,1.12,1,2.25,2
				c-2.15,0.06-4.37-0.17-6.5,0c1.03-11.98-1.56-7.46-2.75-8.5c-4.86-4.25,16.71-2.98,18.25-3c8.16-0.12,16.34,0.12,24.5,0
				c5.91-0.09,11.84,0.06,17.75,0c0.12-4,0.12-4,0.25-8c2.92-11.91-3.7-7.2-12.75-7c-16.91,0.37-33.84-0.55-50.75,0c0-1.5,0-3,0-4.5
				c0.81,0.08,2.84-0.98,3-1c0.48-0.07,1.01,0.03,1.5,0c10.19-0.72,27.3-0.54,39.5-1c2.94-0.11,18.43,0.48,19.5-0.75
				c0.07-0.73-0.1-1.53,0-2.25c0.15-1.07,0.6-8.25,0.25-8.5c-8.8,0.31-17.71-0.28-26.5,0c-0.18,0.01-3.32,0.99-3.5,1
				c-5.44,0.16-25.67,1.24-27.75,1c-0.17-0.02,0.06-0.81-3-1.5c-3.74-1.54,1.73-2.41,3-2.5c2.48-0.17,13.1,0.61,18.5,0.5
				c13.08-0.26,26.17-0.86,39.25-1c0.94-1.73-0.25-5.22-0.25-5.5c0-0.66,0.04-1.34,0-2c-0.15-2.73,0.52-7.21-0.75-7.5
				c-0.37,0.29-0.87,1-1,1c-10.22,0.16-20.54,0.92-30.75,1.5c-9.19,0.52-15,0.25-24.25,2c-0.65,0.12-1.55-4.03-1.25,6
				c-0.5,0-0.5,0-1,0c-0.24-1.42-0.77-5.29-0.5-6.5c0.03-0.13,0.56-0.01,0.75-2.5c1.93-0.09,3.82-0.35,5.75-0.5
				c7.71-0.62,16.19-0.64,24-1c9.75-0.45,19.51-0.43,29.25-1c0.08-1.69-0.28-3.27-0.25-5c0.02-1.32,0.06-2.68,0-4
				c-0.07-1.59,0.2-3.61,0-5c-0.1-0.65,0.27-2.13-0.25-2.5c-14.07,1.3-28.12,2.58-42.25,3c-5.22,0.15-10.78,1.04-16,0.5
				c-1.22-0.13-3.53-1-5-1c0.01-2.5-0.03-5,0-7.5c0.25,0,0.25,0,0.5,0c0.6,0.42,0.91,0.38,1.5,0.5c4.26,0.9,9.17,0.62,13.5,0.5
				c0.67-0.02,1.33,0.02,2,0c2.21,7.54,6.27,4.26,13.5,4c6.93-0.25,24.11-0.98,29.5-2c0.16-0.03,0.34,0.03,0.5,0
				c0.91-0.16,1.81,0.39,2.5-0.75c0.15-1.15-0.52-3.56-0.5-3.75c0.11-1.2,0.02-1.46,0-2.5c-0.02-1.13,1.55-7.42-0.25-8
				c-4.91,3.88-11.02,2.06-16.75,2.5c-6.9,0.54-13.84,1.56-20.75,2c-2.48,0.16-16.28-0.46-17,0c-0.67,0.43,0.38,3.46-3,4
				c-0.46-0.11,1.62-3.03,0.75-4.25c-0.28-0.39-9.11-2.23,1.5-3.25c5.34-0.51,12.8-0.12,18.5-0.5c12.41-0.83,24.8-2.13,37.25-2.5
				c1.04-0.74-0.28-6.37-0.25-7.5c0.02-0.83,0.02-1.67,0-2.5c-0.01-0.41,0.96-4.75,0.5-8.25c-0.38-0.75-4.43,2.05-5,2.25
				c-13.28,0.32-26.81,2.95-40.25,3.5c-1.44,1.93-3.5-0.33-9,2.5c-0.91,3.43-1.68,2.34-1.75,2.5c0.5-2.65-3.51,0-2.5-5
				c0.8-3.97,13.43-1.9,17.25-3c-0.88-2.75-0.88-2.75-1.75-5.5c0.1-0.01-0.58-0.22,2-0.5c-0.45,2.27,2.97,3.85,1.25,5.5
				c8.4-0.77,16.87-1.12,25.25-2c4.75-0.5,9.52-0.76,14.25-1.5c1.05-0.98-0.29-6.25-0.25-7.5c0.01-0.33,0-0.67,0-1
				c0.03-2.23,1.27-5.81,0.5-8c-0.1-0.27,0.2-0.77-0.25-1c-5.77,1.24-12.1,1.89-18.25,2.5c-13.66,1.35-27.71,1.7-41,5
				c-0.74-2.32-8.16-2.35,5.5-4.5c15.84-2.49,36.69-2.5,53.25-4.5c1.23-0.86,0.62-2.24,0.75-3.5c0.23-2.27-0.46-4.38-0.5-6.5
				c-0.01-0.41,0.96-4.73,0.5-8.25c-0.22-0.42-0.93,0.59-3,0.75c-9.94,0.76-19.66,2.51-29.5,4c-8.22,1.25-16.54,2.14-24.75,3.5
				c-0.55,2.2-2.03,3.86-1.25,6c-0.17,0.01-0.33-0.01-0.5,0c-0.33,0.01-0.67,0.01-1,0c0.5-5,0.5-5,1-10c0.13-0.01,0.41-0.87,2.5-1
				c5.53-0.36,10.95-0.47,16.5-1c5.66-0.54,11.35-1.34,17-2c7.54-0.88,15.15-1.79,22.75-2c1.8-1.72,0.2-4.75,0.25-5
				c0.03-0.16,0.71-1.95,1-3c0.23-0.84,2.12-1.12,1.5-5.5C108.07,148.53,108.4,147.93,109.56,148.17z"
          />

          <path
            class="st3"
            d="M109.56,148.17c-1.15-0.24-1.48,0.36-2,0.5c-5.3,1.43-30.59,3.64-38.5,4.5c-17.57,1.92-21.38,5.87-20.5-1.75
				c0.08-0.72,1.44-1.38,1.5-1.75c19.67-0.64,39.21-3.32,58.75-5C109.06,144.82,109.48,147.58,109.56,148.17z"
          />

          <path
            class="st91"
            d="M98.56,35.67c-1.56,0.12-13.24,2.03-13.75,2.5c-0.62,0.57,0.21,2.26-0.75,3.5c-7,1.53-14.01,2.97-21,4.5
				c-3.97,0.87-8.07,1.56-12,2.5c0.75-2.25,0.75-2.25,1.5-4.5c11.64-2.75,34.61-7.62,46-9.5C98.56,35.17,98.56,35.17,98.56,35.67z"
          />

          <path
            class="st92"
            d="M45.06,45.67c2.25,1.75,2.25,1.75,4.5,3.5c-1.78,0.44-7.28,1.15-7.75,1.5c-1.83,1.35,1.29,4.56-1.75,4
				c0.1-2.24-0.07-4.51,0-6.75C41.31,46.13,43.26,46.25,45.06,45.67z"
          />

          <path
            class="st93"
            d="M52.56,44.17c-0.75,2.25-0.75,2.25-1.5,4.5c-0.33,0.08-0.66,0.29-1.5,0.5c-2.25-1.75-2.25-1.75-4.5-3.5
				C47.52,44.87,50.08,44.75,52.56,44.17z"
          />

          <path
            class="st88"
            d="M131.06,117.67c0.04,5.66-0.06,11.34,0,17c0.09,9.06,0.64,18.18,0.5,27.25c1,0.38,1,0.38,2,0.75
				c-0.12,13.26-0.49,26.49,0,39.75c-2.5,1.38-2.5,1.38-5,2.75c-0.92-30.67-0.67-61.33-0.5-92
				C130.84,112.44,128.5,117.26,131.06,117.67z"
          />

          <path
            class="st87"
            d="M135.06,119.67c-0.05,12.66-0.03,25.34,0,38c0.05,19.5-0.12,39,0.5,58.5c-2.65,0.73-4.96,1.51-7.5,2.5
				c0.25-4.48,0.5-9.01,0.5-13.5c2.5-1.38,2.5-1.38,5-2.75c-0.49-13.26-0.12-26.49,0-39.75c0.08-9.33-0.03-18.67,0-28
				c0.01-4.99,0.51-10.07,0.5-15C134.56,119.67,134.56,119.67,135.06,119.67z"
          />

          <path
            class="st94"
            d="M131.06,117.67c-2.55-0.41-0.22-5.23-3-4.5c0.02-3.86,0.47-7.63,0.5-11.5
				C133.18,99.72,131.03,113.36,131.06,117.67z"
          />

          <path
            class="st3"
            d="M44.56,358.17c0.3-0.02,1.48,0.44,6,0.5c0.5,3.25,0.5,3.25,1,6.5c-11.52,0.22-0.49,2.26,4.75,3
				c16.27,2.31,33.1,2.57,49.5,3.5c-0.38,3.5-0.38,3.5-0.75,7c-1,0.24-5.31-0.02-7.5,0c-11.06,0.11-22.45-1.26-33.5-2
				c-7.07-0.47-14.18-0.51-21.25-1c0.29-4.03-1.19-8.17-1.25-9c-0.17-2.56,0.12-5.18,0-7.75C41.7,358.53,44.28,358.18,44.56,358.17z
				"
          />

          <path
            class="st3"
            d="M45.56,218.17c0.66-0.03,1.34,0.04,2,0c0.75,2.75,0.75,2.75,1.5,5.5c-10.61,1.02-1.78,2.86-1.5,3.25
				c0.87,1.22-1.21,4.14-0.75,4.25c3.38-0.54,2.33-3.57,3-4c0.72-0.46,14.52,0.16,17,0c6.91-0.44,13.85-1.46,20.75-2
				c0.41,2.78-3.51,1.42-3.75,1.5c-0.51,0.18,0.01,1.34-0.5,1.5c-4.13,1.34-5.61-0.5-8.25,3.5c-5.67,0.34-11.33,0.66-17,1
				c-4.78,0.29-10.38,0.01-15,1c-0.07,0.01-0.76-1.18-1,1c-0.25,0-0.25,0-0.5,0c0.06-5.58-0.05-11.17,0-16.75
				C42.89,218.19,44.2,218.22,45.56,218.17z"
          />

          <path
            class="st95"
            d="M51.56,355.67c6.77,0.1,50.44,1.32,53,2c-0.77,0.8,0.62,2.48-0.25,3c-1.32,0.79-26.76-0.87-30.75-1
				c-7.66-0.24-15.36-0.9-23-1c-4.52-0.06-5.7-0.52-6-0.5c0.62-0.55-0.16-2.24,0-2.5c0.1-0.17-0.15-0.34,0.5-0.5
				C45.37,355.09,47.66,355.61,51.56,355.67z"
          />

          <path
            class="st3"
            d="M44.56,275.17c3.06,0.69,2.83,1.48,3,1.5c-0.25,4-0.25,4-0.5,8c-1.33,0.29-2.08,1.27-2.5,2.5
				c-0.16,0.02-2.19,1.08-3,1c0.01-4.5-0.02-9,0-13.5C44.09,275.86,44.41,275.13,44.56,275.17z"
          />

          <path
            class="st3"
            d="M46.56,208.17c-1.01,5,3,2.35,2.5,5c-0.43,0.96-0.2,1.56,0,2.5c-2.77,0.18-3.8,0.5-4,0.5
				c-0.78,0.01-3.06,0.36-3.5-0.25c-0.15-2.56,0.21-5.2,0-7.75C44.06,208.17,44.06,208.17,46.56,208.17z"
          />

          <path
            class="st3"
            d="M45.56,261.17c-0.27,1.21,0.26,5.08,0.5,6.5c0.11,0.63-0.07,1.35,0,2c-1.5,0.02-3-0.01-4.5,0
				c0.01-3.17-0.01-6.33,0-9.5C43.95,260.29,45.93,259.6,45.56,261.17z"
          />

          <path
            class="st3"
            d="M43.56,347.67c2.41,1.13,2.69,1.3,1.5,7.5c-0.65,0.16-0.4,0.33-0.5,0.5c-4.83,0.75-3.38-0.87-3.5-8.5
				C42.16,346.99,42.65,347.24,43.56,347.67z"
          />

          <path
            class="st3"
            d="M41.56,296.67c0-1.17,0-2.33,0-3.5C43.09,292.76,43.09,297.08,41.56,296.67z"
          />

          <path
            class="st2"
            d="M51.06,327.67c5.63-0.2,11.36-0.03,17,0c12.48,0.07,25,0.97,37.5,0.5c0.01,0.07,1.42-0.21,1.5,0.25
				c0.41,2.37-0.35,11.15,1.5,11.75c-0.04,6.42-0.03,29.3-0.5,33c-0.29,2.31-0.33,4.86-3,5.5c0.38-3.5,0.38-3.5,0.75-7
				c-16.4-0.93-33.23-1.19-49.5-3.5c-5.24-0.74-16.27-2.78-4.75-3c6.59-0.12,16.42,1.39,23.5,2c10.08,0.86,20.1,2.48,30.25,2.5
				c0.01-3.46,0.67-7.09,0.75-10.5c0.04-1.66,0.47-9.96-0.75-10.5c-9.02,1.22-39.62-0.9-42-0.5c-0.48,0.08-0.02,1.43-0.5,1.5
				c-2.4,0.33-11.27,1.09-12,1.5c-0.49,0.27-1.91,3.04-1.75,3.25c0.57,0.73,2.87-0.52,2.5,1.25c-3.89-0.06-6.18-0.58-6.5-0.5
				c1.19-6.2,0.91-6.37-1.5-7.5c-0.12-3.6,10.79-2.53,18-2.5c14.57,0.05,29.18,1.27,43.75,1.5c0.37-0.26,0.37-5.21,0.25-6
				c-0.15-0.94,0.38-1.79-0.75-2.5c-7.59,0.11-15.16-0.35-22.75-0.5c-8.96-0.18-27.66-0.76-35-0.5c1.19-8.98-4.78-6.88-3-9.25
				C44.44,327.41,49.94,327.71,51.06,327.67z"
          />

          <path
            class="st87"
            d="M97.56,378.67c-11.18,0.73-22.31-0.46-33.5-0.5c0-0.75,0-0.75,0-1.5C75.1,377.41,86.5,378.78,97.56,378.67z
				"
          />

          <path
            class="st96"
            d="M107.56,148.67c0.62,4.38-1.27,4.66-1.5,5.5c-13.68,1.44-27.39,3-41,5c2-3,2-3,4-6
				C76.96,152.3,102.25,150.1,107.56,148.67z"
          />

          <path
            class="st84"
            d="M106.06,154.17c-0.29,1.05-0.97,2.84-1,3c-8,0.82-16,1.68-24,2.5c-5.29,0.54-10.75,0.8-16,1.5
				c-3.14,0.42-6.4,0.49-9.5,1c-5.5-2.17,7.08-2.64,9.5-3C78.66,157.16,92.38,155.6,106.06,154.17z"
          />

          <path
            class="st37"
            d="M46.06,180.67c1.31-0.13,2.69-0.33,4-0.5c0.5,3.25,0.5,3.25,1,6.5c-13.66,2.15-6.24,2.18-5.5,4.5
				c0.32,1.02-0.23,4.61,0,6.5c-0.83,0.14-2.29,1.23-3.5,1c-1.65-4.11,0.2-13.52-0.5-18.25C43.03,180.66,44.57,180.81,46.06,180.67z
				"
          />

          <path
            class="st9"
            d="M65.06,161.17c0,2.5,0,2.5,0,5c-5.55,0.53-10.97,0.64-16.5,1c0-1.5,0-1.5,0-3c2.08-0.31,4.62-0.3,6.75-0.5
				c0.46-0.08,0.17-1.49,0.25-1.5C58.65,161.66,61.92,161.58,65.06,161.17z"
          />

          <path
            class="st3"
            d="M46.06,168.17c-0.5,5-0.5,5-1,10c-1.22-0.02-2.11-0.04-3.25,0.5c-0.56-0.23-0.49-9.21-0.25-11
				C43.16,167.39,44.47,168.29,46.06,168.17z"
          />

          <path
            class="st95"
            d="M59.06,176.17c0.34,2.43-0.09,2.22-2,3c-1.82,0.75-4.9,0.73-7,1c-1.31,0.17-2.69,0.37-4,0.5
				c0-1.25,0-1.25,0-2.5c0.17-0.01,0.33,0.01,0.5,0C50.79,177.94,54.87,176.64,59.06,176.17z"
          />

          <path
            class="st2"
            d="M48.56,164.17c0,1.5,0,1.5,0,3c-2.09,0.13-2.37,0.99-2.5,1c-1.58,0.13-2.9-0.78-4.5-0.5
				c0.04-0.28-1.42-1.67,0.25-3C42.18,164.48,46.99,164.4,48.56,164.17z"
          />

          <path
            class="st2"
            d="M157.06,242.67c0.54,1.91-1.95,1.85-2,2.25c-0.06,0.56,1.86-1.86,1.5,10.75c0,0.05-1.08-0.13-1,0.25
				c12.56,3.28,22.08-0.08,1.5-0.25c0.43-2.3,8.25-0.34,13-0.5c-0.69,13.14,13.72,3.67,7.5,14.5c-18.25,0-18.25,0-36.5,0
				c0.05-2.79,1.05-19.87,0.5-20.75c-0.31-0.49-1.43-0.17-2-0.25c1.65-0.4,4.48-1.85,7.25-1.5c2.13-4.12,5.84-1.85,6.75-2.5
				c0.08-0.06,0.68,0.14,0.5-1c0.31-0.23,2.73,0.48,0.75-1.5c-0.24-0.24-5.91-2.49-6.25-2.5c0-0.25,0-0.25,0-0.5
				C151.46,240.25,154.36,241.08,157.06,242.67z"
          />

          <g>
            <path
              class="st97"
              d="M190.56,287.67c0.02,0.11,0.39,0.28,1,2c-0.05,0.43,0.2,1.33-0.25,1.5c-1.6,0.62-30.05-1.1-34.25-0.5
					c-0.88,0.12,0.18,1.33-2,0.5c0.08-0.72-0.27-2.63,0.25-3C167,287.06,179.24,289.29,190.56,287.67z"
            />

            <g>
              <path
                class="st51"
                d="M192.06,292.17c1.01,0.15,1.12,0.41,1.5,0.5c-1.12,1.36-3.28,5.1-3.5,6.5c-0.26,1.68,0.59,2.05,0.5,0.5
						c3.95-1.16,5.68-2.01,6-6.5c0.83,0.4,4.11,3.26,4.25,4.5c1.18-1.16,4.28,0.45,6.25,1c-0.1,1.34-0.75,0.29-1,2.75
						c-0.02,0.24,1.37,7.7-1,2c-0.11-0.27,1.19-6.82-1.25-4.75c-0.69,0.59,0.08,3.59-0.25,4.25c-0.33,0.67-2.39-0.98-3,0
						c-0.55,0.89,3.41-0.18-1.25,4.25c-1.3-10.88-1.49,4.31-3.25-0.75c-0.39-1.12,0.47-8.25-0.25-8.25c-0.5,4.5-0.5,4.5-1,9
						c-9.25,0.25-9.25,0.25-18.5,0.5c-0.5-5.5-0.5-5.5-1-11c-0.5,5.5-0.5,5.5-1,11c-9.5,0-9.5,0-19,0
						c-0.67-0.48-0.46-14.74-0.25-16.5c2.18,0.83,1.12-0.38,2-0.5c4.59,3.23,7.54-2.33,7.25,6.5c0.5-2.75,0.5-2.75,1-5.5
						c5.33,0.94,8.95-2.72,10,4c0.69-8.86,3.06-1.49,3.5-1.5c1.53-0.05-1.47-3.27,1-2.5c1.1,0.35,1.54,3.65-1.25,3.75
						c-0.6,1.38,2.89,0.82,3,0.5c0.07-0.2-1.54-3.51,0.25-4.25c2.35-0.96,2.01,6.66,2.5,0C186.85,292.48,189.48,291.8,192.06,292.17
						z"
              />

              <g>
                <path
                  class="st83"
                  d="M192.06,290.67c0.07,0.48-0.04,1.01,0,1.5c-2.57-0.37-5.21,0.31-7.75-0.5c-0.49,6.66-0.15-0.96-2.5,0
							c-1.79,0.74-0.18,4.05-0.25,4.25c-0.11,0.32-3.6,0.88-3-0.5c2.79-0.1,2.35-3.4,1.25-3.75c-2.47-0.77,0.53,2.45-1,2.5
							c-0.44,0.01-2.81-7.36-3.5,1.5c-1.05-6.72-4.67-3.06-10-4c-0.5,2.75-0.5,2.75-1,5.5c0.29-8.83-2.66-3.27-7.25-6.5
							c4.2-0.6,32.65,1.12,34.25,0.5c0.45-0.17,0.2-1.07,0.25-1.5C191.57,289.72,191.84,289.28,192.06,290.67z"
                />

                <path
                  class="st26"
                  d="M196.56,293.17c-0.32,4.49-2.05,5.34-6,6.5c-0.25-0.25-0.25-0.25-0.5-0.5c0.22-1.4,2.38-5.14,3.5-6.5
							C194.37,292.85,194.97,292.41,196.56,293.17z"
                />

                <path
                  class="st16"
                  d="M183.81,296.17c1.23-0.54,2.24,7.66,0.5,8.5C184.97,303.35,183.42,296.34,183.81,296.17z"
                />

                <path
                  class="st98"
                  d="M188.31,297.67c1.54,7.77-0.96,9.04-0.5,0.5c0.12-0.12,0.12-0.12,0.25-0.25S188.18,297.79,188.31,297.67
							z"
                />

                <path
                  class="st99"
                  d="M197.81,298.17c2.77-2.14,0.74,1.1,0.75,1.25C199.18,305.76,196.5,299.17,197.81,298.17z"
                />

                <path
                  class="st8"
                  d="M166.81,298.67c1.05-0.53,0.96,2.77,0.5,3C166.25,302.2,166.35,298.9,166.81,298.67z"
                />

                <path
                  class="st57"
                  d="M188.81,292.67c0.57,4.9-1.65,5.54-0.25,0.25C188.68,292.79,188.68,292.79,188.81,292.67z"
                />

                <path
                  class="st99"
                  d="M160.31,294.17c0.99-1.3,0.23,0.67,0.25,0.75C161.42,298.67,159.11,295.73,160.31,294.17z"
                />

                <path
                  class="st99"
                  d="M170.31,298.17c0.17-0.02,1.26,3.21,0,2.5C169.85,300.41,169.96,298.2,170.31,298.17z"
                />

                <path
                  class="st16"
                  d="M166.81,294.17c1.55-0.08,0.43,4.74,0.25,0.75C167.05,294.81,166.13,294.2,166.81,294.17z"
                />

                <path
                  class="st48"
                  d="M160.31,303.17c1.2-0.69,1.11,3.35-0.25,1.25C159.94,304.23,159.97,303.36,160.31,303.17z"
                />

                <path
                  class="st99"
                  d="M172.31,298.17c0.39,0,0.39,3,0,3S171.92,298.17,172.31,298.17z"
                />

                <path
                  class="st22"
                  d="M172.31,303.17c0.07-0.03,1.01,0.84,0.75,1.25C172.35,305.54,171.49,303.52,172.31,303.17z"
                />

                <path
                  class="st48"
                  d="M164.31,303.17c0.07-0.01,1.28,0.68,1.25,0.75C164.98,305.09,162.38,303.33,164.31,303.17z"
                />

                <path
                  class="st48"
                  d="M166.81,303.17c0.64,0.45,0.27,2.2-0.5,1C165.99,303.67,166.75,303.13,166.81,303.17z"
                />

                <path
                  class="st15"
                  d="M178.81,303.17c0.64,0.45,0.27,2.2-0.5,1C177.99,303.67,178.75,303.13,178.81,303.17z"
                />

                <path
                  class="st37"
                  d="M170.31,303.67c1.29-0.68,1.44,0.89,0.5,1C170.75,304.67,169.8,303.94,170.31,303.67z"
                />

                <path
                  class="st100"
                  d="M160.31,299.67c0.75-0.3,1.1,0.76,0.5,1C160.06,300.97,159.71,299.91,160.31,299.67z"
                />

                <path
                  class="st8"
                  d="M178.31,298.67c0.09-0.04,0.86,1.49,0.5,1.5C177.68,300.19,177.88,298.85,178.31,298.67z"
                />

                <path
                  class="st16"
                  d="M164.31,298.67c0.38,0,0.38,1.5,0,1.5S163.92,298.67,164.31,298.67z"
                />

                <path
                  class="st59"
                  d="M190.56,299.67c0.09,1.55-0.76,1.18-0.5-0.5C190.31,299.42,190.31,299.42,190.56,299.67z"
                />

                <path
                  class="st101"
                  d="M164.81,300.67c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
							c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
							S164.68,300.79,164.81,300.67z"
                />
              </g>
            </g>
          </g>

          <g>
            <path
              class="st2"
              d="M190.56,279.17c-0.94,2.41-0.53,6.01,0,8.5c-11.32,1.62-23.55-0.6-35.25,0.5c-0.52,0.37-0.17,2.28-0.25,3
					c-0.21,1.76-0.42,16.02,0.25,16.5c9.5,0,9.5,0,19,0c0.5-5.5,0.5-5.5,1-11c0.5,5.5,0.5,5.5,1,11c9.25-0.25,9.25-0.25,18.5-0.5
					c0.5-4.5,0.5-4.5,1-9c0.72,0-0.14,7.13,0.25,8.25c1.76,5.06,1.95-10.13,3.25,0.75c4.66-4.43,0.7-3.36,1.25-4.25
					c0.61-0.98,2.67,0.67,3,0c0.33-0.66-0.44-3.66,0.25-4.25c2.44-2.07,1.14,4.48,1.25,4.75c2.37,5.7,0.98-1.76,1-2
					c0.25-2.46,0.9-1.41,1-2.75c1.41,0.39,1.77,0.39,3.5,1c1.55,1.29-0.02,4.1,2.25,4.5c1.65-6.45,0.31-3.6-2.25-4.5
					c8.46-5.22,3.95-0.09,5.25,6.5c1.5-3.06,4.58,0.8,5.25-3c0.63,1.47,1.88,4.76,2,5c-3.84-0.4-29.3-0.5-30.75,0
					c-2.15,0.75-0.08,2.87,4.5,2c0.55-0.1,0.88-1.56,1-1.5c0.33,0.16,0.06,4.32,5,0.5c0.73-0.09,1.55,0.6,3.75,0.5
					c4.77,2.25,12.69,1.25,18.5,1.5c0.64,1.08,3.39,4.3,4.5,6c0.06,0.09,0.13,1.23,0.75,2c0.12-0.5,0.12-0.5,0.25-1
					c0.09,0.11,1.05,0.8,2,2c2.6,3.26,4.77,5.21,5,5.5c0.21,0.27-0.63,2.62,3.5,5.5c3.69,6.18,10.26,8.64,12.5,10.5
					c0.4,0.33,0.7,0.75,1,1c0.89,0.72,2.07,2.75,3,3.5c2.77,8.13,1.82,17.16-3.5,24c-3.17,4.08-7.62,7.07-12.75,8
					c-2.91,0.53-52.52,3.82-59,4c-4.92,0.14-27.37,0.41-30-0.5c-1.16-0.4-10.47-6.95-11.75-12.25c-1.59-6.61,0.53-27.23,0.5-35.75
					c17.53-2.08,86.15-1.22,93.75-2.5c0.47-0.08,2.96-0.57,2.75-1.25c-2.62-3.62-2.62-3.62-5.25-7.25c-45.62,0-45.62,0-91.25,0
					c-0.03-14.88-0.16-29.6,0-44.5C165.81,278.67,165.81,278.67,190.56,279.17z"
            />

            <g>
              <path
                class="st97"
                d="M230.56,318.17c-0.12,0.5-0.12,0.5-0.25,1c-0.62-0.77-0.69-1.91-0.75-2c0-0.25,0-0.25,0-0.5
						C230.81,317.01,230.5,318.1,230.56,318.17z"
              />

              <g>
                <g>
                  <path
                    class="st59"
                    d="M223.06,308.17c1.16,2.06-14.15,1.47-15.25,1.5c-0.39,0.01,0.13-1.05-1-1c-0.41,0.02-0.2,1-0.25,1
								c-2.2,0.1-3.02-0.59-3.75-0.5c-4.94,3.82-4.67-0.34-5-0.5c-0.12-0.06-0.45,1.4-1,1.5c-4.58,0.87-6.65-1.25-4.5-2
								C193.76,307.66,219.21,307.77,223.06,308.17z"
                  />

                  <path
                    class="st50"
                    d="M162.81,308.17c0.46-0.02,0.85,1.5,1,1.5c3.56-1.63,14.48-2.35,11.75,1.25
								c-0.69,0.91-16.94-0.23-19.25,0.75C155.46,308.17,159.36,308.29,162.81,308.17z"
                  />

                  <path
                    class="st10"
                    d="M176.81,308.17c0.6-0.3,12.89-0.29,13.5,0c1.2,0.56,1.36,3.14-1,2.5c-1.19-0.32-0.28-3.55-3,1
								c-5.84-1.2-9.6-0.2-10-0.5C175.8,310.79,175.83,308.66,176.81,308.17z"
                  />

                  <path
                    class="st16"
                    d="M225.06,311.17c-5.81-0.25-13.73,0.75-18.5-1.5c0.05,0-0.16-0.98,0.25-1c1.13-0.05,0.61,1.01,1,1
								c1.1-0.03,16.41,0.56,15.25-1.5C223.14,308.33,224.18,309.68,225.06,311.17z"
                  />

                  <path
                    class="st9"
                    d="M210.56,299.67c2.56,0.9,3.9-1.95,2.25,4.5C210.54,303.77,212.1,300.95,210.56,299.67z"
                  />
                </g>

                <g>
                  <path
                    class="st16"
                    d="M235.56,360.17c1.63-3.54-1.5-2.23-2-3.25c-0.46-0.93,1.12-9.92,0.5-12.75c-0.12-0.5-0.12-0.5-0.25-1
								c-12.9-0.01-26.01,0.11-38.75,1c-0.35,0.02-0.42,0.4-1.5,0.5c-1.5-1-1.5-1-3-2c0.62-0.68,1.34-0.74,1-2
								c15.41-0.42,30.84-0.35,46.25-1c0.38,10.12,0.38,10.12,0.75,20.25C237.06,360.04,237.06,360.04,235.56,360.17z"
                  />

                  <path
                    class="st102"
                    d="M191.56,340.67c0.34,1.26-0.38,1.32-1,2c-0.14,0.16,0.27,1.26-0.25,1.5c-0.28,0.13-4.99,0.34-6.25,0.5
								c-4.46,0.58-8.98-0.04-10.75,1.5c-0.6-0.65-0.77-1-1.75-1c-1.61,0-4.06,0.04-5.5,0c-0.17-0.01-0.33,0.01-0.5,0
								c-0.15,0-2.6-1-2.75-1c-6.29,0.13-4.65,0.5-4.75,1c-0.87,4.19,1.97,1.27-2.5,4c0.04-1.15-0.25-7.14,0.25-7.5
								C167.72,341.35,179.64,340.99,191.56,340.67z"
                  />

                  <path
                    class="st10"
                    d="M180.06,360.67c1.6,3.72-2.31,0.63-2.5,3c-7.08,0.31-14.19,0.22-21.25,1c-1.77-1.68-0.23-2.85-0.25-3
								C164.05,361.28,172.06,360.99,180.06,360.67z"
                  />

                  <path
                    class="st98"
                    d="M180.06,360.67c-8,0.32-16,0.62-24,1c-0.04-0.32,0.03-0.67,0-1c3.53,0.22,6.98-0.39,10.5-0.5
								c5.49-0.17,11.01-0.36,16.5-0.5C207.05,359.04,198.37,359.94,180.06,360.67z"
                  />

                  <path
                    class="st49"
                    d="M181.06,358.67c1.02-0.19,0.19-1.91,1-2.5c2.14-0.35,1.43,2.32,1,3.5c-5.49,0.14-11.01,0.33-16.5,0.5
								c1.23-1.48,0.25-1.68,0.5-3c0.32-0.03,0.71,0.07,1,0c1.41-0.34,1.45,0.09,2,0c0.39,1.06,0.49,0.62,1,0
								c0.4-0.48,0.89,0.28,1.5-3.5c-0.13,6.43,1.03,0.96,5.25,4.5C177.98,354.36,178.13,359.2,181.06,358.67z"
                  />

                  <path
                    class="st98"
                    d="M234.06,344.17c-0.92-0.28-5.97-0.64-6.25-0.5c-1.08,0.55-0.76,7.75-1.25,0.75
								c-1.23-1.61-2.14-0.2-2.5-0.25c-6.03-0.82-21.45,0.23-28.5,0.5c0.14-0.2-0.16-0.59-0.5-0.5c12.74-0.89,25.85-1.01,38.75-1
								C233.93,343.67,233.93,343.67,234.06,344.17z"
                  />

                  <g>
                    <path
                      class="st51"
                      d="M234.06,344.17c0.62,2.83-0.96,11.82-0.5,12.75c0.5,1.02,3.63-0.29,2,3.25
									c-19.35,0.66-38.67,2.66-58,3.5c0.19-2.37,4.1,0.72,2.5-3c18.32-0.73,26.99-1.63,3-1c0.43-1.18,1.14-3.85-1-3.5
									c-1.77,0.29-1.45,0.91-1,2.5c-2.92,0.53-3.07-4.3-3.25-0.5c-4.22-3.54-5.38,1.93-5.25-4.5c1.16-7.15-0.74-4.89-1.5-5.5
									c0.01-0.91,0.25-1.25-0.5-2c-0.03-0.02-0.56,0.11-0.5-0.5c0.09,0,1.37-0.25,1.5-0.5c0.98,0,1.15,0.35,1.75,1
									c1.77-1.54,6.29-0.92,10.75-1.5c3.07,0.13,6.47,0.28,9.5,0c1.08-0.1,1.15-0.48,1.5-0.5c0.34-0.09,0.64,0.3,0.5,0.5
									c-2.07,2.94,0.3,1.41,2,1.5c0.45,1.21,1.05,1.21,1.5,0c3.2,0.22,3.68-1.19,4.75,1.5c4.03-4.18,1.04,0.54,5,1
									c-3.75-3.88,3.64-4.57,1,1c1.39,0.35,0.3-6.59,5.75-3c0.89,0.58-1.2,2.83,2-0.5c1.98-0.39,1.69,0.04,2,0
									c-0.66,3.89,2.46,0.02,0.5-0.5c3.54-0.16,1.05,1.8,4.5-0.75c0.04-0.03-0.59-0.38-0.5-0.75c0.36,0.05,1.27-1.36,2.5,0.25
									c0.49,7,0.17-0.2,1.25-0.75C228.08,343.52,233.13,343.88,234.06,344.17z"
                    />

                    <g>
                      <path
                        class="st18"
                        d="M224.06,344.17c-0.09,0.37,0.54,0.72,0.5,0.75c-3.45,2.55-0.96,0.59-4.5,0.75
										c-0.04,0,0.18,0.42-0.5,0.5c-0.31,0.04-0.02-0.39-2,0c-0.66,0.13-1.2-0.15-2,0.5c-5.45-3.59-4.36,3.35-5.75,3
										c2.64-5.57-4.75-4.88-1-1c-3.96-0.46-0.97-5.18-5-1c-1.07-2.69-1.55-1.28-4.75-1.5c-1.57-0.11-0.83-0.98-1.25-1
										c-0.4-0.02-0.2,1-0.25,1c-1.7-0.09-4.07,1.44-2-1.5C202.61,344.39,218.03,343.34,224.06,344.17z"
                      />

                      <path
                        class="st16"
                        d="M227.56,354.67c0.25,0,0.25,0,0.5,0c1.05,8.04,2.72-2.85,3.75,3c7.05-0.21-9.3,2.03-16,0.5
										c4.77-0.57,9.43,0.97,9-2C226.69,359.71,227.19,357.46,227.56,354.67z"
                      />

                      <path
                        class="st48"
                        d="M193.56,344.67c-3.03,0.28-6.43,0.13-9.5,0c1.26-0.16,5.97-0.37,6.25-0.5
										c0.52-0.24,0.11-1.34,0.25-1.5C192.06,343.67,192.06,343.67,193.56,344.67z"
                      />

                      <path
                        class="st58"
                        d="M230.31,350.67c0.2,0.54,1.92,3.06,1,3.5C229.78,354.9,229.75,352.42,230.31,350.67z"
                      />

                      <path
                        class="st98"
                        d="M207.81,358.17c3.45-0.57,7.25,2.54-0.75,0.75C207.35,358.7,207.65,358.19,207.81,358.17z"
                      />

                      <path
                        class="st99"
                        d="M182.06,356.17c-0.81,0.59,0.02,2.31-1,2.5C180.6,357.07,180.28,356.46,182.06,356.17z"
                      />

                      <path
                        class="st8"
                        d="M219.56,346.17c0.68-0.08,0.46-0.5,0.5-0.5C222.02,346.19,218.89,350.05,219.56,346.17z"
                      />

                      <path
                        class="st57"
                        d="M207.31,350.67c1.28,0.94,0.26,1.03,0.25,1.25C207.41,356.9,206.46,351.47,207.31,350.67z"
                      />

                      <path
                        class="st57"
                        d="M217.56,346.17c-3.2,3.33-1.11,1.08-2,0.5C216.36,346.01,216.89,346.3,217.56,346.17z"
                      />

                      <path
                        class="st57"
                        d="M184.81,351.67c0.39,0,0.39,3,0,3S184.42,351.67,184.81,351.67z"
                      />

                      <path
                        class="st101"
                        d="M199.06,346.17c-0.45,1.21-1.05,1.21-1.5,0c0.05,0-0.15-1.02,0.25-1
										C198.23,345.19,197.49,346.06,199.06,346.17z"
                      />

                      <path
                        class="st16"
                        d="M199.81,358.67c1.93,0.16-0.68,1.92-1.25,0.75C198.52,359.35,199.73,358.66,199.81,358.67z"
                      />

                      <path
                        class="st48"
                        d="M201.31,358.67c0.09-0.04,1.77,0.66,1.75,0.75C202.9,360.24,199.82,359.37,201.31,358.67z"
                      />

                      <path
                        class="st100"
                        d="M227.81,349.67c0.05-0.05,0.62,0.32,0.5,1C227.92,352.89,226.93,350.44,227.81,349.67z"
                      />

                      <path
                        class="st102"
                        d="M178.31,347.67c0.42,0.18,0.62,1.52-0.5,1.5C177.44,349.16,178.22,347.63,178.31,347.67z"
                      />

                      <path
                        class="st103"
                        d="M198.81,352.67c0.64,0.45,0.27,2.2-0.5,1C197.99,353.17,198.75,352.63,198.81,352.67z"
                      />

                      <path
                        class="st98"
                        d="M213.31,358.17c0.64,0.45,0.27,2.2-0.5,1C212.49,358.67,213.25,358.13,213.31,358.17z"
                      />

                      <path
                        class="st57"
                        d="M190.81,356.17c0.83-0.17,1.27-0.11,1.25,0.75C192.05,357.34,190.01,356.33,190.81,356.17z"
                      />

                      <path
                        class="st99"
                        d="M184.81,356.17c0.08-0.01,0.94,0.74,0.75,1.25C185.26,358.19,183.98,356.25,184.81,356.17z"
                      />

                      <path
                        class="st104"
                        d="M215.81,355.67c0.29-0.14,1.25-0.02,1.25,0.25C217.06,356.49,214.91,356.1,215.81,355.67z"
                      />

                      <path
                        class="st104"
                        d="M194.81,355.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
										s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C194.68,355.29,194.68,355.29,194.81,355.17z"
                      />

                      <path
                        class="st48"
                        d="M219.81,353.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
										s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C219.68,353.79,219.68,353.79,219.81,353.67z"
                      />

                      <path
                        class="st105"
                        d="M228.06,354.67c-0.25,0-0.25,0-0.5,0c0.07-0.53-0.17-1.5,0.25-1.5
										C228.27,353.47,227.98,354.1,228.06,354.67z"
                      />

                      <path
                        class="st83"
                        d="M192.81,352.17c0.38,0,0.38,1.5,0,1.5S192.42,352.17,192.81,352.17z"
                      />

                      <path
                        class="st59"
                        d="M188.56,352.17c0.25,0,0.25,0,0.5,0C189.06,354.16,188.56,354.16,188.56,352.17z"
                      />

                      <path
                        class="st100"
                        d="M216.31,351.17c0.12,0.12,0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25
										c-0.12,0.12-0.12,0.12-0.25,0.25c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C216.18,351.29,216.18,351.29,216.31,351.17z"
                      />

                      <path
                        class="st100"
                        d="M212.81,350.67c0.38,0,0.38,1.5,0,1.5S212.42,350.67,212.81,350.67z"
                      />

                      <path
                        class="st99"
                        d="M189.06,352.17c-0.25,0-0.25,0-0.5,0C188.56,350.17,189.06,350.17,189.06,352.17z"
                      />

                      <path
                        class="st100"
                        d="M224.31,350.17c0.38,0,0.38,1.5,0,1.5S223.92,350.17,224.31,350.17z"
                      />

                      <path
                        class="st16"
                        d="M224.31,346.17c0.38,0,0.38,1.5,0,1.5S223.92,346.17,224.31,346.17z"
                      />
                    </g>
                  </g>

                  <path
                    class="st48"
                    d="M165.56,345.17c0.05,0.62-0.48,0.47-0.5,0.5c-2.25-0.25-2.25-0.25-4.5-0.5c-1.25,0-1.25,0-2.5,0
								c0.1-0.5-1.54-0.87,4.75-1C162.95,344.16,165.41,345.16,165.56,345.17z"
                  />

                  <g>
                    <path
                      class="st51"
                      d="M160.56,345.17c-0.14,2.74,0.98,1.01,3.5,1.5c0,0.54-0.11,1.54,0.25,1.5c0.5-0.06,0.1-1.27,0.25-1.5
									c0.4-0.62,0.38-0.78,0.5-1c0.02-0.03,0.55,0.12,0.5-0.5c0.17,0.01,0.33-0.01,0.5,0c1.3-0.21,2.75,0.44,4,0.5
									c-0.06,0.61,0.47,0.48,0.5,0.5c0.04,0.84-0.33,1.34,0.5,2c0.76,0.61,2.66-1.65,1.5,5.5c-0.61,3.78-1.1,3.02-1.5,3.5
									c-1.39-1.96-0.89-0.02-1,0c-0.55,0.09-0.59-0.34-2,0c-0.38-1-0.38-1-0.75-2c-0.52,0.45-0.12,1.33-0.25,2
									c-0.25,1.32,0.73,1.52-0.5,3c-3.52,0.11-6.97,0.72-10.5,0.5c-0.33-3.92-0.63-7.56-0.5-11.5c4.47-2.73,1.63,0.19,2.5-4
									C159.31,345.17,159.31,345.17,160.56,345.17z"
                    />

                    <g>
                      <path
                        class="st48"
                        d="M171.56,345.17c-0.13,0.25-1.41,0.5-1.5,0.5c-1.25-0.06-2.7-0.71-4-0.5
										C167.5,345.21,169.95,345.17,171.56,345.17z"
                      />

                      <path
                        class="st57"
                        d="M171.06,348.17c-0.83-0.66-0.46-1.16-0.5-2C171.31,346.92,171.07,347.26,171.06,348.17z"
                      />

                      <path
                        class="st49"
                        d="M165.06,345.67c-0.12,0.22-0.1,0.38-0.5,1c-0.11-1.14-0.48,0-0.5,0c-2.52-0.49-3.64,1.24-3.5-1.5
										C162.81,345.42,162.81,345.42,165.06,345.67z"
                      />

                      <path
                        class="st103"
                        d="M168.06,357.17c-0.29,0.07-0.68-0.03-1,0c0.13-0.67-0.27-1.55,0.25-2
										C167.68,356.17,167.68,356.17,168.06,357.17z"
                      />

                      <path
                        class="st103"
                        d="M161.31,347.67c0.39,0,0.39,3,0,3S160.92,347.67,161.31,347.67z"
                      />

                      <path
                        class="st106"
                        d="M164.56,346.67c-0.15,0.23,0.25,1.44-0.25,1.5c-0.36,0.04-0.25-0.96-0.25-1.5
										C164.08,346.67,164.44,345.53,164.56,346.67z"
                      />

                      <path
                        class="st104"
                        d="M161.31,352.67c0.06-0.04,0.82,0.51,0.5,1C161.04,354.86,160.67,353.12,161.31,352.67z"
                      />

                      <path
                        class="st100"
                        d="M164.31,352.67c0.64,0.45,0.27,2.2-0.5,1C163.49,353.17,164.25,352.63,164.31,352.67z"
                      />

                      <path
                        class="st107"
                        d="M161.31,356.67c0.75-0.3,1.1,0.76,0.5,1C161.06,357.97,160.71,356.91,161.31,356.67z"
                      />

                      <path
                        class="st48"
                        d="M164.31,356.17c0.09-0.04,0.86,1.49,0.5,1.5C163.68,357.69,163.88,356.35,164.31,356.17z"
                      />

                      <path
                        class="st100"
                        d="M171.06,357.17c-0.51,0.62-0.61,1.06-1,0C170.17,357.15,169.66,355.2,171.06,357.17z"
                      />

                      <path
                        class="st106"
                        d="M169.81,353.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5
										c-0.12,0.12-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25
										C169.68,353.29,169.68,353.29,169.81,353.17z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>

          <g>
            <path
              class="st2"
              d="M249.06,116.67c-0.06,0.17,0.01,1.51-0.5,3c-0.13,0.38,0.13,1.11,0,1.5c-0.37,1.13-1.19,2.39-1.5,3.5
					c-0.35,0.04-0.82-0.07-1,0c-3.48,1.41-5.87,10.86-2,12.5c-0.12,3.96,1.04,7.84,1.5,11.75c-8.09,9.05-10.27,20.44-4,31.25
					c5.65,9.75,9.3,5.89,10.5,13c1.87,11.06-11.48,17.54-18,25c1.04-3.25-2.07-2.33-4.5-2.5c-7.78-0.55-14.68,0.96-22.25,0
					c-0.39,0.13,0.21,0.97,0.25,1c-2.75-0.91-5.41-1.89-8.25-2.5c-1.5-0.24-2.8,0.36-4.25,0.5c-1.19,0.11-7.79,1.53-9.5,2
					c0-0.5,0-0.5,0-1c1.46-0.24,3.7-0.26,4.75-1.5c-7.72-0.24-15.55,0.46-23.25-0.5c-4.85-0.6-15.5-4.77-17-2.5
					c-1.18-0.42-2.34-1.09-3.5-1.5c-1.58-0.55-2.5-0.67-4-1c-0.05-0.01,0.18-0.69-1-0.5c0.54-1.07,1.18-1.66,2.25-2
					c7.29-2.31,92.76,4.14,97.5,3c2.35-0.56,8.31-7.2,3-8.5c-5.02-1.22-87.39-3.14-103.25-4.5c0.28-12.31-0.05-24.68,0-37
					c0.02-4.4,0.5-3.3,0.5-3.5c47.62,3,47.62,3,95.25,6c1.62-4.12,1.62-4.12,3.25-8.25c-33.06-1.56-66.03-4.75-99-7.75
					c0.03-14.33-0.1-28.67,0-43c45.62,4.75,45.62,4.75,91.25,9.5c2.54,1.19,10.5,1.19,12,2
					C246.79,115.51,243.79,118.1,249.06,116.67z"
            />

            <g>
              <path
                class="st72"
                d="M146.56,209.67c-2.66,3.62-3.28,3.25-4-1C144.06,208.99,144.98,209.11,146.56,209.67z"
              />

              <g>
                <g>
                  <path
                    class="st99"
                    d="M234.56,124.67c0.87,0.21,1.19,0.21,1.75-0.5c2.34,1.2,1.09,15.79,2.25,19.25
								c-10.36,2.81-29.74,0.21-42.5-0.75c-0.33-2.06,1.89-1.79,0-3c4.47,0.35,31.18,2.99,32.75,2.5c2.23-0.69,1.11-3.34,1.5-3.5
								c1.51-0.61,3.72,6.12,4-7c0.12,2.38,0.12,2.38,0.25,4.75c0.5,0,0.5,0,1,0c0.05-2.72,0.5-12.48-1.25-5.75
								c0-4.41-1.83-5.17-3-1c-3.96-8.33-2.44,10.67-3.75-1.75c0.45-1.96,5.87-1.38,0.25-1.75c-0.74-4.63,1.08,1.92,3-2
								C231.23,128.07,232.13,127.75,234.56,124.67z"
                  />

                  <path
                    class="st57"
                    d="M169.56,137.17c8.83,0.63,17.67,1.81,26.5,2.5c1.89,1.21-0.33,0.94,0,3
								c-13.59-1.02-27.14-2.66-40.75-3.5c-0.49-0.26-0.14-1.06-0.25-1.5c0.32-0.04,0.75,0.07,1,0
								C160.79,136.29,164.94,138.51,169.56,137.17z"
                  />

                  <path
                    class="st55"
                    d="M201.56,117.17c0,1.25,0,1.25,0,2.5c-14.85-1.37-29.85-2.08-44.5-5c-0.01-0.05-0.86,0.21,0-1
								C159.58,112.59,195.37,116.49,201.56,117.17z"
                  />

                  <path
                    class="st108"
                    d="M202.06,119.67c0-1.25,0-1.25,0-2.5c6.84,0.75,28.02,2.91,30.75,3.5c9.03,1.94,0.04,2.16-3.5,2
								C220.81,122.28,210.65,120.45,202.06,119.67z"
                  />

                  <path
                    class="st10"
                    d="M202.06,119.67c-0.02,0,0.04,0.05-0.5,0c0-1.25,0-1.25,0-2.5c0.16,0.02,0.34-0.02,0.5,0
								C202.06,118.42,202.06,118.42,202.06,119.67z"
                  />

                  <g>
                    <path
                      class="st53"
                      d="M157.06,113.67c-0.86,1.21-0.01,0.95,0,1c0.24,0.92-0.34,1.5,1.25,2c3.87,1.21,52.68,4.97,63.5,6
									c1.8,6.95,0.06,0.1,2.75,2.25c-4.41-4.31,6.08-0.26,9.25-1.25c0.78,0.57,0.69,0.99,0.75,1c-2.43,3.08-3.33,3.4-3.75-0.5
									c-1.92,3.92-3.74-2.63-3,2c5.62,0.37,0.2-0.21-0.25,1.75c1.31,12.42-0.21-6.58,3.75,1.75c1.17-4.17,3-3.41,3,1
									c1.75-6.73,1.3,3.03,1.25,5.75c-0.5,0-0.5,0-1,0c-0.12-2.38-0.12-2.38-0.25-4.75c-0.28,13.12-2.49,6.39-4,7
									c-0.39,0.16,0.73,2.81-1.5,3.5c-1.57,0.49-28.28-2.15-32.75-2.5c-8.83-0.69-17.67-1.87-26.5-2.5
									c-6.35-0.45-15.04-1.57-13.5,0.5c-0.25,0.07-0.68-0.04-1,0c-0.71-2.85,0.8-18.7,0.5-23.75
									C155.83,113.39,156.68,113.82,157.06,113.67z"
                    />

                    <g>
                      <path
                        class="st109"
                        d="M159.81,133.17c1.32-0.3,23.03,2.18,27,2.5c0.85,0.07,5.7-0.53,6-0.5c0.09,0.01,1.41,0.99,1.5,1
										c8.58,0.79,17.3,0.85,25.75,2.75c-1.04,1.64-2.35-0.21-2.75-0.25c-19.51-1.76-38.35-2.68-58-4.5
										C158.79,134.01,159.61,133.21,159.81,133.17z"
                      />

                      <path
                        class="st57"
                        d="M217.81,123.17c1.18,0.26-1.12,3.09,1.75,2.75c-5.2,6,0.94-2.75-5.75,1.75
										c-0.78,0.52,0.69,3.91-1.75,0.25C217.83,125.98,217.43,123.08,217.81,123.17z"
                      />

                      <path
                        class="st48"
                        d="M169.56,137.17c-4.62,1.34-8.77-0.87-13.5,0.5C154.52,135.59,163.2,136.72,169.56,137.17z"
                      />

                      <path
                        class="st99"
                        d="M157.56,124.67c0.25,0,0.25,0,0.5,0c0.23,2.38,0.04,5.11-0.25,7.5
										C157.43,132.17,157.48,125.43,157.56,124.67z"
                      />

                      <path
                        class="st99"
                        d="M231.31,130.67c1.01,8.17-0.96,8.15-0.25,0.75c0-0.25,0-0.25,0-0.5
										C231.18,130.79,231.18,130.79,231.31,130.67z"
                      />

                      <path
                        class="st99"
                        d="M210.31,128.17c0.79,0.61-0.35,8.22-0.25,1.75C210.06,129.42,208,129.21,210.31,128.17z"
                      />

                      <path
                        class="st99"
                        d="M202.56,124.17c-0.01,0.2,0.76,1.4-0.75,4C201.36,126.83,202.18,125.38,202.56,124.17z"
                      />

                      <path
                        class="st99"
                        d="M228.31,133.17c0.25,0,0.45,3.79,0.25,4.25C228,138.67,227.78,133.17,228.31,133.17z"
                      />

                      <path
                        class="st110"
                        d="M195.81,122.17c0.84,0,0.7,2.04-0.5,2C194.02,124.12,195.28,122.17,195.81,122.17z"
                      />

                      <path
                        class="st103"
                        d="M160.81,118.67c0.09-0.06,1.77,1.14,1.75,1.25C162.2,121.63,158.75,120.2,160.81,118.67z"
                      />

                      <path
                        class="st111"
                        d="M158.06,119.17c0.07,0.13-0.07,0.37,0,0.5c-0.25,0.5-0.25,0.5-0.5,1c-0.25-1-0.25-1-0.5-2
										C157.56,118.92,157.56,118.92,158.06,119.17z"
                      />

                      <path
                        class="st100"
                        d="M176.81,120.67c0.59,0.07,1.33-0.12,1.5,0C179.61,121.55,177.58,123.07,176.81,120.67z"
                      />

                      <path
                        class="st103"
                        d="M213.81,130.67c1.54-0.2,0.34,1.87-0.5,1.5C212.62,131.86,213.47,130.71,213.81,130.67z"
                      />

                      <path
                        class="st99"
                        d="M186.81,130.67c1.3-0.47,1.72,1.08,1,1.5C187.22,132.5,186.57,131.11,186.81,130.67z"
                      />

                      <path
                        class="st99"
                        d="M187.81,125.67c0.54,0.31,0.43,2.42-0.5,2C186.48,127.29,187.55,125.52,187.81,125.67z"
                      />

                      <path
                        class="st112"
                        d="M198.81,125.17c1.37-0.28,0.25,0.67,0.25,0.75C198.88,129.78,197.72,125.39,198.81,125.17z"
                      />

                      <path
                        class="st113"
                        d="M222.31,138.17c0.1,0,1.77,0.66,1.75,0.75C223.82,140.15,218.88,138.27,222.31,138.17z"
                      />

                      <path
                        class="st103"
                        d="M181.31,130.17c0.54,0.31,0.43,2.42-0.5,2C179.98,131.79,181.05,130.02,181.31,130.17z"
                      />

                      <path
                        class="st8"
                        d="M160.81,130.17c1.47,0.74-1.18,2.42-1.75,1.25C159.01,131.32,160.71,130.12,160.81,130.17z"
                      />

                      <path
                        class="st100"
                        d="M199.81,122.17c0.76,0.22-0.37,2.56-0.5,2.5C198.56,124.34,199.31,122.02,199.81,122.17z"
                      />

                      <path
                        class="st114"
                        d="M160.31,127.17c1.54-0.97,1.02,1.44,0.5,1.5C160.63,128.69,159.59,127.62,160.31,127.17z"
                      />

                      <path
                        class="st102"
                        d="M198.81,130.17c0.17-0.05,1.1,1.05,0.75,1.75C199.14,132.75,197.91,130.43,198.81,130.17z"
                      />

                      <path
                        class="st100"
                        d="M190.81,126.17c1.29-0.72,0.25,2.11,0,2C190.41,127.99,190.4,126.39,190.81,126.17z"
                      />

                      <path
                        class="st48"
                        d="M190.81,122.17c0.97,0,0.33,2,0,2S189.84,122.17,190.81,122.17z"
                      />

                      <path
                        class="st115"
                        d="M195.81,126.67c0.81,0.35-0.04,2.38-0.75,1.25C194.8,127.51,195.73,126.64,195.81,126.67z"
                      />

                      <path
                        class="st112"
                        d="M170.81,127.17c0.88-1.09,0.34,2.04,0,2C170.48,129.13,170.34,127.74,170.81,127.17z"
                      />

                      <path
                        class="st104"
                        d="M177.31,124.67c0.98-0.26,1,1.29,0.5,1.5C177.62,126.25,176.54,124.87,177.31,124.67z"
                      />

                      <path
                        class="st112"
                        d="M177.81,127.17c0.39,0,0.39,2.5,0,2.5S177.42,127.17,177.81,127.17z"
                      />

                      <path
                        class="st48"
                        d="M184.31,130.17c0.39,0,0.39,2.5,0,2.5S183.92,130.17,184.31,130.17z"
                      />

                      <path
                        class="st48"
                        d="M173.31,120.67c1.05-0.36,1.77,0.52,1,1C173.86,121.95,172.72,120.87,173.31,120.67z"
                      />

                      <path
                        class="st48"
                        d="M194.81,130.17c0.07-0.03,1.25,0.68,1.25,0.75C196.06,132.16,193.12,130.93,194.81,130.17z"
                      />

                      <path
                        class="st83"
                        d="M225.81,138.67c0.42-0.25,1.28,0.68,1.25,0.75C226.68,140.25,224.69,139.35,225.81,138.67z"
                      />

                      <path
                        class="st103"
                        d="M220.31,134.67c0.07-0.03,1.01,0.84,0.75,1.25C220.35,137.04,219.49,135.02,220.31,134.67z"
                      />

                      <path
                        class="st104"
                        d="M180.81,121.67c1.05-0.36,1.77,0.52,1,1C181.36,122.95,180.22,121.87,180.81,121.67z"
                      />

                      <path
                        class="st100"
                        d="M195.31,133.17c1.53-0.17-0.1,1.65-0.5,1.5C194.11,134.4,194.98,133.2,195.31,133.17z"
                      />

                      <path
                        class="st116"
                        d="M180.81,126.67c1.12-0.02,0.92,1.32,0.5,1.5C181.22,128.2,180.44,126.67,180.81,126.67z"
                      />

                      <path
                        class="st9"
                        d="M187.81,122.17c0.06-0.04,0.82,0.51,0.5,1C187.54,124.36,187.17,122.62,187.81,122.17z"
                      />

                      <path
                        class="st117"
                        d="M209.81,133.67c0.64,0.45,0.27,2.2-0.5,1C208.99,134.17,209.75,133.63,209.81,133.67z"
                      />

                      <path
                        class="st104"
                        d="M184.31,122.17c1.29-0.68,1.44,0.89,0.5,1C184.75,123.17,183.8,122.44,184.31,122.17z"
                      />

                      <path
                        class="st103"
                        d="M204.81,134.17c1.29-0.68,1.44,0.89,0.5,1C205.25,135.17,204.3,134.44,204.81,134.17z"
                      />

                      <path
                        class="st106"
                        d="M225.81,135.67c0.06-0.04,0.82,0.51,0.5,1C225.54,137.86,225.17,136.12,225.81,135.67z"
                      />

                      <path
                        class="st48"
                        d="M168.31,124.17c0.75-0.3,1.1,0.76,0.5,1C168.06,125.47,167.71,124.41,168.31,124.17z"
                      />

                      <path
                        class="st103"
                        d="M167.31,131.17c0.75-0.3,1.1,0.76,0.5,1C167.06,132.47,166.71,131.41,167.31,131.17z"
                      />

                      <path
                        class="st118"
                        d="M190.31,130.67c1.29-0.68,1.44,0.89,0.5,1C190.75,131.67,189.8,130.94,190.31,130.67z"
                      />

                      <path
                        class="st105"
                        d="M173.81,124.67c0.75-0.3,1.1,0.76,0.5,1C173.56,125.97,173.21,124.91,173.81,124.67z"
                      />

                      <path
                        class="st35"
                        d="M163.81,130.67c0.06-0.04,0.82,0.51,0.5,1C163.54,132.86,163.17,131.12,163.81,130.67z"
                      />

                      <path
                        class="st48"
                        d="M164.81,127.67c1.16,0.61-0.88,1.62-1.25,0.75C163.53,128.35,164.74,127.63,164.81,127.67z"
                      />

                      <path
                        class="st99"
                        d="M180.81,124.67c0.75-0.3,1.1,0.76,0.5,1C180.56,125.97,180.21,124.91,180.81,124.67z"
                      />

                      <path
                        class="st37"
                        d="M158.06,119.17c-0.5-0.25-0.5-0.25-1-0.5C157.85,117.02,157.9,118.88,158.06,119.17z"
                      />

                      <path
                        class="st104"
                        d="M157.56,120.67c0.25-0.5,0.25-0.5,0.5-1C158.08,119.72,159.27,119.81,157.56,120.67z"
                      />

                      <path
                        class="st50"
                        d="M184.31,125.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5
										c-0.12,0.12-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25
										C184.18,125.29,184.18,125.29,184.31,125.17z"
                      />

                      <path
                        class="st37"
                        d="M163.81,119.67c0.29-0.14,1.25-0.02,1.25,0.25C165.06,120.49,162.91,120.1,163.81,119.67z"
                      />

                      <path
                        class="st98"
                        d="M184.31,126.67c0.38,0,0.38,1.5,0,1.5S183.92,126.67,184.31,126.67z"
                      />

                      <path
                        class="st37"
                        d="M167.56,120.67c-0.25,0-0.25,0-0.5,0C167.16,119.35,167.73,119.3,167.56,120.67z"
                      />

                      <path
                        class="st104"
                        d="M170.81,120.17c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
										c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
										S170.68,120.29,170.81,120.17z"
                      />

                      <path
                        class="st99"
                        d="M220.31,127.67c0.38,0,0.38,1.5,0,1.5S219.92,127.67,220.31,127.67z"
                      />

                      <path
                        class="st118"
                        d="M167.81,128.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
										s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C167.68,128.29,167.68,128.29,167.81,128.17z"
                      />

                      <path
                        class="st114"
                        d="M173.31,129.67c0.29-0.14,1.25-0.02,1.25,0.25C174.56,130.49,172.41,130.1,173.31,129.67z"
                      />

                      <path
                        class="st49"
                        d="M167.06,120.67c0.25,0,0.25,0,0.5,0C167.28,122.89,166.9,122.57,167.06,120.67z"
                      />

                      <path
                        class="st119"
                        d="M217.31,130.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
										s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C217.18,130.29,217.18,130.29,217.31,130.17z"
                      />

                      <path
                        class="st118"
                        d="M170.81,124.17c0.38,0,0.38,1.5,0,1.5S170.42,124.17,170.81,124.17z"
                      />

                      <path
                        class="st107"
                        d="M170.31,131.17c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
										c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
										S170.18,131.29,170.31,131.17z"
                      />

                      <path
                        class="st107"
                        d="M163.81,123.67c0.38,0,0.38,1.5,0,1.5S163.42,123.67,163.81,123.67z"
                      />

                      <path
                        class="st118"
                        d="M220.31,131.17c0.38,0,0.38,1.5,0,1.5S219.92,131.17,220.31,131.17z"
                      />

                      <path
                        class="st109"
                        d="M228.31,138.67c0.12,0.12,0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25
										c-0.12,0.12-0.12,0.12-0.25,0.25c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C228.18,138.79,228.18,138.79,228.31,138.67z"
                      />

                      <path
                        class="st104"
                        d="M173.31,131.67c0.29-0.14,1.25-0.02,1.25,0.25C174.56,132.49,172.41,132.1,173.31,131.67z"
                      />

                      <path
                        class="st35"
                        d="M160.81,123.67c0.38,0,0.38,1.5,0,1.5S160.42,123.67,160.81,123.67z"
                      />

                      <path
                        class="st105"
                        d="M158.06,124.67c-0.25,0-0.25,0-0.5,0c0.06-0.6-0.2-1.21,0.25-1.5
										C158.21,123.17,158,124.13,158.06,124.67z"
                      />

                      <path
                        class="st99"
                        d="M202.56,124.17c0.14-0.43-0.26-1.14,0.25-1.5C203.63,124.07,202.56,124.09,202.56,124.17z"
                      />
                    </g>
                  </g>
                </g>

                <g>
                  <path
                    class="st120"
                    d="M221.06,168.17c1.74,2.85-3.59,0.61-4,2.5c-21.5-1.75-21.5-1.75-43-3.5c-1.96,0.74,0.69-0.11-1.5-0.5
								c-0.48-0.08-1.02,0.07-1.5,0c-3.03-0.46-5.94-0.78-9-1c0.02-1.73-1.91-0.55,0-2C181.68,164.72,201.48,166.35,221.06,168.17z"
                  />

                  <path
                    class="st16"
                    d="M156.56,163.17c-2.23,5.95-0.41,16.55-1,24c-0.1-0.02-0.91,1.34-2-0.25c0-11.5,0-11.5,0-23
								C154.34,162.78,155.47,163.23,156.56,163.17z"
                  />

                  <path
                    class="st16"
                    d="M217.06,170.67c8.38,0.75,8.38,0.75,16.75,1.5c-14-0.75-14-0.75-28-1.5c-1.34,0.54-0.5,3.43-0.75,4.5
								c-1.74,0.57,0.17-2.24-0.5-3.75c-0.54-1.22-2.15-0.54-3-0.75c-0.26-0.06-0.69-0.02-1,0c-0.13,0.01-1.68-1.44-2.5,0.25
								c-0.25,0.52,0.35,3.23-0.25,3.25c0.79-4.77-4.17-4.69-4.5-4.5c-0.34,0.19,0.08,5.31-0.5,6c-0.67,0,0.98-10.02-3-4.5
								c0.7-2.32-8.19-2.97-8-1c-0.55-2.23-2.96-1.42-5.25-1.5c-1.25-0.75-1.25-0.75-2.5-1.5
								C195.56,168.92,195.56,168.92,217.06,170.67z"
                  />

                  <g>
                    <path
                      class="st49"
                      d="M169.56,167.67c-0.11,3.96,1.06,0.5,1.25,0.5c0.38,0,0.13,1,0.5,1c0.19,0,0.8-0.99,1-1
									c0.23-0.01-0.81,0.33,4.25,0.5c2.29,0.08,4.7-0.73,5.25,1.5c-0.19-1.97,8.7-1.32,8,1c3.98-5.52,2.33,4.5,3,4.5
									c0.58-0.69,0.16-5.81,0.5-6c0.33-0.19,5.29-0.27,4.5,4.5c0.6-0.02,0-2.73,0.25-3.25c0.82-1.69,2.37-0.24,2.5-0.25
									c0.66,1.54,1.05,2.29,1,0c0.85,0.21,2.46-0.47,3,0.75c0.67,1.51-1.24,4.32,0.5,3.75c-0.19,0.82-0.97,2.63-1,3
									c-0.1,1.21-0.08,2.78,0,4c-4.29,0.49-2.53-0.8-3.25-4c0.07,6.78-1.58,5.7-1.75,6c-0.06,0.1-2.09-0.16,0,1
									c-0.75,0.5-0.75,0.5-1.5,1c-1.88-0.12-3.64,0.06-5.5,0c-0.08-0.01-0.87-0.93-1.25-1c-2.01-0.38-7.91,0.68,1.25,1
									c9.11,1.45,23.08,1.68,24.25,2c0.18,0.05,0.15,2.6,2.75,1.75c-3-3.36,9.16,0.74,9.5-1.75c1.07,0.02,4.02,1.13,6.5,0.25
									c0.5-8.88,0.5-8.88,1-17.75c2.11,4.63,2.09,15.36,2.25,21c-21.4-1.66-59.85-1.46-78.25-3.5c-0.81-5.95,12.73,1.89,10.5-2.5
									c4.94,0.22,10.32,0.1,15.25-0.5c-7.92-0.27-15.82-0.78-23.75-1c-1.17-2.29-3.04-3.09,1-2.75c2.5-21.44-0.06,4.48,3.25,0.25
									c0.58-0.74,0.02-1.81,0.25-2.5c0.35-1.06,1.59-2.6,0-3c-0.61-7.49,0.38-1.85,1.5-6.25c-2.2-0.24-1.4-1.3-1.5-3.25
									C167.97,166.84,169.27,167.65,169.56,167.67z"
                    />

                    <g>
                      <path
                        class="st48"
                        d="M162.06,184.17c7.93,0.22,15.83,0.73,23.75,1c-4.93,0.6-10.31,0.72-15.25,0.5
										C165.27,185.43,147.74,183.77,162.06,184.17z"
                      />

                      <path
                        class="st121"
                        d="M174.06,167.17c1.25,0.75,1.25,0.75,2.5,1.5c-5.06-0.17-4.02-0.51-4.25-0.5c-0.2,0.01-0.81,1-1,1
										c-0.37,0-0.12-1-0.5-1c-0.19,0-1.36,3.46-1.25-0.5c0.08,0.01-0.54-0.3,1.5-0.5c0.78-0.08,1.53,0.26,1.5-0.5
										C174.74,167.05,172.1,167.91,174.06,167.17z"
                      />

                      <path
                        class="st57"
                        d="M192.06,186.17c-9.16-0.32-3.26-1.38-1.25-1C191.19,185.24,191.98,186.15,192.06,186.17z"
                      />

                      <path
                        class="st59"
                        d="M183.31,179.17c1.14,0.08,1.62,4.33-0.25,2.75C184.32,180.88,182.86,179.14,183.31,179.17z"
                      />

                      <path
                        class="st19"
                        d="M201.56,170.67c0.05,2.29-0.34,1.54-1,0C200.87,170.65,201.29,170.6,201.56,170.67z"
                      />

                      <path
                        class="st100"
                        d="M192.31,178.17c1.29-0.68,1.44,0.89,0.5,1C192.75,179.17,191.8,178.44,192.31,178.17z"
                      />

                      <path
                        class="st6"
                        d="M195.81,183.67c0.64,0.45,0.27,2.2-0.5,1C194.99,184.17,195.75,183.63,195.81,183.67z"
                      />

                      <path
                        class="st106"
                        d="M172.81,181.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
										s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
										C172.68,181.29,172.68,181.29,172.81,181.17z"
                      />
                    </g>
                  </g>

                  <g>
                    <path
                      class="st51"
                      d="M236.06,170.67c-0.5,8.88-0.5,8.88-1,17.75c-2.48,0.88-5.43-0.23-6.5-0.25c-10.43-0.2-20.62-1.33-31-2
									c0.75-0.5,0.75-0.5,1.5-1c0-0.5,0-0.5,0-1c0.17-0.3,1.82,0.78,1.75-6c0.72,3.2-1.04,4.49,3.25,4c0.42,6.53,1.56-0.17,0-4
									c0.03-0.37,0.81-2.18,1-3c0.25-1.07-0.59-3.96,0.75-4.5c14,0.75,14,0.75,28,1.5c-8.38-0.75-8.38-0.75-16.75-1.5
									c0.41-1.89,5.74,0.35,4-2.5c4.92,0.46,9.88,0.32,14.75,1C236.33,169.5,235.9,170.33,236.06,170.67z"
                    />

                    <g>
                      <path
                        class="st57"
                        d="M197.56,186.17c10.38,0.67,20.57,1.8,31,2c-0.34,2.49-12.5-1.61-9.5,1.75
										c-2.6,0.85-2.57-1.7-2.75-1.75c-1.17-0.32-15.14-0.55-24.25-2C193.92,186.23,195.68,186.05,197.56,186.17z"
                      />

                      <path
                        class="st101"
                        d="M204.06,182.17c-0.08-1.22-0.1-2.79,0-4C205.61,181.99,204.47,188.7,204.06,182.17z"
                      />

                      <path
                        class="st57"
                        d="M199.06,184.17c0,0.5,0,0.5,0,1C196.97,184.01,199,184.27,199.06,184.17z"
                      />

                      <path
                        class="st48"
                        d="M221.31,174.17c0.97-0.09,6.96-0.15,7.25,0.25c-0.92,9.81-1.76,11.82-1.25,0.75
										c-3.55-1.03-9.01,1.44-9.5,1.5C211.18,177.46,219.26,174.36,221.31,174.17z"
                      />

                      <path
                        class="st106"
                        d="M231.31,174.17c2.57-0.89,1.7,4.86,0.5,4.5C232.59,175.7,231.07,174.25,231.31,174.17z"
                      />

                      <path
                        class="st101"
                        d="M231.31,185.17c0.07-0.05,1.72,0.17,1.75,0.25C233.81,187.95,229.4,186.36,231.31,185.17z"
                      />

                      <path
                        class="st57"
                        d="M231.31,179.67c1.31-0.52-0.36,2.04-0.5,2C230.26,181.52,230.5,179.99,231.31,179.67z"
                      />

                      <path
                        class="st18"
                        d="M209.31,181.17c2.23,0.23-1.62,2.33-1.25,0.75C208.07,181.85,209.23,181.16,209.31,181.17z"
                      />

                      <path
                        class="st122"
                        d="M210.81,182.67c0.88-1.09,0.34,2.04,0,2C210.48,184.63,210.34,183.24,210.81,182.67z"
                      />

                      <path
                        class="st101"
                        d="M207.81,173.17c0.12-0.01,0.71,1.99,0.5,2C207.06,175.23,207.5,173.2,207.81,173.17z"
                      />

                      <path
                        class="st49"
                        d="M220.31,177.67c1.12-0.02,0.92,1.32,0.5,1.5C220.72,179.2,219.94,177.67,220.31,177.67z"
                      />

                      <path
                        class="st101"
                        d="M227.31,185.17c0.29-0.14,1.25-0.02,1.25,0.25C228.56,185.99,226.41,185.6,227.31,185.17z"
                      />

                      <path
                        class="st117"
                        d="M216.81,183.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5
										c-0.12,0.12-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25
										C216.68,183.79,216.68,183.79,216.81,183.67z"
                      />

                      <path
                        class="st103"
                        d="M224.31,183.17c0.38,0,0.38,1.5,0,1.5S223.92,183.17,224.31,183.17z"
                      />

                      <path
                        class="st123"
                        d="M211.81,175.17c0.38,0,0.38,1.5,0,1.5S211.42,175.17,211.81,175.17z"
                      />
                    </g>
                  </g>

                  <g>
                    <path
                      class="st53"
                      d="M162.06,163.67c-1.91,1.45,0.02,0.27,0,2c-1.13-0.08-3.66-0.56-4.75-1c-1.01,0.29,0.19,9.65,0.5,1
									c2.91,0.35,5.84,0.64,8.75,1c0.1,1.95-0.7,3.01,1.5,3.25c-1.12,4.4-2.11-1.24-1.5,6.25c0.08,0.93-0.1,2.05,0,3
									c-0.23,0.69,0.33,1.76-0.25,2.5c-3.31,4.23-0.75-21.69-3.25-0.25c-4.04-0.34-2.17,0.46-1,2.75c-14.32-0.4,3.22,1.26,8.5,1.5
									c2.23,4.39-11.31-3.45-10.5,2.5c-1.14-0.13-3.26-0.74-4.5-1c0.59-7.45-1.23-18.05,1-24
									C156.87,163.15,159.4,163.52,162.06,163.67z"
                    />

                    <path
                      class="st106"
                      d="M162.06,165.67c3.06,0.22,5.97,0.54,9,1c0,0.25,0,0.25,0,0.5c-2.04,0.2-1.42,0.51-1.5,0.5
									c-0.28-0.02-1.58-0.82-3-1c-2.91-0.36-5.84-0.65-8.75-1c-0.31,8.65-1.51-0.71-0.5-1
									C158.4,165.11,160.92,165.59,162.06,165.67z"
                    />

                    <path
                      class="st112"
                      d="M166.56,179.17c-0.1-0.95,0.08-2.07,0-3C168.15,176.57,166.91,178.11,166.56,179.17z"
                    />

                    <path
                      class="st9"
                      d="M161.31,168.17c0.12,0.12,0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25
									c-0.12,0.12-0.12,0.12-0.25,0.25c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
									C161.18,168.29,161.18,168.29,161.31,168.17z"
                    />
                  </g>

                  <path
                    class="st104"
                    d="M172.56,166.67c0.03,0.76-0.72,0.42-1.5,0.5c0-0.25,0-0.25,0-0.5
								C171.54,166.74,172.08,166.58,172.56,166.67z"
                  />
                </g>
              </g>
            </g>
          </g>

          <path
            class="st124"
            d="M229.56,217.17c1.34-0.02,2.37-0.75,3.75-0.5c0.44,1.06-1.21,0.93-1.25,1c-2.07-0.05-4.43,1.49-6-0.5
				C227.29,217.11,228.38,217.18,229.56,217.17z"
          />

          <path
            class="st88"
            d="M135.06,376.17c-2.88,4.52-5.03,2.96-3,1C133.47,375.8,134.09,376.43,135.06,376.17z"
          />

          <path
            class="st125"
            d="M141.06,236.67c0.57,4.26-1.52,8.53-5.5,10.5c0.12-2.99-0.09-6.01,0-9c1.5-1,1.5-1,3-2
				C139.66,236.25,140.14,236.52,141.06,236.67z"
          />

          <path
            class="st87"
            d="M133.56,134.67c-0.03,9.33,0.08,18.67,0,28c-1-0.38-1-0.38-2-0.75c0.14-9.07-0.41-18.19-0.5-27.25
				C132.31,134.67,132.31,134.67,133.56,134.67z"
          />

          <g>
            <path
              class="st86"
              d="M252.56,46.67c3.25,0.88,3.25,0.88,6.5,1.75c-2.88,3.99,2.13,8.91,3,5c0.25-1.11-1.83-3.38,0.75-4.25
					c4.16-1.4,8.88,12.01,0.25,10.75c5.48,4.45,3.32,23.43,3,31.75c-0.96,0.82-4.15,4.5-5.5,6c-0.07-1.27,2.89-3.84,3-4.25
					c0.36-1.33,0.32-26.16,0-27.5c-0.85-3.52-3.92,0.23-6-0.25c-0.63-2.42-2.41-6.18-4-8c1.79-4.87-12.22-10.44-11.5-7
					c-3.66-1.05-70.57-11.58-75.25-12c-11.02-1-20.82,0.56-24.75,12.5c-0.82-1.86-0.08-5.45-2-6c1.32-2.03,2.33-5.13,4.5-6.5
					c0.67-0.42,6.52-1.74,6.75-2c2.22-2.52-6.05-5.55-8.25-2.5c-0.52,0.72-7.24,14.66-7.5,16c-0.97,7.13-0.37,14.34-0.5,21.5
					c-0.2,10.81,0.06,21.68,0,32.5c-0.5,0.75-0.5,0.75-1,1.5c-0.16-3.05,0.04-6.41,0-6.75c-0.03-0.3-0.25,1.31-1-5.5
					c-0.39-3.56-3.09-13.31-3.5-18c-0.45-5.17,1-12.01-1-11.75c0.05-6.33-0.13-12.67,0-19c0.05-2.37-0.28-17.03,1.25-17.5
					C170.54,34.46,211.65,40.07,252.56,46.67z"
            />

            <g>
              <path
                class="st87"
                d="M144.56,38.67c-2.17,1.37-3.18,4.47-4.5,6.5c-1.57,2.42-3.37,6.51-4.5,5c0.26-1.34,6.98-15.28,7.5-16
						C144.72,36.48,141.86,39.3,144.56,38.67z"
              />

              <path
                class="st90"
                d="M253.56,57.67c-2.06-2.35-8.44-6.12-11.5-7C241.33,47.22,255.34,52.8,253.56,57.67z"
              />

              <path
                class="st3"
                d="M133.06,34.67c0.21,0.13,1.51-1.15,1.5-1.25C134.52,33.05,129.97,28.07,133.06,34.67
						c-0.59-0.27-2.12,2.12-2.75-4c2.78-0.43,7.2,1.03,4.25,4.25C132.34,37.33,133.19,34.73,133.06,34.67z"
              />

              <path
                class="st86"
                d="M261.31,59.17c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
						s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
						C261.18,59.29,261.18,59.29,261.31,59.17z"
              />

              <path
                class="st86"
                d="M133.06,34.67c-3.09-6.59,1.46-1.61,1.5-1.25C134.57,33.51,133.26,34.8,133.06,34.67z"
              />
            </g>
          </g>

          <path
            class="st9"
            d="M105.06,283.17c-6.31-0.56-12.7,0.26-19,0.5c-11.81,0.46-24.32,0.12-36,1c-0.99,0.07-2.27-0.16-3,0
				c0.25-4,0.25-4,0.5-8c2.08,0.24,22.31-0.84,27.75-1c0.18-0.01,3.32-0.99,3.5-1c8.79-0.28,17.7,0.31,26.5,0
				C105.65,274.91,105.21,282.09,105.06,283.17z"
          />

          <path
            class="st38"
            d="M105.06,178.67c-0.13,1.26,0.48,2.64-0.75,3.5c-16.56,2-37.41,2.01-53.25,4.5c-0.5-3.25-0.5-3.25-1-6.5
				c2.1-0.27,5.18-0.25,7-1c9.01-0.62,18.01-1.62,27-2.5c2.76-0.27,18.81-2.83,19.75-2.5C105.34,174.71,103.83,177.89,105.06,178.67
				z"
          />

          <path
            class="st9"
            d="M105.06,319.67c-5.12-1.36-10.38-0.01-15.5,0c-11.83,0.02-23.65-0.77-35.5-0.5c-0.17,0-0.33,0-0.5,0
				c-1.12-1-1.12-1-2.25-2c6.5,0.92,9.61-3.61,19.5-5.5c0.41-0.08,0.1-0.94,0.5-1c5.53-0.85,24.95,0.63,33.5,0
				c0.11,2.16,1.46,8.5,1.25,9.25C105.89,320.51,105.14,319.4,105.06,319.67z"
          />

          <path
            class="st9"
            d="M105.06,264.67c-8,0.43-16,0.63-24,1c-5.83,0.27-11.67,0.7-17.5,1c-0.36-2.61,1.02-0.46,1.75-1
				c0.37-0.27,1.31-2.75,2.5-3.5c2.57-1.61,5.29-0.13,4.75-2.5c10.21-0.58,20.53-1.34,30.75-1.5c0.13,0,0.63-0.71,1-1
				C105.57,257.45,104.91,261.94,105.06,264.67z"
          />

          <path
            class="st4"
            d="M105.06,184.67c-1.98,0.96-3.71,2.67-5.75,3.5c-11.82,4.81-24.31,2.97-25.5,3.5
				c-0.17,0.08-1.37,2.96-1.25,3.5c-1.52,0.14-2.99,0.35-4.5,0.5c-5.02,0.49-9.98,0.93-15,1.5c0.89-7.59,16.77-5.79,23.25-7
				c2.45-0.46,4.26-1.94,4.5-2c0.33-0.08,6.3,1.01,5.75-2c6.15-0.61,12.48-1.26,18.25-2.5
				C105.26,183.89,104.96,184.39,105.06,184.67z"
          />

          <path
            class="st9"
            d="M105.06,242.17c-5.42,2.3-18.17,1.54-22.5,2.5c-1.66-3.77-11.14,0.62-8,4c-3.81,0.24-7.71,0.23-11.5,0.5
				c-1.69,0.12-3.31,0.38-5,0.5c-0.66-3.23,4.46-4.46,4.5-7c14.13-0.42,28.18-1.7,42.25-3
				C105.32,240.03,104.96,241.51,105.06,242.17z"
          />

          <path
            class="st3"
            d="M100.06,204.67c-3.74,1.3-7.28,2.09-11.25,2c0.21,2.69-4.45,2.07-10.25,3c-4.68,0.75-15.62-0.26-15.5,4.5
				c-4.65,0.38-9.35,1.19-14,1.5c-0.2-0.94-0.43-1.54,0-2.5c0.07-0.16,0.84,0.93,1.75-2.5c5.5-2.83,7.56-0.57,9-2.5
				C73.25,207.62,86.78,204.99,100.06,204.67z"
          />

          <path
            class="st9"
            d="M102.06,164.67c2.85,2.8-21.73,5.46-23.25,6.5c-0.12,0.08,0.24,1.14-0.25,3c-5,0.5-10.01,0.94-15,1.5
				c-8.57-3.71,7.26-4.68,9-7C82.39,167.18,92.11,165.43,102.06,164.67z"
          />

          <path
            class="st2"
            d="M86.56,186.17c0.55,3.01-5.42,1.92-5.75,2c-0.24,0.06-2.05,1.54-4.5,2c-6.48,1.21-22.36-0.59-23.25,7
				c-1.36,0.16-2.65,0.33-4,0.5c-1.1,0.14-2.45-0.18-3.5,0c-0.23-1.89,0.32-5.48,0-6.5C58.84,187.86,72.89,187.52,86.56,186.17z"
          />

          <path
            class="st40"
            d="M104.56,210.67c-9.35,0.69-18.67,1.67-28,2.5c1-1.75,1-1.75,2-3.5c5.8-0.93,10.46-0.31,10.25-3
				c3.97,0.09,7.51-0.7,11.25-2c0.57-0.2,4.62-3,5-2.25C105.52,205.92,104.55,210.25,104.56,210.67z"
          />

          <path
            class="st35"
            d="M104.56,230.67c0.28-1.26-0.76-1.08-2.25-1c-9.07,0.49-18.17,1.46-27.25,2c2.64-4,4.12-2.16,8.25-3.5
				c0.51-0.16-0.01-1.32,0.5-1.5c0.24-0.08,4.16,1.28,3.75-1.5c5.73-0.44,11.84,1.38,16.75-2.5
				C106.11,223.25,104.53,229.54,104.56,230.67z"
          />

          <path
            class="st2"
            d="M72.56,259.67c0.54,2.37-2.18,0.89-4.75,2.5c-1.19,0.75-2.13,3.23-2.5,3.5c-0.73,0.54-2.11-1.61-1.75,1
				c-5.5,0.28-11.04,0-16.5,1c-0.3-10.03,0.6-5.88,1.25-6C57.56,259.92,63.36,260.19,72.56,259.67z"
          />

          <path
            class="st126"
            d="M104.56,172.17c-5.84-0.05-11.7,0.48-17.5,1c-2.81,0.25-5.68,0.72-8.5,1c0.49-1.86,0.13-2.92,0.25-3
				c1.52-1.04,26.1-3.7,23.25-6.5c2.07-0.16,2.78-1.17,3-0.75C105.52,167.44,104.55,171.75,104.56,172.17z"
          />

          <path
            class="st127"
            d="M105.06,184.67c0.77,2.19-0.47,5.77-0.5,8c-10.7,0.31-21.36,1.49-32,2.5c-0.12-0.54,1.08-3.42,1.25-3.5
				c1.19-0.53,13.68,1.31,25.5-3.5C101.35,187.34,103.08,185.62,105.06,184.67z"
          />

          <g>
            <path
              class="st95"
              d="M63.06,214.17c1.32-0.11,2.68,0.11,4,0c1.28,3.12-0.98,1.08-1,3c-6.16,0.44-12.34,0.61-18.5,1
					c-0.66,0.04-1.34-0.03-2,0c-0.25-1-0.25-1-0.5-2c0.2,0,1.23-0.32,4-0.5C53.71,215.36,58.4,214.55,63.06,214.17z"
            />

            <path
              class="st38"
              d="M67.56,223.17c0.25-3,0.25-3,0.5-6c12.15-0.93,24.46-2.03,36.5-4c-0.03,1.13,1.29,6.76,0.25,7.5
					C92.36,221.03,79.97,222.33,67.56,223.17z"
            />

            <path
              class="st128"
              d="M104.56,210.67c0.02,0.83,0.02,1.67,0,2.5c-12.04,1.97-24.35,3.07-36.5,4c-0.66,0.05-1.34-0.05-2,0
					c0.02-1.92,2.28,0.12,1-3c3.15-0.26,6.33-0.72,9.5-1C85.89,212.34,95.21,211.36,104.56,210.67z"
            />

            <path
              class="st35"
              d="M66.06,217.17c0.66-0.05,1.34,0.05,2,0c-0.25,3-0.25,3-0.5,6c-5.7,0.38-13.16-0.01-18.5,0.5
					c-0.75-2.75-0.75-2.75-1.5-5.5C53.71,217.77,59.9,217.61,66.06,217.17z"
            />
          </g>

          <path
            class="st33"
            d="M105.06,157.17c-0.05,0.25,1.55,3.28-0.25,5c-7.6,0.21-15.21,1.12-22.75,2c-0.5-2.25-0.5-2.25-1-4.5
				C89.06,158.85,97.05,157.98,105.06,157.17z"
          />

          <path
            class="st3"
            d="M72.56,168.67c-1.74,2.32-17.57,3.29-9,7c-1.5,0.17-3,0.33-4.5,0.5c-4.18,0.48-8.27,1.78-12.5,2
				c-0.78-2.14,0.7-3.8,1.25-6C56.02,170.81,64.34,169.91,72.56,168.67z"
          />

          <path
            class="st129"
            d="M86.06,283.67c-0.25,1.25-0.25,1.25-0.5,2.5c-12.2,0.46-29.31,0.28-39.5,1c1.77-1.4,4.68,0.93,4-2.5
				C61.73,283.79,74.25,284.12,86.06,283.67z"
          />

          <path
            class="st2"
            d="M62.56,242.67c-0.04,2.54-5.16,3.77-4.5,7c-4,0.29-8,0.72-12,1c0.38-1.94-0.09-5.26,0.5-7.5
				C51.78,243.71,57.34,242.82,62.56,242.67z"
          />

          <path
            class="st35"
            d="M105.06,247.17c-9.7-0.12-19.34,0.92-29,1.5c2.05-1.2,3.71-3.38,6.5-4c4.33-0.96,17.08-0.2,22.5-2.5
				C105.26,243.56,104.98,245.57,105.06,247.17z"
          />

          <path
            class="st40"
            d="M81.06,159.67c0.5,2.25,0.5,2.25,1,4.5c-5.65,0.66-11.34,1.46-17,2c0-2.5,0-2.5,0-5
				C70.3,160.47,75.77,160.21,81.06,159.67z"
          />

          <g>
            <path
              class="st2"
              d="M46.06,269.67c0.5-0.01,1,0,1.5,0c0,1.5,0,1.5,0,3c-1.27,0.09-6.74,0.96-3,2.5c-0.15-0.03-0.46,0.7-3-0.5
					c0.01-1.67-0.01-3.33,0-5C43.06,269.65,44.56,269.68,46.06,269.67z"
            />

            <path
              class="st40"
              d="M66.06,273.17c1.25-2.25,1.25-2.25,2.5-4.5c5.5-0.2,10.99-0.28,16.5-0.5c3.88-0.16,18.79-0.27,19.75-0.5
					c0.37-0.09,0.25-0.66,0.25-1c0,0.28,1.19,3.77,0.25,5.5C92.22,272.3,79.13,272.9,66.06,273.17z"
            />

            <path
              class="st130"
              d="M81.06,265.67c-0.68,3.43,2.23,1.1,4,2.5c-5.51,0.22-11,0.3-16.5,0.5c-6.97,0.26-14.02,1-21,1
					c-0.5,0-1-0.01-1.5,0c-0.07-0.65,0.11-1.37,0-2c0.5,0,0.5,0,1,0c5.46-1,11-0.72,16.5-1C69.39,266.37,75.22,265.94,81.06,265.67z
					"
            />

            <path
              class="st35"
              d="M66.06,273.17c-5.4,0.11-16.02-0.67-18.5-0.5c0-1.5,0-1.5,0-3c6.98,0,14.03-0.74,21-1
					C67.31,270.92,67.31,270.92,66.06,273.17z"
            />

            <path
              class="st128"
              d="M105.06,264.67c0.04,0.66,0,1.34,0,2c0,0.34,0.12,0.91-0.25,1c-0.96,0.23-15.87,0.34-19.75,0.5
					c-1.77-1.4-4.68,0.93-4-2.5C89.06,265.3,97.06,265.09,105.06,264.67z"
            />
          </g>

          <g>
            <path
              class="st9"
              d="M62.06,199.67c0.88,2.75,0.88,2.75,1.75,5.5c-3.82,1.1-16.45-0.97-17.25,3c-2.5,0-2.5,0-5,0
					c-0.16-1.98,0.12-4.02,0-6c-0.23-1.43,0.75-0.91,2-1c1.98-0.14,4.03,0.18,6,0C53.66,200.8,57.92,200.12,62.06,199.67z"
            />

            <path
              class="st131"
              d="M49.06,197.67c0.25,1.75,0.25,1.75,0.5,3.5c-1.97,0.18-4.02-0.14-6,0c0.4-1.97-1.2-1.75-1.5-2.5
					c1.21,0.23,2.67-0.86,3.5-1C46.61,197.49,47.96,197.81,49.06,197.67z"
            />

            <path
              class="st40"
              d="M89.06,196.67c-1.27,3.07-2.37,5.43,1.5,6c-8.38,0.88-16.85,1.23-25.25,2c1.72-1.65-1.7-3.23-1.25-5.5
					c1.5-0.16,3-0.34,4.5-0.5C75.39,197.92,82.24,197.45,89.06,196.67z"
            />

            <path
              class="st33"
              d="M90.56,202.67c-3.87-0.57-2.77-2.93-1.5-6c4.62-0.53,12.36-1.3,15.5-3c-0.04,1.25,1.3,6.52,0.25,7.5
					C100.08,201.9,95.31,202.17,90.56,202.67z"
            />

            <path
              class="st128"
              d="M104.56,192.67c0,0.33,0.01,0.67,0,1c-3.14,1.7-10.88,2.47-15.5,3c-6.82,0.79-13.67,1.26-20.5,2
					c-0.25-1.5-0.25-1.5-0.5-3c1.51-0.15,2.98-0.36,4.5-0.5C83.2,194.16,93.86,192.97,104.56,192.67z"
            />

            <path
              class="st95"
              d="M68.06,195.67c0.25,1.5,0.25,1.5,0.5,3c-1.5,0.16-3,0.34-4.5,0.5c-2.58,0.28-1.9,0.49-2,0.5
					c-4.14,0.46-8.39,1.13-12.5,1.5c-0.25-1.75-0.25-1.75-0.5-3.5c1.35-0.17,2.64-0.34,4-0.5
					C58.08,196.59,63.03,196.15,68.06,195.67z"
            />
          </g>

          <path
            class="st84"
            d="M105.06,283.17c-0.1,0.72,0.07,1.52,0,2.25c-1.07,1.23-16.56,0.64-19.5,0.75c0.25-1.25,0.25-1.25,0.5-2.5
				C92.35,283.42,98.74,282.6,105.06,283.17z"
          />

          <path
            class="st132"
            d="M104.56,172.17c0.04,2.12,0.73,4.23,0.5,6.5c-1.22-0.77,0.28-3.96-1.25-4.5
				c-0.94-0.33-16.99,2.23-19.75,2.5c-0.38-1.51,3.11-0.48,3-3.5C92.86,172.64,98.72,172.12,104.56,172.17z"
          />

          <path
            class="st126"
            d="M50.06,284.67c0.68,3.43-2.23,1.1-4,2.5c-0.49,0.03-1.02-0.07-1.5,0c0.42-1.23,1.17-2.21,2.5-2.5
				C47.79,284.51,49.06,284.74,50.06,284.67z"
          />

          <g>
            <path
              class="st35"
              d="M98.06,233.17c0.41,2.78,2.17-0.54,4,4.5c-5.39,1.02-22.57,1.75-29.5,2c0.69-2.59-2.9-2.38-2.5-5
					c1-0.05,2,0.05,3,0C81.38,234.27,89.73,233.62,98.06,233.17z"
            />

            <path
              class="st128"
              d="M104.56,230.67c0.02,1.04,0.11,1.3,0,2.5c-1.5,0-1.5,0-3,0c-1.16,0.04-2.34-0.06-3.5,0
					c-8.33,0.46-16.67,1.1-25,1.5c1.51-1.34,1.59-2.38,2-3c9.08-0.54,18.18-1.51,27.25-2C103.8,229.59,104.84,229.4,104.56,230.67z"
            />

            <path
              class="st9"
              d="M70.06,234.67c-0.4,2.62,3.19,2.41,2.5,5c-7.23,0.26-11.29,3.54-13.5-4
					C62.65,235.55,66.45,234.83,70.06,234.67z"
            />

            <path
              class="st95"
              d="M75.06,231.67c-0.41,0.62-0.49,1.66-2,3c-1,0.05-2-0.05-3,0c-3.61,0.17-7.41,0.88-11,1
					c-0.67,0.02-1.33-0.02-2,0c0.02-1.92,2.28,0.12,1-3C63.72,232.33,69.39,232.01,75.06,231.67z"
            />

            <path
              class="st95"
              d="M58.06,232.67c1.28,3.12-0.98,1.08-1,3c-4.33,0.12-9.24,0.4-13.5-0.5c-0.25-0.75-0.25-0.75-0.5-1.5
					C47.67,232.67,53.27,232.95,58.06,232.67z"
            />

            <path
              class="st38"
              d="M104.56,233.17c-0.02,0.19,0.65,2.6,0.5,3.75c-0.69,1.14-1.59,0.59-2.5,0.75c-0.5-2.25-0.5-2.25-1-4.5
					C103.06,233.17,103.06,233.17,104.56,233.17z"
            />

            <path
              class="st38"
              d="M101.56,233.17c0.5,2.25,0.5,2.25,1,4.5c-0.16,0.03-0.34-0.03-0.5,0c-1.83-5.04-3.59-1.72-4-4.5
					C99.22,233.1,100.39,233.21,101.56,233.17z"
            />

            <path
              class="st5"
              d="M43.06,233.67c0.25,0.75,0.25,0.75,0.5,1.5c-0.59-0.12-0.9-0.08-1.5-0.5
					C42.3,232.49,42.99,233.68,43.06,233.67z"
            />
          </g>

          <path
            class="st133"
            d="M106.06,36.17c-6.9,3.42-14.64,3.89-22,5.5c0.96-1.24,0.13-2.93,0.75-3.5c0.51-0.47,12.19-2.38,13.75-2.5
				C100.16,35.54,105.18,35.04,106.06,36.17z"
          />

          <path
            class="st35"
            d="M73.56,359.67c-1.15,4.38,4.14,5.77,1.5,7.5c-7.08-0.61-16.91-2.12-23.5-2c-0.5-3.25-0.5-3.25-1-6.5
				C58.2,358.77,65.9,359.43,73.56,359.67z"
          />

          <g>
            <path
              class="st35"
              d="M105.06,299.67c-0.25-0.5-0.25-0.5-0.5-1c-8.68-0.21-17.32,0.42-26,0.5c-5.87,0.05-32.19-0.3-35.5,1
					c-0.54,0.21-0.82,0.67-1.5,0.5c0-1.33,0-2.67,0-4c1.53,0.41,1.53-3.91,0-3.5c0-0.17,0-0.33,0-0.5c16.91-0.55,33.84,0.37,50.75,0
					C101.36,292.47,107.98,287.76,105.06,299.67z"
            />

            <path
              class="st9"
              d="M60.06,302.17c0.15,2.66,6.54,3.8,2.5,5.5c-1.54,0.02-23.11-1.25-18.25,3c1.19,1.04,3.78-3.48,2.75,8.5
					c-2.87,0.23-4.38-0.96-3.5,3c-0.71,0.05-1.32,1.58-2.5,1c0.03-7.48,0.48-14.99,0.5-22.5c0.68,0.17,0.96-0.29,1.5-0.5
					C41.25,303.27,51.91,302.1,60.06,302.17z"
            />

            <path
              class="st35"
              d="M90.56,301.67c-0.76,2.56-1.58,4.46-3.5,6c-8.16,0.12-16.34-0.12-24.5,0c4.04-1.7-2.35-2.84-2.5-5.5
					c5.82,0.05,11.68,0.11,17.5,0C81.9,302.08,86.22,301.86,90.56,301.67z"
            />

            <path
              class="st38"
              d="M105.06,299.67c-0.12,4-0.12,4-0.25,8c-5.91,0.06-11.84-0.09-17.75,0c1.92-1.54,2.74-3.44,3.5-6
					c7.29-0.33,14.09,1.75,14-3C104.81,299.17,104.81,299.17,105.06,299.67z"
            />

            <path
              class="st95"
              d="M78.56,299.17c1.28,3.12-0.98,1.08-1,3c-5.82,0.11-11.68,0.05-17.5,0c-8.14-0.07-18.8,1.1-17-2
					C46.37,298.87,72.68,299.22,78.56,299.17z"
            />

            <path
              class="st134"
              d="M104.56,298.67c0.09,4.75-6.71,2.67-14,3c-4.34,0.2-8.66,0.42-13,0.5c0.02-1.92,2.28,0.12,1-3
					C87.23,299.09,95.88,298.45,104.56,298.67z"
            />
          </g>

          <path
            class="st2"
            d="M106.06,359.17c-1.58,0.3-0.53-1.24-1.5-1.5c-2.56-0.68-46.23-1.9-53-2c0.37-1.77-1.93-0.52-2.5-1.25
				c-0.16-0.21,1.26-2.98,1.75-3.25c0.73-0.41,9.6-1.17,12-1.5c0.48-0.07,0.02-1.42,0.5-1.5c2.38-0.4,32.98,1.72,42,0.5
				C106.52,349.21,106.09,357.5,106.06,359.17z"
          />

          <path
            class="st38"
            d="M106.06,359.17c-0.08,3.41-0.74,7.04-0.75,10.5c-10.15-0.02-20.17-1.64-30.25-2.5
				c2.64-1.73-2.65-3.12-1.5-7.5c3.99,0.13,29.43,1.79,30.75,1c0.87-0.52-0.52-2.2,0.25-3
				C105.53,357.93,104.48,359.47,106.06,359.17z"
          />

          <g>
            <path
              class="st3"
              d="M46.56,243.17c-0.59,2.24-0.12,5.56-0.5,7.5c-0.1,0.52-6.72,3.09,5.5,3c0.25,2.25,0.25,2.25,0.5,4.5
					c-1.93,0.15-3.82,0.41-5.75,0.5c-0.19,2.49-0.72,2.37-0.75,2.5c0.37-1.56-1.61-0.87-4-1c0.02-6-0.04-12,0-18
					C43.02,242.17,45.33,243.04,46.56,243.17z"
            />

            <path
              class="st130"
              d="M105.06,247.17c0.06,1.32,0.02,2.68,0,4c-8.48,0.69-17,0.68-25.5,1c-5.97,0.22-12.03,0.82-18,1
					c0.75-2,0.75-2,1.5-4c3.79-0.27,7.69-0.26,11.5-0.5c0.5-0.03,1,0.03,1.5,0C85.72,248.08,95.36,247.04,105.06,247.17z"
            />

            <path
              class="st40"
              d="M76.06,257.17c-3.29-2.58,3.88-1.49,3.5-5c8.5-0.32,17.02-0.31,25.5-1c-0.03,1.73,0.33,3.31,0.25,5
					C95.56,256.74,85.8,256.71,76.06,257.17z"
            />

            <path
              class="st35"
              d="M79.56,252.17c0.38,3.51-6.79,2.42-3.5,5c-7.81,0.36-16.29,0.38-24,1c-0.25-2.25-0.25-2.25-0.5-4.5
					c3.22-0.02,6.72-0.4,10-0.5C67.53,252.98,73.58,252.39,79.56,252.17z"
            />

            <path
              class="st135"
              d="M63.06,249.17c-0.75,2-0.75,2-1.5,4c-3.28,0.1-6.78,0.48-10,0.5c-12.22,0.09-5.6-2.48-5.5-3
					c4-0.28,8-0.71,12-1C59.75,249.55,61.36,249.29,63.06,249.17z"
            />
          </g>

          <path
            class="st9"
            d="M78.56,209.67c-1,1.75-1,1.75-2,3.5c-3.17,0.28-6.35,0.74-9.5,1c-1.32,0.11-2.68-0.11-4,0
				C62.93,209.4,73.87,210.42,78.56,209.67z"
          />

          <g>
            <path
              class="st37"
              d="M43.06,339.67c5.53,0.9,10.96,0.37,16.5,0.5c0.08,2.06-0.02,4.29,2,5c-7.21-0.03-18.12-1.1-18,2.5
					c-0.9-0.42-1.4-0.68-2.5-0.5c-0.04-2.65,0.04-5.32,0-8C43,340.41,42.59,339.59,43.06,339.67z"
            />

            <path
              class="st44"
              d="M47.06,337.17c7.34-0.26,26.04,0.32,35,0.5c0.71,4.21-2.14,1.52-4.5,3c-6.01-0.11-12-0.36-18-0.5
					c-5.54-0.13-10.97,0.4-16.5-0.5C42.44,337.06,45,337.24,47.06,337.17z"
            />

            <path
              class="st35"
              d="M77.56,340.67c9.29,0.17,18.73,0.74,28,0c0.12,0.79,0.12,5.74-0.25,6c-14.57-0.23-29.18-1.45-43.75-1.5
					c-2.02-0.71-1.92-2.94-2-5C65.56,340.31,71.54,340.56,77.56,340.67z"
            />

            <path
              class="st134"
              d="M105.56,340.67c-9.27,0.74-18.71,0.17-28,0c2.36-1.48,5.21,1.21,4.5-3c7.59,0.15,15.16,0.61,22.75,0.5
					C105.93,338.87,105.41,339.73,105.56,340.67z"
            />
          </g>

          <path
            class="st130"
            d="M87.06,173.17c0.11,3.02-3.38,1.99-3,3.5c-8.99,0.88-17.99,1.88-27,2.5c1.91-0.78,2.34-0.57,2-3
				c1.5-0.17,3-0.33,4.5-0.5c4.99-0.56,10-1,15-1.5C81.38,173.89,84.24,173.42,87.06,173.17z"
          />

          <g>
            <path
              class="st2"
              d="M172.06,244.67c0.41,0.09,0.58,0.34,1,0.5c5.24,2.01-0.79,1.7-2.5,7c-0.67-1.98-12.43,1.66-13.5-0.75
					c-1.32-2.97,0.84-3.49,3-4c-8.1-1.61,4.61-2.13,7-2.25c0.5,0,0.5,0,1,0C168.84,245.16,170.29,244.27,172.06,244.67z"
            />

            <path
              class="st49"
              d="M156.56,255.67c0.25,0,0.25,0,0.5,0c20.58,0.17,11.06,3.53-1.5,0.25
					C155.47,255.53,156.55,255.72,156.56,255.67z"
            />
          </g>

          <g>
            <path
              class="st2"
              d="M242.06,50.67c3.06,0.88,9.44,4.65,11.5,7c1.59,1.82,3.37,5.58,4,8c2.31,8.82,1.02,24.03,1.5,33.5
					c-2.71,3.25-3.18,3.24-5.5,7.5c-56.25-6.75-56.25-6.75-112.5-13.5c0.08-8.66-0.16-17.34,0-26c0.1-5.41-1.53-8.31,1-16
					c3.93-11.94,13.73-13.5,24.75-12.5C171.48,39.09,238.39,49.62,242.06,50.67z"
            />

            <path
              class="st55"
              d="M155.06,82.67c0.63,0.07,0.75,0.18,1-0.5c25.78,0.88,50.95,6.25,76.25,8c0.72,0.49,2.42,2.34,1.5,3
					c-39.25-4.5-39.25-4.5-78.5-9C154.81,83.91,155.16,83.11,155.06,82.67z"
            />

            <g>
              <path
                class="st53"
                d="M204.06,71.17c-1.11,6.6,1.79,2.31,0.5,0.5c19.62-0.05,14.38,4.03,15.25,4c1.22-0.04-2.15-2.13,2.75-2
						c0.04,2.29-0.62,3.36,1.75,3c-1.52-0.9-1.72-1.29-0.75-3c10.89,1.01,6.48,0.87,7.75,14c1.34-10.69-2.66-14.91,5-12
						c1.06-9.13,0.69,4.03,0.75,14.25c-1.93,0.96-1.39-0.77-1.5-0.75c0.83,0.01,0.45-2.49,0.5-5.25c0.18-10.97-0.81-7.49-0.5,5.25
						c-0.79,0.1-0.36,1.02-0.75,1c-0.74-0.03-4.14-1.58-5-0.5c-1.24-0.86-0.63-2.47-0.75-4c-0.15-1.91,0.5-10.13-0.25-10.5
						c-1.52,1.44,0.14,5.57-0.25,10.5c-0.09,1.14-0.13,2.1,0,3.25c-11.47-0.17-67.64-9.03-72.75-7.75c-0.65,0.16,0.39,0.63,0.25,1
						c-0.25,0.68-0.37,0.57-1,0.5c-0.41-1.67-0.12-20.87,0.75-21.5c26.56,4.19,53.25,7.67,80,10.5c0.89,0.6-0.39,3.9-1.5,3
						c-0.62-0.5,0.11-2.26-0.5-2.5c-0.38-0.15,0.63,1.56-2,2c-0.35,0.06-0.14-1.01-0.5-1c-4.32,0.1-18.51-0.86-19.5-3
						c-0.75,0.98-1.28,1.15-2.5,1c-17.59-2.11-35.31-4.96-52.75-7.25C162.08,66.91,202.06,69.81,204.06,71.17z"
              />

              <g>
                <path
                  class="st57"
                  d="M229.06,85.67c-0.25,0-0.25,0-0.5,0c0.39-4.93-1.27-9.06,0.25-10.5
							C229.55,75.54,228.91,83.76,229.06,85.67z"
                />

                <path
                  class="st103"
                  d="M204.56,71.67c1.29,1.81-1.61,6.1-0.5-0.5C204.39,71.39,204.34,71.36,204.56,71.67z"
                />

                <path
                  class="st58"
                  d="M223.56,73.67c-0.97,1.71-0.77,2.1,0.75,3c-2.37,0.36-1.71-0.71-1.75-3
							C222.89,73.68,223.23,73.64,223.56,73.67z"
                />

                <path
                  class="st102"
                  d="M157.06,72.17c-0.03,0.84-0.16,1.56,0.5,1.5c-0.78,2.4,0.27,3.99-0.75,6c-0.78-2.43-0.41-17.99,1-12
							c4.28,0.47-0.09,1.02-0.25,1.25C157.46,69.05,157.06,71.96,157.06,72.17z"
                />

                <path
                  class="st2"
                  d="M235.56,89.17c-0.31-12.74,0.68-16.22,0.5-5.25C236.01,86.67,236.38,89.18,235.56,89.17z"
                />

                <path
                  class="st101"
                  d="M225.81,75.67c0.58,0.25,0.75,2.26,0.75,2.75C226.64,86.92,224.56,87.24,225.81,75.67z"
                />

                <path
                  class="st99"
                  d="M222.81,77.17c0.41,0,0.25,4.4,0.25,5.25C223.06,91.89,222.03,86.73,222.81,77.17z"
                />

                <path
                  class="st57"
                  d="M219.31,76.67c0.68-0.25,1.23,3.42,1.25,3.75C221.13,88.04,219.09,85.39,219.31,76.67z"
                />

                <path
                  class="st57"
                  d="M233.81,81.17c1.05-0.98,1.36,4.01,0.5,4C233.04,85.16,233.46,81.49,233.81,81.17z"
                />

                <path
                  class="st49"
                  d="M202.81,77.17c0.39,8.74-1.66,8.64-0.25,0.25C202.68,77.29,202.68,77.29,202.81,77.17z"
                />

                <path
                  class="st136"
                  d="M215.31,73.67c0.38,0.12,0.38,0.12,0.75,0.25C212,78.68,210.28,77.92,215.31,73.67z"
                />

                <path
                  class="st10"
                  d="M193.81,72.17c2.91,2.3-2.75,1.03-2.75,0.75C191.05,72.38,193.44,73.06,193.81,72.17z"
                />

                <path
                  class="st100"
                  d="M233.31,86.17c0.43-0.2,1.06,0.43,1.25,0.75C234.93,87.53,233.57,92.02,233.31,86.17z"
                />

                <path
                  class="st112"
                  d="M193.31,79.67c0.48,1.14,0.72,1.84,0.5,3C193.02,86.88,192.72,79.73,193.31,79.67z"
                />

                <path
                  class="st49"
                  d="M213.06,82.67c-0.25,0.75-0.25,0.75-0.5,1.5C209.62,83.88,211.55,82.35,213.06,82.67z"
                />

                <path
                  class="st102"
                  d="M197.31,71.17c0.22,0,1.53,4.39-0.75,2.75C196.9,73.48,197.09,71.16,197.31,71.17z"
                />

                <path
                  class="st103"
                  d="M207.81,77.67c0.32-0.1,1.67-0.08,1.75,0.25C209.86,79.16,202.36,79.43,207.81,77.67z"
                />

                <path
                  class="st57"
                  d="M173.81,72.17c1.33,0.14-1.68,7.15-0.25,0.25C173.65,72.27,173.73,72.16,173.81,72.17z"
                />

                <path
                  class="st57"
                  d="M215.81,83.67c0.16-0.12,1.09-0.08,1.25,0.25C216.08,89.57,215.57,83.84,215.81,83.67z"
                />

                <path
                  class="st101"
                  d="M186.81,71.67c0.13-0.06,2.75,0.61,2.75,0.75C189.53,73.13,184.98,72.58,186.81,71.67z"
                />

                <path
                  class="st57"
                  d="M162.31,68.17c0.13-0.06,2.75,0.61,2.75,0.75C165.03,69.63,160.48,69.08,162.31,68.17z"
                />

                <path
                  class="st104"
                  d="M157.56,73.67c-0.66,0.06-0.53-0.66-0.5-1.5C160.82,73.34,157.77,73.01,157.56,73.67z"
                />

                <path
                  class="st101"
                  d="M180.31,70.17c1.37-0.21,0.74,3.5-0.75,1.25C179.32,71.06,180.11,70.2,180.31,70.17z"
                />

                <path
                  class="st122"
                  d="M208.81,79.17c0.26,0,0.43,2.83,0.25,3.25C208.54,83.6,208.26,79.17,208.81,79.17z"
                />

                <path
                  class="st137"
                  d="M180.31,78.17c0.31,0.03,1.19,1.19,0.5,1.5C179.74,80.14,179.35,78.08,180.31,78.17z"
                />

                <path
                  class="st123"
                  d="M187.31,73.17c0.39,0,0.39,3,0,3S186.92,73.17,187.31,73.17z"
                />

                <path class="st99" d="M216.31,76.67c0.39,0,0.39,3,0,3S215.92,76.67,216.31,76.67z" />

                <path
                  class="st102"
                  d="M167.81,72.67c1.9-0.74,2.42,2.99,0.5,0.5C168.27,73.12,167,72.98,167.81,72.67z"
                />

                <path
                  class="st100"
                  d="M233.81,77.17c1.07-0.47,1.45,1.58,0.5,1.5C234,78.64,233.11,77.47,233.81,77.17z"
                />

                <path
                  class="st15"
                  d="M212.56,84.17c0.25-0.75,0.25-0.75,0.5-1.5C213.88,82.84,214.39,84.35,212.56,84.17z"
                />

                <path
                  class="st103"
                  d="M176.56,73.67c0.25,0,0.25,0,0.5,0c-0.07,0.5,1.04,0.58-0.25,1.5
							C175.51,74.25,176.63,74.17,176.56,73.67z"
                />

                <path
                  class="st114"
                  d="M183.81,71.17c0.33,0.04,1.2,1.23,0.5,1.5C183.91,72.82,182.28,71,183.81,71.17z"
                />

                <path
                  class="st49"
                  d="M177.06,73.67c-0.25,0-0.25,0-0.5,0c-0.09-0.61-0.1-1.91,0-2.5c0.25,0,0.25,0,0.5,0
							C177.15,71.75,177.14,73.06,177.06,73.67z"
                />

                <path
                  class="st117"
                  d="M165.81,68.67c0.24-0.08,1.78,0.65,1.75,0.75C167.3,70.36,164.92,68.98,165.81,68.67z"
                />

                <path
                  class="st48"
                  d="M171.31,70.17c1.29-0.68,1.44,0.89,0.5,1C171.75,71.17,170.8,70.44,171.31,70.17z"
                />

                <path
                  class="st112"
                  d="M190.31,78.67c0.38,0,0.38,2,0,2S189.92,78.67,190.31,78.67z"
                />

                <path
                  class="st49"
                  d="M203.81,82.17c0.06-0.04,0.82,0.51,0.5,1C203.54,84.36,203.17,82.62,203.81,82.17z"
                />

                <path
                  class="st105"
                  d="M200.31,74.17c1.29-0.68,1.44,0.89,0.5,1C200.75,75.17,199.8,74.44,200.31,74.17z"
                />

                <path
                  class="st101"
                  d="M225.81,85.67c0.38,0,0.38,2,0,2S225.42,85.67,225.81,85.67z"
                />

                <path
                  class="st10"
                  d="M160.81,72.67c0.32-0.15,1.75-0.03,1.75,0.25C162.56,73.48,159.82,73.13,160.81,72.67z"
                />

                <path
                  class="st100"
                  d="M170.81,76.67c0.38,0,0.38,1.5,0,1.5S170.42,76.67,170.81,76.67z"
                />

                <path
                  class="st138"
                  d="M167.31,76.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5
							c-0.12,0.12-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25
							C167.18,76.79,167.18,76.79,167.31,76.67z"
                />

                <path
                  class="st118"
                  d="M180.31,74.17c0.12,0.12,0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25
							c-0.12,0.12-0.12,0.12-0.25,0.25c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
							C180.18,74.29,180.18,74.29,180.31,74.17z"
                />

                <path
                  class="st121"
                  d="M163.81,73.17c0.29-0.14,1.25-0.02,1.25,0.25C165.06,73.99,162.91,73.6,163.81,73.17z"
                />

                <path
                  class="st102"
                  d="M170.81,73.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c-0.12,0.12-0.12,0.12-0.25,0.25
							s-0.12,0.12-0.25,0.25s-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
							C170.68,73.79,170.68,73.79,170.81,73.67z"
                />

                <path
                  class="st57"
                  d="M219.81,85.67c0.38,0,0.38,1.5,0,1.5S219.42,85.67,219.81,85.67z"
                />

                <path
                  class="st114"
                  d="M183.31,78.17c0.12,0.12,0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25s0.12,0.12,0.25,0.25
							c-0.12,0.12-0.12,0.12-0.25,0.25c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0-0.25,0-0.25,0-0.5
							C183.18,78.29,183.18,78.29,183.31,78.17z"
                />

                <path
                  class="st105"
                  d="M177.06,71.17c-0.25,0-0.25,0-0.5,0C176.69,70.34,176.92,70.34,177.06,71.17z"
                />

                <path
                  class="st103"
                  d="M190.31,81.67c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
							c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
							S190.18,81.79,190.31,81.67z"
                />

                <path
                  class="st137"
                  d="M173.81,70.67c0.25,0,0.25,0,0.5,0c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5
							c-0.12,0.12-0.12,0.12-0.25,0.25c-0.12-0.12-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25s-0.12-0.12-0.25-0.25
							C173.68,70.79,173.68,70.79,173.81,70.67z"
                />

                <path
                  class="st139"
                  d="M187.31,78.67c0.38,0,0.38,1.5,0,1.5S186.92,78.67,187.31,78.67z"
                />

                <path
                  class="st119"
                  d="M193.81,75.67c0.12,0.12,0.12,0.12,0.25,0.25c0,0.25,0,0.25,0,0.5c-0.12,0.12-0.12,0.12-0.25,0.25
							c-0.25,0-0.25,0-0.5,0c-0.12-0.12-0.12-0.12-0.25-0.25c0.12-0.12,0.12-0.12,0.25-0.25s0.12-0.12,0.25-0.25
							S193.68,75.79,193.81,75.67z"
                />
              </g>
            </g>
          </g>

          <g>
            <path
              class="st3"
              d="M52.56,322.67c0.2,3.43,2.83,4.1-1.5,5c-1.12,0.04-6.62-0.26-7,0.25c-1.78,2.37,4.19,0.27,3,9.25
					c-2.06,0.07-4.61-0.1-4,2.5c-0.46-0.07-0.06,0.75-2-0.5c-0.07-5.33-0.02-10.67,0-16c1.18,0.58,1.79-0.95,2.5-1
					C45.06,322.07,50.04,322.68,52.56,322.67z"
            />

            <path
              class="st126"
              d="M105.56,328.17c-12.5,0.47-25.02-0.43-37.5-0.5c-0.75-2.25-0.75-2.25-1.5-4.5c12.41,0,24.84-1.33,37.25,0
					c0.4-0.24,0.53-0.64,0.75-1c0.14-0.23-0.14-1.3,0-1.5C106.47,322.22,105.12,325.89,105.56,328.17z"
            />

            <path
              class="st135"
              d="M47.06,319.17c2.13-0.17,4.35,0.06,6.5,0c0.17,0,0.33,0,0.5,0c3.35,1.45,5.21-1.29,7,3.5
					c-2.83-0.02-5.67-0.01-8.5,0c-2.51,0.01-7.5-0.6-9-0.5C42.68,318.21,44.19,319.4,47.06,319.17z"
            />

            <path
              class="st128"
              d="M105.06,319.67c-0.02,0.05-0.47,0.95-0.5,1c-0.14,0.2,0.14,1.27,0,1.5c-7.95-0.6-16.63,1.83-15-2.5
					C94.68,319.66,99.94,318.3,105.06,319.67z"
            />

            <path
              class="st35"
              d="M61.06,322.67c1.81,0.01,3.85,0.5,5.5,0.5c0.75,2.25,0.75,2.25,1.5,4.5c-5.64-0.03-11.37-0.2-17,0
					c4.33-0.9,1.7-1.57,1.5-5C55.39,322.66,58.22,322.65,61.06,322.67z"
            />

            <path
              class="st130"
              d="M89.56,319.67c-1.63,4.33,7.05,1.9,15,2.5c-0.22,0.36-0.35,0.76-0.75,1c-12.41-1.33-24.84,0-37.25,0
					c-1.65,0-3.69-0.49-5.5-0.5c-1.79-4.79-3.65-2.05-7-3.5C65.91,318.9,77.73,319.69,89.56,319.67z"
            />
          </g>

          <path
            class="st9"
            d="M82.56,244.67c-2.79,0.62-4.45,2.8-6.5,4c-0.5,0.03-1-0.03-1.5,0C71.41,245.29,80.89,240.9,82.56,244.67z"
          />

          <g>
            <path
              class="st3"
              d="M108.06,34.67c0,20,0,20,0,40c0,33.38,0,33.38,0,66.75c-1.08,1.33-2.42,1.09-3,1.25
					c-2.44-0.81-0.93-2.37-2.25-3c-1.09-0.52-22.86,2.6-24,3c-2.45,0.85,0.53,1-1.75,3c-9.02,0.9-18.11,0.87-27,3
					c0.02-0.2-0.84-0.23-0.5-4c0.08,0,0.98-0.99,1.25-1c4.41-0.16,8.98,0.93,13.5,0.5c0.17-0.02,2.49-1.45,3-1.5
					c3.6-0.38,7.83,0.63,11.5-1.5c4.76-0.25,9.53-0.84,14.25-1.5c3.75-0.53,7.44-1.24,11.25-1c1.32-0.95,0.59-3.74,0.75-6.5
					c0.4-6.83-0.62-13.74-0.5-20.5c0-0.16,0.47-0.47,0.5-2.5c0.05-2.83-0.04-5.7,0-8.5c0.03-2.53-0.03-5.01,0-7.5
					c0.02-1.57-0.5-1.7-0.5-2c0.01-0.5,0.91,1.42,1-9.5c0.02-2.49-0.52-5.14-0.5-7.5c0.01-0.83-0.01-1.67,0-2.5
					c0.02-3.42,0.48-7.01,0.5-10.5c0.02-2.31-0.54-4.85-0.5-7c0.01-0.5-0.01-1,0-1.5c0.02-1.52,2.29-11.57,1-16.5
					c-0.87-1.13-5.89-0.62-7.5-0.5c0-0.5,0-0.5,0-1C108.47,33.03,107.57,34.7,108.06,34.67z"
            />

            <path
              class="st4"
              d="M105.06,142.67c-2.57,0.7-22.53,2.46-28,3c2.28-2-0.7-2.15,1.75-3c1.14-0.4,22.91-3.52,24-3
					C104.13,140.29,102.62,141.86,105.06,142.67z"
            />

            <path
              class="st140"
              d="M63.06,46.17c2.5,2,2.5,2,5,4c-8.48,1.61-17.25,2.27-25.5,4.75c-0.26,1.58,1,1.65,1,1.75
					c0.25,9.54,1.72,4.99,2,6.25c0.09,0.41-1.37-0.26-2,1.25c-0.32,0.75,0.58,1.12,0.5,1.5c-1.26,6.18,0.03,6.06,0,6.5
					c-0.03,0.51-0.45-0.23-0.5,1.5c-0.08,2.99-0.05,5.52,0,8.5c0.01,0.31-1.32,1.97,0,2.5c-0.19,0.04-2.34,1.21-3.5,1.5
					c0.08-10.45-0.48-21.07,0-31.5c3.04,0.56-0.08-2.65,1.75-4c0.47-0.35,5.97-1.06,7.75-1.5c0.84-0.21,1.17-0.42,1.5-0.5
					C54.99,47.73,59.08,47.03,63.06,46.17z"
            />

            <path
              class="st4"
              d="M45.06,101.17c-0.99,0.06-0.25,1.64-0.5,2.5c-1.25,4.24-0.91,3.96-1.5,7c-0.06,0.3-1.82,4.08-2,5.75
					c-0.2,1.76,1.06,1.01,1,1.75c-0.05,0.66,0.04,1.34,0,2c-1.35,2.52-1.05,5.3-1,8c0.05,2.46,0.26,4.81,0.5,7.25
					c0.06,0.42,0.99,0.2,1,0.25c0.53,2.97,1.13,5.96,1,9c-1.32,0.02-1.61,1.29-3.5-0.5c0.41-1.83-0.1-5.83,0-8
					c0.09-1.99-0.04-4.01,0-6c0.09-4.56-0.55-9.03-0.5-13.5c0.06-4.97,0.47-9.99,0.5-15c1.47-0.66,2.7,1.38,4-1
					C45.24,100.48,45,101.17,45.06,101.17z"
            />

            <path
              class="st37"
              d="M48.56,84.17c1,3,1,3,2,6c-8.17,2.07-5.3,2.34-6.5,3c-1.25,0.69-2.69,0.5-4,1c0.01-2.67-0.02-5.33,0-8
					c1.16-0.29,3.31-1.46,3.5-1.5C44.27,84.5,46.68,84.52,48.56,84.17z"
            />

            <path
              class="st4"
              d="M44.56,93.67c-0.23,2.15,0.54,5.09-0.5,7c-1.3,2.38-2.53,0.34-4,1c0.02-2.5-0.01-5,0-7.5
					c1.31-0.5,2.75-0.31,4-1C44,93.6,44.18,93.62,44.56,93.67z"
            />

            <path
              class="st9"
              d="M93.06,139.67c-4.72,0.66-9.49,1.25-14.25,1.5c-3.67,2.13-7.9,1.12-11.5,1.5c-0.51,0.05-2.83,1.48-3,1.5
					c-4.52,0.43-9.09-0.66-13.5-0.5c-0.27,0.01-1.17,1-1.25,1c-1.99,0.1-4.01-0.03-6,0c0.13-3.04-0.47-6.03-1-9
					c0.62-0.1,1.63,0.15,2,0c-0.3,1.79,0.93,1.91,1,2c0.14,0.18-0.26,1.3,0.25,1.5c0.82,0.33,11.06-0.79,13.25-1
					c8.17-0.77,16.39-2.29,24.5-3.5C84.53,140.05,89.57,134.34,93.06,139.67z"
            />

            <path
              class="st38"
              d="M104.56,111.67c-0.12,6.76,0.9,13.67,0.5,20.5c-0.54-0.39-0.74-1.37-1-2c-0.31-0.77,0.69-1.6-0.75-2
					c-0.64-0.18-11.09,2.69-13,3c-10.36,1.66-20.85,3.1-31.25,4.5c-4.47,0.6-9.19,0.44-13.5,2c-0.07-0.09-1.3-0.21-1-2
					c0.54-0.22,0.78-1.43,2-2c4.86-2.25,11.28-2.49,16.5-3.5c12-2.32,25.96-2.68,37-8.5c0.74-0.39,4.58-2.2,4.5-2.75
					c-1.62-0.38-1.62-0.38-3.25-0.75c-14.73,3.71-35.94,4.51-49.25,7c-1.18-1.67-2.35-3.39-2-5.5
					C68.24,117.19,86.31,113.78,104.56,111.67z"
            />

            <path
              class="st127"
              d="M105.06,52.67c-10.84,1.78-21.69,3.53-32.5,5.5c-4.54,0.83-4.52-0.04-4.75,0c-0.34,0.06,0.89,0.58-6.25,2
					c-3.96-2.98,2.42-2.87,2.75-3c5.8-2.28,11.73-3.97,17.75-5.5c3.95-1,13.3-1.91,15-4.5c23.35-7.66-15.22,0.39-29,3
					c-2.5-2-2.5-2-5-4c6.99-1.53,14-2.97,21-4.5c7.36-1.61,15.1-2.08,22-5.5C107.34,41.1,105.08,51.14,105.06,52.67z"
            />

            <path
              class="st40"
              d="M104.56,91.17c-8.9,1.08-17.67,3.01-26.5,4.5c-7.31,1.23-14.68,2.28-22,3.5c-2.84,0.47-5.63,1.19-8.5,1.5
					c-3.09-3.17,21.77-8.13,22.75-9c0.73-0.64-0.54-1.29-0.25-2c8.09-1.5,16.16-3.48,24.25-5c0.59-0.11,6.16,1.08,10.75-3
					c0.25,0,0.25,0,0.5,0C105.47,92.58,104.56,90.67,104.56,91.17z"
            />

            <path
              class="st38"
              d="M105.56,61.17c-0.44-0.03-0.5,0.45-1,0.5c-11.57,1.27-30.5,4.72-42.5,7c-0.25-2.75-0.25-2.75-0.5-5.5
					c3.49-0.6,6.99-1.38,10.5-2c11.04-1.94,22.42-3.39,33-7C105.02,56.32,105.57,58.86,105.56,61.17z"
            />

            <path
              class="st35"
              d="M105.06,71.67c-7.53,1.18-15,2.7-22.5,4c-6.83,1.19-13.67,2.33-20.5,3.5c3-3.25,3-3.25,6-6.5
					c5.4-1,20.99-3.4,24.75-5c1.02-0.43,1.48-0.79,1.25-2c3.13-0.61,11.26-1.71,10.5-4c0.5-0.05,0.56-0.53,1-0.5
					C105.53,64.66,105.08,68.25,105.06,71.67z"
            />

            <path
              class="st128"
              d="M105.06,109.17c-0.03,2.03-0.5,2.34-0.5,2.5c-18.24,2.11-36.31,5.52-54.5,8c-1.92,0.26-4.06,0.4-6,0.5
					c0.5-1.25,0.5-1.25,1-2.5c0.83-0.17,1.67-0.33,2.5-0.5c7.54-1.54,14.92-2.37,22.5-3.5C81.63,111.94,93.53,109.46,105.06,109.17z
					"
            />

            <path
              class="st38"
              d="M105.06,93.17c-0.03,2.49,0.03,4.97,0,7.5c-0.33,0.01-0.67-0.02-1,0c-5.16,0.27-15.16,2.21-21.5,3
					c-1.25-3-1.25-3-2.5-6C88.39,96.22,96.91,95.68,105.06,93.17z"
            />

            <path
              class="st127"
              d="M105.06,100.67c-0.04,2.8,0.05,5.67,0,8.5c-11.53,0.3-23.43,2.77-35,4.5c0.34-4.21,2.86-1.84,5.25-2.5
					c2.29-0.63,15.84-3.96,16.5-4.5c0.74-0.6-0.55-1.32-0.25-2c5.63-0.9,12.09-0.62,12.5-4
					C104.39,100.65,104.72,100.67,105.06,100.67z"
            />

            <path
              class="st38"
              d="M105.06,132.17c-0.16,2.76,0.57,5.55-0.75,6.5c-3.81-0.24-7.5,0.47-11.25,1c-3.49-5.33-8.53,0.38-9.5-5
					c6.44-0.96,19.67-1.92,20.5-4.5C104.31,130.8,104.52,131.78,105.06,132.17z"
            />

            <path
              class="st38"
              d="M105.06,74.17c-0.02,2.36,0.52,5.01,0.5,7.5c-0.25,0-0.25,0-0.5,0c-5.08,0.02-10.02,1.23-15,2
					c3.57-2.97-2.13-2.8-1.5-6.5C94.06,76.21,99.7,75.99,105.06,74.17z"
            />

            <path
              class="st45"
              d="M105.06,52.67c-0.01,0.5,0.01,1,0,1.5c-10.58,3.61-21.96,5.06-33,7c0.25-1.5,0.25-1.5,0.5-3
					C83.36,56.19,94.22,54.45,105.06,52.67z"
            />

            <path
              class="st84"
              d="M104.56,91.17c0,0.3,0.52,0.43,0.5,2c-8.15,2.51-16.66,3.05-25,4.5c-1.02,0.18-1.18,0.44-1.5,0.5
					c-0.25-1.25-0.25-1.25-0.5-2.5C86.88,94.18,95.65,92.24,104.56,91.17z"
            />

            <path
              class="st3"
              d="M83.06,49.67c-0.5,1-0.5,1-1,2c-6.02,1.53-11.95,3.22-17.75,5.5c-0.33,0.13-6.71,0.02-2.75,3
					c-6.04,1.21-12.08,2.22-18,4c0.63-1.51,2.09-0.84,2-1.25c-0.28-1.26-1.75,3.29-2-6.25C56.68,54.21,69.97,52.27,83.06,49.67z"
            />

            <path
              class="st2"
              d="M104.56,61.67c0.76,2.29-7.37,3.39-10.5,4c-15.13,2.94-30.49,4.86-45.5,8.5c-2.5-0.25-2.5-0.25-5-0.5
					c0.05-1.73,0.47-0.99,0.5-1.5c6.07-0.75,12-2.36,18-3.5C74.06,66.39,92.98,62.94,104.56,61.67z"
            />

            <path
              class="st2"
              d="M97.06,47.17c-4.74,0.41-9.35,1.58-14,2.5c-13.09,2.6-26.38,4.54-39.5,7c0-0.1-1.26-0.17-1-1.75
					c8.25-2.48,17.02-3.14,25.5-4.75C81.83,47.55,120.4,39.5,97.06,47.17z"
            />

            <path
              class="st9"
              d="M68.06,72.67c-3,3.25-3,3.25-6,6.5c-6.15,1.05-12.32,2.13-18.5,3c-0.05-2.98-0.08-5.51,0-8.5
					c2.5,0.25,2.5,0.25,5,0.5C47.85,78.03,59.45,74.25,68.06,72.67z"
            />

            <path
              class="st9"
              d="M61.56,63.17c0.25,2.75,0.25,2.75,0.5,5.5c-6,1.14-11.93,2.75-18,3.5c0.03-0.44-1.26-0.32,0-6.5
					C49.9,65.03,55.76,64.16,61.56,63.17z"
            />

            <g>
              <path
                class="st141"
                d="M105.06,71.67c-0.01,0.83,0.01,1.67,0,2.5c-5.36,1.82-10.99,2.05-16.5,3c-1.65,0.29-3.33,0.72-5,1
						c-0.5-1.25-0.5-1.25-1-2.5C90.06,74.36,97.53,72.84,105.06,71.67z"
              />

              <path
                class="st128"
                d="M82.56,75.67c0.5,1.25,0.5,1.25,1,2.5c-11.67,1.97-23.36,3.82-35,6c-1.87,0.35-4.29,0.34-5,0.5
						c-1.32-0.53,0.01-2.19,0-2.5c6.18-0.87,12.35-1.95,18.5-3C68.89,78,75.73,76.85,82.56,75.67z"
              />
            </g>

            <path
              class="st130"
              d="M72.56,58.17c-0.25,1.5-0.25,1.5-0.5,3c-3.51,0.62-7.01,1.4-10.5,2c-5.79,0.99-11.66,1.86-17.5,2.5
					c0.08-0.38-0.82-0.75-0.5-1.5c5.92-1.78,11.96-2.79,18-4c7.14-1.42,5.91-1.94,6.25-2C68.04,58.12,68.01,59,72.56,58.17z"
            />

            <path
              class="st3"
              d="M70.06,89.67c-0.29,0.71,0.98,1.36,0.25,2c-0.98,0.87-25.84,5.83-22.75,9c-1.94,0.21-2.37,0.5-2.5,0.5
					c-0.06,0,0.19-0.69-1-0.5c1.04-1.91,0.27-4.85,0.5-7C47.74,94.04,65.15,90.58,70.06,89.67z"
            />

            <path
              class="st9"
              d="M50.06,119.67c-0.35,2.11,0.82,3.83,2,5.5c-2.06,0.38-4.1,1.17-6.25,1c-0.48,0.15-0.16,1.46-0.25,1.5
					c-1.55,0.61-2.82,0.98-4.5,0.5c-0.05-2.7-0.35-5.48,1-8c0.95,0.7,0.86,0.06,2,0C46,120.06,48.14,119.93,50.06,119.67z"
            />

            <path
              class="st3"
              d="M47.06,110.67c0,0.33,0.92,2.87,0.5,6.5c-0.83,0.17-1.67,0.33-2.5,0.5c-0.97,0.2-2.01,0.41-3,0.5
					c0.06-0.74-1.2,0.01-1-1.75c0.18-1.67,1.94-5.45,2-5.75C44.38,110.59,45.74,110.78,47.06,110.67z"
            />

            <path
              class="st2"
              d="M49.56,103.17c0.75,2,0.75,2,1.5,4c-1.22,0.25-2.49,0.57-3.75,0.5c-0.46,0.43-0.25,2.25-0.25,3
					c-1.31,0.12-2.68-0.08-4,0c0.59-3.04,0.25-2.76,1.5-7C46.32,103.98,47.88,103.42,49.56,103.17z"
            />

            <path
              class="st3"
              d="M45.56,127.67c0.72-0.03,0.48,0.72,0.5,1.5c0.06,2.4-0.33,4.54,0.5,4.5c-1.22,0.57-1.46,1.78-2,2
					c-0.37,0.15-1.38-0.1-2,0c-0.01-0.05-0.94,0.17-1-0.25c-0.24-2.44-0.45-4.79-0.5-7.25C42.73,128.65,44,128.28,45.56,127.67z"
            />

            <path
              class="st95"
              d="M56.06,99.17c0.7,2.87,1.24,1.44,2.5,2.5c-3,0.52-5.99,1.05-9,1.5c-1.67,0.25-3.24,0.81-5,0.5
					c0.25-0.86-0.49-2.44,0.5-2.5c0.13,0,0.56-0.29,2.5-0.5C50.43,100.36,53.21,99.64,56.06,99.17z"
            />

            <path
              class="st135"
              d="M45.06,117.67c-0.5,1.25-0.5,1.25-1,2.5c-1.14,0.06-1.05,0.7-2,0c0.04-0.66-0.05-1.34,0-2
					C43.05,118.08,44.09,117.87,45.06,117.67z"
            />

            <path
              class="st40"
              d="M90.06,83.67c-9.82,1.52-32.3,4.68-39.5,6.5c-1-3-1-3-2-6c11.64-2.18,23.33-4.03,35-6
					c1.67-0.28,3.35-0.71,5-1C87.92,80.87,93.62,80.7,90.06,83.67z"
            />

            <path
              class="st2"
              d="M105.06,81.67c-4.59,4.08-10.16,2.89-10.75,3c-8.09,1.52-16.16,3.5-24.25,5c-4.91,0.91-22.32,4.37-25.5,4
					c-0.38-0.04-0.55-0.07-0.5-0.5c1.2-0.66-1.67-0.93,6.5-3c7.2-1.82,29.68-4.98,39.5-6.5C95.04,82.89,99.97,81.68,105.06,81.67z"
            />

            <path
              class="st45"
              d="M104.06,130.17c-0.83,2.58-14.06,3.54-20.5,4.5c-8.11,1.21-16.33,2.73-24.5,3.5c0-1.25,0-1.25,0-2.5
					c10.4-1.4,20.89-2.84,31.25-4.5c1.91-0.31,12.36-3.18,13-3C104.75,128.57,103.74,129.39,104.06,130.17z"
            />

            <path
              class="st130"
              d="M59.06,135.67c0,1.25,0,1.25,0,2.5c-2.19,0.21-12.43,1.33-13.25,1c-0.51-0.2-0.11-1.32-0.25-1.5
					C49.87,136.1,54.58,136.27,59.06,135.67z"
            />

            <path
              class="st2"
              d="M100.06,121.67c-8.73,0.65-18.09,2.59-27,4c-8.94,1.41-18.01,3.27-27,3.5c-0.02-0.78,0.22-1.53-0.5-1.5
					c0.09-0.04-0.23-1.35,0.25-1.5c2.15,0.17,4.19-0.62,6.25-1c13.31-2.49,34.52-3.29,49.25-7c1.62,0.38,1.62,0.38,3.25,0.75
					C104.63,119.46,100.79,121.28,100.06,121.67z"
            />

            <path
              class="st9"
              d="M100.06,121.67c-11.04,5.82-25,6.18-37,8.5c1.11-2.78,12.01-1.17,10-4.5
					C81.96,124.26,91.33,122.32,100.06,121.67z"
            />

            <path
              class="st2"
              d="M73.06,125.67c2.01,3.33-8.89,1.72-10,4.5c-5.22,1.01-11.64,1.25-16.5,3.5c-0.83,0.04-0.44-2.1-0.5-4.5
					C55.05,128.94,64.11,127.08,73.06,125.67z"
            />

            <path
              class="st9"
              d="M97.06,47.17c-1.7,2.59-11.05,3.5-15,4.5c0.5-1,0.5-1,1-2C87.7,48.74,92.32,47.57,97.06,47.17z"
            />

            <path
              class="st45"
              d="M78.06,95.67c0.25,1.25,0.25,1.25,0.5,2.5c-6.67,1.16-13.33,2.34-20,3.5c-1.26-1.06-1.8,0.37-2.5-2.5
					C63.38,97.95,70.74,96.9,78.06,95.67z"
            />

            <path
              class="st3"
              d="M94.06,65.67c0.23,1.21-0.23,1.57-1.25,2c-3.76,1.6-19.35,4-24.75,5c-8.6,1.59-20.2,5.36-19.5,1.5
					C63.57,70.52,78.93,68.61,94.06,65.67z"
            />

            <path
              class="st3"
              d="M91.56,104.67c-0.3,0.68,0.99,1.4,0.25,2c-0.66,0.54-14.21,3.87-16.5,4.5c-2.39,0.66-4.91-1.71-5.25,2.5
					c-7.58,1.13-14.96,1.96-22.5,3.5c0.42-3.63-0.5-6.17-0.5-6.5C59.92,109.54,78.48,106.76,91.56,104.67z"
            />

            <path
              class="st35"
              d="M80.06,97.67c1.25,3,1.25,3,2.5,6c-8.87,1.11-26.07,2.37-31.5,3.5c-0.75-2-0.75-2-1.5-4
					c3.01-0.45,6-0.98,9-1.5c6.67-1.16,13.33-2.34,20-3.5C78.87,98.11,79.04,97.84,80.06,97.67z"
            />

            <path
              class="st2"
              d="M104.06,100.67c-0.41,3.38-6.87,3.1-12.5,4c-13.08,2.09-31.63,4.87-44.5,6c0-0.75-0.21-2.57,0.25-3
					c1.26,0.07,2.53-0.25,3.75-0.5c5.43-1.13,22.63-2.39,31.5-3.5C88.89,102.88,98.9,100.94,104.06,100.67z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style>
.st0 {
  display: none;
}

.st1 {
  display: inline;
  fill: #f9f9f8;
}

.st2 {
  fill: #110b0d;
}

.st3 {
  fill: #2a2628;
}

.st4 {
  fill: #3c3a3b;
}

.st5 {
  fill: #4c4a4d;
}

.st6 {
  fill: #8c501e;
}

.st7 {
  fill: #a2641b;
}

.st8 {
  fill: #805c39;
}

.st9 {
  fill: #1d2727;
}

.st10 {
  fill: #9d722e;
}

.st11 {
  fill: #8b151e;
}

.st12 {
  fill: #7f3a13;
}

.st13 {
  fill: #b35e14;
}

.st14 {
  fill: #562412;
}

.st15 {
  fill: #412313;
}

.st16 {
  fill: #4b3619;
}

.st17 {
  fill: #ca7020;
}

.st18 {
  fill: #dda549;
}

.st19 {
  fill: #b27529;
}

.st20 {
  fill: #ca7f0b;
}

.st21 {
  fill: #da9610;
}

.st22 {
  fill: #2f1e12;
}

.st23 {
  fill: #640d14;
}

.st24 {
  fill: #c73a34;
}

.st25 {
  fill: #490a16;
}

.st26 {
  fill: #ab282c;
}

.st27 {
  fill: #f9f9f8;
}

.st28 {
  fill: #e94c3f;
}

.st29 {
  fill: #ec735e;
}

.st30 {
  fill: #f7ac8e;
}

.st31 {
  fill: #ea5a5e;
}

.st32 {
  fill: #cf4850;
}

.st33 {
  fill: #1a6462;
}

.st34 {
  fill: #433630;
}

.st35 {
  fill: #1d3330;
}

.st36 {
  fill: #2d9f9e;
}

.st37 {
  fill: #1a1a1b;
}

.st38 {
  fill: #205653;
}

.st39 {
  fill: #1e7b7a;
}

.st40 {
  fill: #184343;
}

.st41 {
  fill: #2fa595;
}

.st42 {
  fill: #20786b;
}

.st43 {
  fill: #38c3b6;
}

.st44 {
  fill: #76c4bd;
}

.st45 {
  fill: #bfe1df;
}

.st46 {
  fill: #173c45;
}

.st47 {
  fill: #5fded8;
}

.st48 {
  fill: #2c2916;
}

.st49 {
  fill: #c09e3d;
}

.st50 {
  fill: #cd9442;
}

.st51 {
  fill: #ebbc5e;
}

.st52 {
  fill: #fcf6e9;
}

.st53 {
  fill: #fed778;
}

.st54 {
  fill: #f8ba6e;
}

.st55 {
  fill: #fde596;
}

.st56 {
  fill: #f8e9ce;
}

.st57 {
  fill: #816124;
}

.st58 {
  fill: #744927;
}

.st59 {
  fill: #af8341;
}

.st60 {
  fill: #3c1716;
}

.st61 {
  fill: #dfceb4;
}

.st62 {
  fill: #dbb889;
}

.st63 {
  fill: #ede3b6;
}

.st64 {
  fill: #fbe6d7;
}

.st65 {
  fill: #f9c19c;
}

.st66 {
  fill: #e0a799;
}

.st67 {
  fill: #a59994;
}

.st68 {
  fill: #9a6c62;
}

.st69 {
  fill: #854436;
}

.st70 {
  fill: #1a0001;
}

.st71 {
  fill: #b23f08;
}

.st72 {
  fill: #f7a826;
}

.st73 {
  fill: #f9d953;
}

.st74 {
  fill: #efb719;
}

.st75 {
  fill: #2f2222;
}

.st76 {
  fill: #967964;
}

.st77 {
  fill: #2a887e;
}

.st78 {
  fill: #174c3d;
}

.st79 {
  fill: #954312;
}

.st80 {
  fill: #693513;
}

.st81 {
  fill: #23261e;
}

.st82 {
  fill: #f08617;
}

.st83 {
  fill: #1e1904;
}

.st84 {
  fill: #d5dde1;
}

.st85 {
  fill: #c0c6c8;
}

.st86 {
  fill: #acadaf;
}

.st87 {
  fill: #797e81;
}

.st88 {
  fill: #5c5a5b;
}

.st89 {
  fill: #d5cc6f;
}

.st90 {
  fill: #878d95;
}

.st91 {
  fill: #9aa39e;
}

.st92 {
  fill: #51534c;
}

.st93 {
  fill: #676e63;
}

.st94 {
  fill: #757277;
}

.st95 {
  fill: #68a9ae;
}

.st96 {
  fill: #666e77;
}

.st97 {
  fill: #7a6e57;
}

.st98 {
  fill: #372813;
}

.st99 {
  fill: #5c4617;
}

.st100 {
  fill: #3c3717;
}

.st101 {
  fill: #70551e;
}

.st102 {
  fill: #8a7341;
}

.st103 {
  fill: #645d2f;
}

.st104 {
  fill: #171f10;
}

.st105 {
  fill: #0b1915;
}

.st106 {
  fill: #504a21;
}

.st107 {
  fill: #132919;
}

.st108 {
  fill: #e7cf88;
}

.st109 {
  fill: #1f1a14;
}

.st110 {
  fill: #443b26;
}

.st111 {
  fill: #65693c;
}

.st112 {
  fill: #9f7d2e;
}

.st113 {
  fill: #121208;
}

.st114 {
  fill: #2c3422;
}

.st115 {
  fill: #49603f;
}

.st116 {
  fill: #796638;
}

.st117 {
  fill: #736828;
}

.st118 {
  fill: #2f422b;
}

.st119 {
  fill: #4c582d;
}

.st120 {
  fill: #a9a064;
}

.st121 {
  fill: #948541;
}

.st122 {
  fill: #b28b31;
}

.st123 {
  fill: #645404;
}

.st124 {
  fill: #e2db9a;
}

.st125 {
  fill: #4b4641;
}

.st126 {
  fill: #2a555b;
}

.st127 {
  fill: #324145;
}

.st128 {
  fill: #97ceda;
}

.st129 {
  fill: #749ba5;
}

.st130 {
  fill: #71bdc7;
}

.st131 {
  fill: #527776;
}

.st132 {
  fill: #b7dee8;
}

.st133 {
  fill: #c5d1ce;
}

.st134 {
  fill: #95dfe2;
}

.st135 {
  fill: #508d92;
}

.st136 {
  fill: #56482c;
}

.st137 {
  fill: #3e412d;
}

.st138 {
  fill: #1b290e;
}

.st139 {
  fill: #3f4522;
}

.st140 {
  fill: #313430;
}

.st141 {
  fill: #d4e9f4;
}
</style>
